import { VaultFactoryDto } from '@dto/vaults/vault-factory.dto';

export const vaultFactories = [
  {
    id: 35,
    factory: '0xe31fceaf93667365ce1e9edad3bed4a7dd0fc01a',
    chainId: 42161,
    name: 'arb',
    enabled: true,
    migrator: '0x8587524388e2e49fe457410f745462dc3e4420e1',
    zapper: '0xe241722dbddd75efecc23d8a04b93f96786c960e',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.055',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0x8efba3027a71bd4d5fa66788faf7aae3dca4f5c7',
      '0x950636b2cd571c220dde496ec0cbc83f3e628b71',
      '0xc7706b9dbc2a2999abc072dc5f65c2a9abc3c282',
      '0x980d80fd24c6c9637a603f9c174a4c5afaa8feb3',
      '0x8c171913e3f22830a0b521ae5f38f94e066a53b2',
      '0xe116f367a11bd5a65c85f7974a8cd412274f1116',
      '0x4a432874bce1ec2a8b6ec96acc650b9b74182712',
      '0x26c6f78cd631fe74e3288dde758bc972d02274b3',
    ],
    underlyingZapperTokensWl: ['0xaf88d065e77c8cc2239327c5edb3a432268e5831'],
    farms: [
      {
        id: 45,
        createdAt: '2023-10-12T11:15:43.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T11:15:43.000Z',
        beacon: '0xa3d6f74f3ba269b1aaf46422dd7d68f566695b5b',
        calculationConnector: '',
        source: '',
        origin: '0x8101f742d2ce08a1d7d863255d41480f8782f44d',
        vaultFactoryId: 35,
        rewardTokens: ['0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec'],
        rewardTokenType: '',
        stakingToken: '0xda064d44871ba31dae33a65b3e23b37e44e9168a',
        stakingTokenType: 'ERC20',
        stakeTokenSymbol: 'GDEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '955598.69',
        tvlUsd: '955598.69',
        enabled: false,
        dexFactory: {
          id: 40,
          chainId: 42161,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 46,
        createdAt: '2023-10-12T11:20:28.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T11:20:28.000Z',
        beacon: '0x5b5ed5b4e190989c3e2a99b7da0150242a73d131',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: [
          '0xd4d42f0b6def4ce0383636770ef773390d85c61a',
          '0x539bde0d7dbd336b79148aa742883198bbf60342',
        ],
        rewardTokenType: '',
        stakingToken: '0xb7e50106a5bd3cf21af210a755f9c8740890a8c9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MAGIC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '6261907.06',
        tvlUsd: '6261907.06',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 47,
        createdAt: '2023-10-12T11:53:53.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T11:53:53.000Z',
        beacon: '0x208c868c016a61d78353ef21e25bb794fab4360f',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0x905dfcd5649217c42684f23958568e533c711aa3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '712158.63',
        tvlUsd: '712158.63',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 48,
        createdAt: '2023-10-12T11:55:41.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T11:55:41.000Z',
        beacon: '0x66b10283569676e2b39a2a59c5432eb60840d48c',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x32eb7902d4134bf98a28b963d26de779af92a212',
          '0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55',
        ],
        rewardTokenType: '',
        stakingToken: '0x7418f5a2621e13c05d1efbd71ec922070794b90a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'RDPX/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '17.19',
        tvlUsd: '17.19',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 49,
        createdAt: '2023-10-12T11:57:12.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T11:57:12.000Z',
        beacon: '0x24fde36549edc78a6f86b99cf989f33f1c7dba59',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55'],
        rewardTokenType: '',
        stakingToken: '0x0c1cf6883efa1b496b01f654e247b9b419873054',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DPX/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '115282.76',
        tvlUsd: '115282.76',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 50,
        createdAt: '2023-10-12T12:00:26.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T12:00:26.000Z',
        beacon: '0xff5bac3209733c58b7970c93ead70ffd1d0b0b6d',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0xcb0e5bfa72bbb4d16ab5aa0c60601c438f04b4ad',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '379289.69',
        tvlUsd: '379289.69',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 51,
        createdAt: '2023-10-12T12:01:54.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T12:01:54.000Z',
        beacon: '0xa4e170a56646cfc731b36592c58a60bb2bf0027b',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0xbf6cbb1f40a542af50839cad01b0dc1747f11e18',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/ARB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '74955.89',
        tvlUsd: '74955.89',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 52,
        createdAt: '2023-10-12T12:04:57.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T12:04:57.000Z',
        beacon: '0x882ad8c88561850332cf4629081b581a1898b45c',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0x42e9dc3f1a7dd582e81d2edf7e5c4869007ce14a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'PREMIA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '421.21',
        tvlUsd: '421.21',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 53,
        createdAt: '2023-10-12T21:23:44.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-12T21:23:44.000Z',
        beacon: '0x35b1a3e9a4ee493af3fa988fcf61ac0961e34e12',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: [
          '0xd4d42f0b6def4ce0383636770ef773390d85c61a',
          '0x539bde0d7dbd336b79148aa742883198bbf60342',
        ],
        rewardTokenType: '',
        stakingToken: '0xb7e50106a5bd3cf21af210a755f9c8740890a8c9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MAGIC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '6261907.06',
        tvlUsd: '6261907.06',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 60,
        createdAt: '2023-10-16T20:26:06.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-16T20:26:06.000Z',
        beacon: '0xb49819a8e32d99af659ef5805e5589e40f096bf0',
        calculationConnector: '',
        source: '',
        origin: '0x8101f742d2ce08a1d7d863255d41480f8782f44d',
        vaultFactoryId: 35,
        rewardTokens: ['0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec'],
        rewardTokenType: '',
        stakingToken: '0xda064d44871ba31dae33a65b3e23b37e44e9168a',
        stakingTokenType: 'ERC20',
        stakeTokenSymbol: 'GDEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '955598.69',
        tvlUsd: '955598.69',
        enabled: false,
        dexFactory: {
          id: 40,
          chainId: 42161,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 61,
        createdAt: '2023-10-16T21:05:51.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-16T21:05:51.000Z',
        beacon: '0x8e7ff388b5fa6e4edbe80c43440cad675a35ac8a',
        calculationConnector: '',
        source: '',
        origin: '0x8101f742d2ce08a1d7d863255d41480f8782f44d',
        vaultFactoryId: 35,
        rewardTokens: ['0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec'],
        rewardTokenType: '',
        stakingToken: '0xda064d44871ba31dae33a65b3e23b37e44e9168a',
        stakingTokenType: 'ERC20',
        stakeTokenSymbol: 'GDEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '955598.69',
        tvlUsd: '955598.69',
        enabled: false,
        dexFactory: {
          id: 40,
          chainId: 42161,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 62,
        createdAt: '2023-10-16T22:13:19.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-16T22:13:19.000Z',
        beacon: '0x8488d5bc28631ef4bd1308633637693e631aece6',
        calculationConnector: '',
        source: '',
        origin: '0x8101f742d2ce08a1d7d863255d41480f8782f44d',
        vaultFactoryId: 35,
        rewardTokens: ['0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec'],
        rewardTokenType: '',
        stakingToken: '0xda064d44871ba31dae33a65b3e23b37e44e9168a',
        stakingTokenType: 'ERC20',
        stakeTokenSymbol: 'GDEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '955598.69',
        tvlUsd: '955598.69',
        enabled: false,
        dexFactory: {
          id: 40,
          chainId: 42161,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 64,
        createdAt: '2023-10-17T21:13:07.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-17T21:13:07.000Z',
        beacon: '0x596c58d41154f2037abb3a155704b7c001516c60',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55'],
        rewardTokenType: '',
        stakingToken: '0x7418f5a2621e13c05d1efbd71ec922070794b90a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'RDPX/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '17.19',
        tvlUsd: '17.19',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 65,
        createdAt: '2023-10-18T15:59:40.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-18T15:59:40.000Z',
        beacon: '0x053c6960471f96a4ed9028aa069ff1a88f8ec364',
        calculationConnector: '',
        source: '',
        origin: '0x8101f742d2ce08a1d7d863255d41480f8782f44d',
        vaultFactoryId: 35,
        rewardTokens: ['0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec'],
        rewardTokenType: '',
        stakingToken: '0xda064d44871ba31dae33a65b3e23b37e44e9168a',
        stakingTokenType: 'ERC20',
        stakeTokenSymbol: 'GDEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '955598.69',
        tvlUsd: '955598.69',
        enabled: false,
        dexFactory: {
          id: 40,
          chainId: 42161,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 66,
        createdAt: '2023-10-22T15:10:59.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-22T15:10:59.000Z',
        beacon: '0xa679aaf29fe60c1337c92306877625909d11d1fd',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0x85cebd962861be410a777755dfa06914de6af003',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'LP-USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0131,
        tvlStaking: '51479.76',
        tvlUsd: '51479.76',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 67,
        createdAt: '2023-10-22T15:45:04.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-22T15:45:04.000Z',
        beacon: '0x1a043770b23e4374b8255d93a9a7b7c0a0cb3a00',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0x85cebd962861be410a777755dfa06914de6af003',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'LP-USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0131,
        tvlStaking: '51479.76',
        tvlUsd: '51479.76',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 68,
        createdAt: '2023-10-27T20:04:38.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-27T20:04:38.000Z',
        beacon: '0x11865f61b699ed9308f977b84939cedb0c085c1a',
        calculationConnector: '',
        source: '',
        origin: '0xde1e437e0be59b596e69ff58e2bda9209a72ce8b',
        vaultFactoryId: 35,
        rewardTokens: ['0x4117ec0a779448872d3820f37ba2060ae0b7c34b'],
        rewardTokenType: '',
        stakingToken: '0x92a212d9f5eef0b262ac7d84aea64a0d0758b94f',
        stakingTokenType: 'ERC20',
        stakeTokenSymbol: 'GDEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.9235,
        tvlStaking: '54026.87',
        tvlUsd: '54026.87',
        enabled: true,
        dexFactory: {
          id: 40,
          chainId: 42161,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 70,
        createdAt: '2023-10-30T22:09:26.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-30T22:09:26.000Z',
        beacon: '0x94611fb6046fc6ccbcebe59e45edfbe7eb82105e',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0x905dfcd5649217c42684f23958568e533c711aa3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '712158.63',
        tvlUsd: '712158.63',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 71,
        createdAt: '2023-10-31T09:24:49.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-31T09:24:49.000Z',
        beacon: '0xef60f10f7550500b7ced6b6f9c9e1f15beece88c',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x539bde0d7dbd336b79148aa742883198bbf60342',
          '0xd4d42f0b6def4ce0383636770ef773390d85c61a',
        ],
        rewardTokenType: '',
        stakingToken: '0xb7e50106a5bd3cf21af210a755f9c8740890a8c9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MAGIC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '6261907.06',
        tvlUsd: '6261907.06',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 73,
        createdAt: '2023-10-31T12:30:27.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-31T12:30:27.000Z',
        beacon: '0x7589f9d3825af9af14e75987d7ab09f9456ce75b',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0x905dfcd5649217c42684f23958568e533c711aa3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '712158.63',
        tvlUsd: '712158.63',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 74,
        createdAt: '2023-10-31T12:44:42.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-31T12:44:42.000Z',
        beacon: '0x788a617c07f3570f7666839aaf2a123747610f22',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0x905dfcd5649217c42684f23958568e533c711aa3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '712158.63',
        tvlUsd: '712158.63',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 75,
        createdAt: '2023-10-31T13:28:27.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-31T13:28:27.000Z',
        beacon: '0xba8fcb1d40da5c4ff250eaed0492316a458d01bb',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0x905dfcd5649217c42684f23958568e533c711aa3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '576361.66',
        tvlUsd: '576361.66',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 77,
        createdAt: '2023-10-31T14:51:41.000Z',
        chainId: 42161,
        dateOfAdd: '2023-10-31T14:51:41.000Z',
        beacon: '0x023e1067f0f409ebcb7b9e789f42f3e5aee4bf46',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x539bde0d7dbd336b79148aa742883198bbf60342',
          '0xd4d42f0b6def4ce0383636770ef773390d85c61a',
        ],
        rewardTokenType: '',
        stakingToken: '0xb7e50106a5bd3cf21af210a755f9c8740890a8c9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MAGIC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '911098.42',
        tvlUsd: '911098.42',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 78,
        createdAt: '2023-11-01T09:07:56.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T09:07:56.000Z',
        beacon: '0x026763e6301b9d5a696c97ca52fb830670cf6c0f',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0x2977b0b54a76c2b56d32cef19f8ea83cc766cfd9',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '121117.22',
        tvlUsd: '121117.22',
        enabled: true,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 80,
        createdAt: '2023-11-01T11:48:19.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T11:48:19.000Z',
        beacon: '0x716484608fdc54bc97fb1e8f77bc1fc94f5d6c88',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55',
          '0xd4d42f0b6def4ce0383636770ef773390d85c61a',
        ],
        rewardTokenType: '',
        stakingToken: '0x7418f5a2621e13c05d1efbd71ec922070794b90a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'RDPX/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '17.19',
        tvlUsd: '17.19',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 81,
        createdAt: '2023-11-01T13:09:28.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T13:09:28.000Z',
        beacon: '0xb21acd6a0b19bd0363483beac7aad0515a03c55d',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55',
          '0xd4d42f0b6def4ce0383636770ef773390d85c61a',
        ],
        rewardTokenType: '',
        stakingToken: '0x0c1cf6883efa1b496b01f654e247b9b419873054',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DPX/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '56152.66',
        tvlUsd: '56152.66',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 82,
        createdAt: '2023-11-01T13:16:14.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T13:16:14.000Z',
        beacon: '0x4a6007ee38f2d251ccd37481ef48045ecf50897f',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0xcb0e5bfa72bbb4d16ab5aa0c60601c438f04b4ad',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '261145.98',
        tvlUsd: '261145.98',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 87,
        createdAt: '2023-11-01T14:09:46.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T14:09:46.000Z',
        beacon: '0xabffa6c9a9199b0dc12529fe417a892a1f17de7e',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0xbf6cbb1f40a542af50839cad01b0dc1747f11e18',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/ARB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '30677.41',
        tvlUsd: '30677.41',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 88,
        createdAt: '2023-11-01T14:18:47.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T14:18:47.000Z',
        beacon: '0xe854dddb6c47669f60a0ac802346231275063772',
        calculationConnector: '',
        source: '',
        origin: '0xf4d73326c13a4fc5fd7a064217e12780e9bd62c3',
        vaultFactoryId: 35,
        rewardTokens: ['0xd4d42f0b6def4ce0383636770ef773390d85c61a'],
        rewardTokenType: '',
        stakingToken: '0x42e9dc3f1a7dd582e81d2edf7e5c4869007ce14a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'PREMIA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '215.26',
        tvlUsd: '215.26',
        enabled: false,
        dexFactory: {
          id: 41,
          chainId: 42161,
          address: '',
          name: 'SushiSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 93,
        createdAt: '2023-11-01T22:34:10.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T22:34:10.000Z',
        beacon: '0xb9f2c34ade14cd8fbe1db1c1924f66a70215c4ee',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0x85cebd962861be410a777755dfa06914de6af003',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '44940.81',
        tvlUsd: '44940.81',
        enabled: true,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 95,
        createdAt: '2023-11-01T23:29:43.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T23:29:43.000Z',
        beacon: '0xb8cab855166a066aa4b90ea11825f77667c43c9f',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0x6966553568634f4225330d559a8783de7649c7d3',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-FRXETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '11852.72',
        tvlUsd: '11852.72',
        enabled: true,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 96,
        createdAt: '2023-11-01T23:32:27.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T23:32:27.000Z',
        beacon: '0x0f86b30a45d0101ea2bfb6bcc0c6df36a8e123f2',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0xe62880cc6872c9e9fb1ddd73f400850fdabe798d',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0312,
        tvlStaking: '2552.95',
        tvlUsd: '2552.95',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 98,
        createdAt: '2023-11-01T23:50:31.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-01T23:50:31.000Z',
        beacon: '0xb2204b3ece8b345e1c05a6b0c1e2f48f4017f360',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0x51e073d92b0c226f7b0065909440b18a85769606',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-DAI+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 257.1448,
        tvlStaking: '18.99',
        tvlUsd: '18.99',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 108,
        createdAt: '2023-11-02T10:46:07.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-02T10:46:07.000Z',
        beacon: '0x3a843b500226046c6b8f35683db9539a6115bb70',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0xdddc78f940e012cfc1ad04de2ca089eb94900145',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-MWOM',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '180.21',
        tvlUsd: '180.21',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 113,
        createdAt: '2023-11-02T11:29:33.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-02T11:29:33.000Z',
        beacon: '0x936a4fa6eeb6930d23e0bfbe436e293b3319f781',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: [
          '0xf00d8790a76ee5a5dbc10eacac39151aa2af0331',
          '0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96',
        ],
        rewardTokenType: '',
        stakingToken: '0x6b7c9db425951543aa556b984869c50e6a18c7b2',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-WOM',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '596.78',
        tvlUsd: '596.78',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 115,
        createdAt: '2023-11-02T13:33:15.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-02T13:33:15.000Z',
        beacon: '0x9f6e06fcc44ca198eb2ffb247050d6da26f52e7a',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0xde509fe1555ab907e5c29f987ba0be1ac0626dae',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-JUSDC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0013,
        tvlStaking: '471.03',
        tvlUsd: '471.03',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 116,
        createdAt: '2023-11-02T13:36:52.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-02T13:36:52.000Z',
        beacon: '0xb9168f9d4ff9454f6b4d6cfaef0b5e4dd465a85e',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: ['0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96'],
        rewardTokenType: '',
        stakingToken: '0x4688300d46ef400c3506a165d5bdca6a51350978',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 4e-5,
        tvlStaking: '159.54',
        tvlUsd: '159.54',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 118,
        createdAt: '2023-11-02T17:48:25.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-02T17:48:25.000Z',
        beacon: '0xcfcae9d320c017d183052da89175a7d5fc63cec8',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96',
          '0x2ac2b254bc18cd4999f64773a966e4f4869c34ee',
        ],
        rewardTokenType: '',
        stakingToken: '0x5ad0b68c8544d475ee73ffd4c8dfe7e273b01266',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-MPENDLE',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0071,
        tvlStaking: '6323.52',
        tvlUsd: '6323.52',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 119,
        createdAt: '2023-11-02T20:28:25.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-02T20:28:25.000Z',
        beacon: '0xe049582e0fd0d1aeb0e36d014eb2ec3b1236ba93',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96',
          '0x2ac2b254bc18cd4999f64773a966e4f4869c34ee',
        ],
        rewardTokenType: '',
        stakingToken: '0xb4beb0fdf0163a39d39b175942e7973da2c336fb',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-PENDLE',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0207,
        tvlStaking: '3283.65',
        tvlUsd: '3283.65',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 120,
        createdAt: '2023-11-02T20:47:08.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-02T20:47:08.000Z',
        beacon: '0xcaea99145625d38eaaf9a577cda814f1b1ba088a',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96',
          '0x4cfa50b7ce747e2d61724fcac57f24b748ff2b2a',
        ],
        rewardTokenType: '',
        stakingToken: '0xc74a9d15037886ea357f0ef243c50010b11133cb',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-FUSDC',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '40.90',
        tvlUsd: '40.90',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 121,
        createdAt: '2023-11-02T21:00:07.000Z',
        chainId: 42161,
        dateOfAdd: '2023-11-02T21:00:07.000Z',
        beacon: '0x585fc6477d8c69d7e01338bb723d64e3bd3b6d66',
        calculationConnector: '',
        source: '',
        origin: '0x62a83c6791a3d7950d823bb71a38e47252b6b6f4',
        vaultFactoryId: 35,
        rewardTokens: [
          '0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96',
          '0x4cfa50b7ce747e2d61724fcac57f24b748ff2b2a',
        ],
        rewardTokenType: '',
        stakingToken: '0xb75ed91d1654e586015d72cabbc8f4b8b9aa0fd9',
        stakingTokenType: 'SINGLE-LP',
        stakeTokenSymbol: 'LP-USDC.E',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '125.68',
        tvlUsd: '125.68',
        enabled: false,
        dexFactory: {
          id: 84719,
          chainId: 42161,
          address: '',
          name: 'Wombat',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 639,
        createdAt: '2024-01-12T15:41:13.000Z',
        chainId: 42161,
        dateOfAdd: '2024-01-12T15:41:13.000Z',
        beacon: '0xa796617e7a6ef1f366480be5825455a5e5c1a92c',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0xd9e2a1a61b6e61b275cec326465d417e52c1b95c',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1357.71',
        tvlUsd: '1357.71',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 640,
        createdAt: '2024-01-12T15:41:13.000Z',
        chainId: 42161,
        dateOfAdd: '2024-01-12T15:41:13.000Z',
        beacon: '0xb8f362011c0274d5ae0f1d9679fb2aa0fb59ee50',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x0bacc7a9717e70ea0da5ac075889bd87d4c81197',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '12137.55',
        tvlUsd: '12137.55',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 641,
        createdAt: '2024-01-12T15:41:13.000Z',
        chainId: 42161,
        dateOfAdd: '2024-01-12T15:41:13.000Z',
        beacon: '0x5a234fd7ab26a1ca101927ebf55dda5640af1a7d',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USDC/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x7e928afb59f5de9d2f4d162f754c6eb40c88aa8e',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '3852.22',
        tvlUsd: '3852.22',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 642,
        createdAt: '2024-01-12T20:26:33.000Z',
        chainId: 42161,
        dateOfAdd: '2024-01-12T20:26:33.000Z',
        beacon: '0x4bee47d5ef92ea363ac2a92f0ec68edab6bf7de2',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'XAI/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0xf0b860d338e8b5199606322653b83a166d96e417',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '255.81',
        tvlUsd: '255.81',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 643,
        createdAt: '2024-01-12T20:26:33.000Z',
        chainId: 42161,
        dateOfAdd: '2024-01-12T20:26:33.000Z',
        beacon: '0x03832381e788a831332bd2985e043f2206af6d38',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/ARB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x0d7c4b40018969f81750d0a164c3839a77353efb',
        poolV3Fee: 0.0005,
        apr: 0.0127,
        tvlStaking: '9737.70',
        tvlUsd: '9737.70',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1599,
        createdAt: '2024-06-06T07:54:03.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-06T07:54:03.000Z',
        beacon: '0x794ee5bc2bce0bfd5e92c425e7573b8c19a1a3d3',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/TIA.N',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x908974b441bfca9ec4fdcd2ea49434e6e73d28f1',
        poolV3Fee: 0.01,
        apr: 0.0317,
        tvlStaking: '8072.86',
        tvlUsd: '8072.86',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1600,
        createdAt: '2024-06-06T07:54:03.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-06T07:54:03.000Z',
        beacon: '0xf1f82942ad87fa6e48cd04d082e3e7b020fb3016',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'PEPE/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1944ac04bd9fed9a2bcdb38b70c35949c864ec35',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '218140.48',
        tvlUsd: '218140.48',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1601,
        createdAt: '2024-06-06T07:54:03.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-06T07:54:03.000Z',
        beacon: '0x2c0a5138e5a534cad8d4947f395fa1e0bfcd57c7',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc6962004f452be9203591991d15f6b388e09e8d0',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '98453987.99',
        tvlUsd: '98453987.99',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1602,
        createdAt: '2024-06-06T07:54:03.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-06T07:54:03.000Z',
        beacon: '0xd8457b4bf9209a82c71ea9bb190d9d5f86797090',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x641c00a822e8b671738d32a431a4fb6074e5c79d',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '27165429.43',
        tvlUsd: '27165429.43',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1603,
        createdAt: '2024-06-06T07:54:03.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-06T07:54:03.000Z',
        beacon: '0xe1ebc0b117d03f38c22aabd818408e7f6429da46',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/ARB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc6f780497a95e246eb9449f5e4770916dcd6396a',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '10391942.65',
        tvlUsd: '10391942.65',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1612,
        createdAt: '2024-06-13T15:20:01.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-13T15:20:01.000Z',
        beacon: '0xcc786e464602f1f4b9a59e9deaccdbdfcb3d2624',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WBTC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2f5e87c9312fa29aed5c179e456625d79015299c',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '150981915.52',
        tvlUsd: '150981915.52',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1613,
        createdAt: '2024-06-13T15:20:01.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-13T15:20:01.000Z',
        beacon: '0x24ba198d3fa34ee412d02bf0d58461ccff9de705',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WSTETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x35218a1cbac5bbc3e57fd9bd38219d37571b3537',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '2595390.31',
        tvlUsd: '2595390.31',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1614,
        createdAt: '2024-06-13T15:20:01.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-13T15:20:01.000Z',
        beacon: '0xdcd4dae454b86ec709f74fb637dd38de68ce9115',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WEETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x14353445c8329df76e6f15e9ead18fa2d45a8bb6',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '61243.75',
        tvlUsd: '61243.75',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1615,
        createdAt: '2024-06-13T15:20:01.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-13T15:20:01.000Z',
        beacon: '0x4e70b6569a8a78ac29dce0b5e38bb8fab359c62e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'PENDLE/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xdbaeb7f0dfe3a0aafd798ccecb5b22e708f7852c',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '9591640.81',
        tvlUsd: '9591640.81',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1616,
        createdAt: '2024-06-13T15:20:01.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-13T15:20:01.000Z',
        beacon: '0x599032a8bb5a3f2d32be46043d0c8b461b58bd82',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'AXLUSDC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xaeeceec4b31d3c1057210115bf176ebb05b9805d',
        poolV3Fee: 0.0001,
        apr: 0.0838,
        tvlStaking: '9760.45',
        tvlUsd: '9760.45',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1617,
        createdAt: '2024-06-14T08:33:48.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T08:33:48.000Z',
        beacon: '0x665f809604ccf19cba33773bb5d2b719675f0eaf',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'GNS/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xaa9e653252ed9e87a9bd545b974efbfb2f389f3f',
        poolV3Fee: 0.0005,
        apr: 0.0032,
        tvlStaking: '724.57',
        tvlUsd: '724.57',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1618,
        createdAt: '2024-06-14T08:33:48.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T08:33:48.000Z',
        beacon: '0x6836c90bade645fd34ead6338cae1da598567e6b',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'EMC/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x47b6de853d181626918eecb1e0ed946a5cf96449',
        poolV3Fee: 0.003,
        apr: 4e-5,
        tvlStaking: '7339.64',
        tvlUsd: '7339.64',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1620,
        createdAt: '2024-06-14T08:33:48.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T08:33:48.000Z',
        beacon: '0x88ea39d13aa29ca0e986fbb27d6c5db0cd4d7025',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'XAI/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x03a33aee5f4947b9c1cde042c5f037d1be304be7',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '14841.65',
        tvlUsd: '14841.65',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1622,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0x47ec6e52688fc0e5f898a6625276b79c6cf250c4',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/LINK',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x468b88941e7cc0b88c1869d68ab6b570bcef62ff',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '8290988.66',
        tvlUsd: '8290988.66',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1623,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0x2000b48c8d4c6700972e4e61fa49ebd8cf5f1ab9',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/GMX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1aeedd3727a6431b8f070c0afaa81cc74f273882',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '851077.13',
        tvlUsd: '851077.13',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1624,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0x62592e5d5c5b8c41dcd7604cdb2dae0fe75d29f2',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/GRT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x74d0ae8b8e1fca6039707564704a25ad2ee036b0',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '904863.93',
        tvlUsd: '904863.93',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1626,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0xbd5a6fcce36c33d7fa092fda379ea9debb7d477d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'GRAI/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x021a4e8adce1dd0cfac1d8561005c1e1ffc55608',
        poolV3Fee: 0.0005,
        apr: 0.004,
        tvlStaking: '1345.72',
        tvlUsd: '1345.72',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1627,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0x59df8a3beb44de24a1127de732f236ef63d3be17',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'TBTC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcb198a55e2a88841e855be4eacaad99422416b33',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1010536.27',
        tvlUsd: '1010536.27',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1628,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0x578bb075ca2f2b5cd00b8afc3635a370ba046fef',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'RSETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x20384b876fab2848cf9f632e5df8c50fe6f311f8',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '106.53',
        tvlUsd: '106.53',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1629,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0x3b8f7152b5b5704b77d220f98e98b9dd5df7cb65',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WBTC/TBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe9e6b9aaafaf6816c3364345f6ef745ccfc8660a',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '3847455.13',
        tvlUsd: '3847455.13',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1630,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0x8a6ea1ef58fbb8088d9e01d822e3538efd52a037',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'MAGIC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x59d72ddb29da32847a4665d08ffc8464a7185fae',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '207503.15',
        tvlUsd: '207503.15',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1631,
        createdAt: '2024-06-14T12:55:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-14T12:55:28.000Z',
        beacon: '0x233a43c04ad4114d0618a44fb84f57b6eb5d6e15',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'LDO/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x52f9d14bed8ce6536da063aaf274ae2747ef4853',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '371708.49',
        tvlUsd: '371708.49',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1641,
        createdAt: '2024-06-17T15:00:41.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-17T15:00:41.000Z',
        beacon: '0x25e05ccc6dfffba25ec2042373de26e983e2cd9a',
        calculationConnector: '',
        source: '',
        origin: '0x74337fb8381ce8c323110cef2e041d0f2220a2ce',
        vaultFactoryId: 35,
        rewardTokens: ['0x4117ec0a779448872d3820f37ba2060ae0b7c34b'],
        rewardTokenType: '',
        stakingToken: '0x24129a6c5b700435cc0d1bd3500796f3fb9ebd49',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDEX+/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 42.265,
        tvlStaking: '1.18',
        tvlUsd: '1.18',
        enabled: false,
        dexFactory: {
          id: 40,
          chainId: 42161,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1642,
        createdAt: '2024-06-17T15:00:41.000Z',
        chainId: 42161,
        dateOfAdd: '2024-06-17T15:00:41.000Z',
        beacon: '0xb6899105f970411c0636bb226c76b73b16b92f5c',
        calculationConnector: '',
        source: '',
        origin: '0x74337fb8381ce8c323110cef2e041d0f2220a2ce',
        vaultFactoryId: 35,
        rewardTokens: ['0x4117ec0a779448872d3820f37ba2060ae0b7c34b'],
        rewardTokenType: '',
        stakingToken: '0x0e75ca30b075aa0df8c360e30cd0ed26ed62432a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDEX+/GDEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 19.2559,
        tvlStaking: '2.59',
        tvlUsd: '2.59',
        enabled: false,
        dexFactory: {
          id: 40,
          chainId: 42161,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1679,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0x632ed879766745139d835221d72745004bc6a5ef',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USDV/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x6fd1112cdfa0f53a698fb4d6c6f7dcec82e20b58',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '654.99',
        tvlUsd: '654.99',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1682,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0x614a35f0d56ca61e216c2bcb4d806d32e0116595',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USDC/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa1f9159e11ad48524c16c9bf10bf440815b03e6c',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '3.59',
        tvlUsd: '3.59',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1683,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0x6f96b0ef1f5031fbc4e0ba1ecc4d315f5fe8fbc0',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ARB/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9ffca51d23ac7f7df82da414865ef1055e5afcc3',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '4106.80',
        tvlUsd: '4106.80',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1684,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0x26d9a19522c261fd367d5d5717be19952da14b90',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4fc7ac44dae553464d92c049175133239a8705c1',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '6455.27',
        tvlUsd: '6455.27',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1687,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0x0f0acc36b4820b8255a946498244387c75d89a1c',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/ETHX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe2d9b612446180334d56e10e82dc78e3dee814b0',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '0.04',
        tvlUsd: '0.04',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1688,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0x3ae17c80d59d1bfd96c7f7d5a988049127e6fb3f',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ARB/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x81d1cc282e9a097115e59f67b9d81d4d1d00ac51',
        poolV3Fee: 0.0005,
        apr: 0.0119,
        tvlStaking: '9422.65',
        tvlUsd: '9422.65',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1689,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0x96d3d007047c37076915dd215e9bc6af9cf150fc',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x389938cf14be379217570d8e4619e51fbdafaa21',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '11932.02',
        tvlUsd: '11932.02',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1690,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0xbcff83390438a3de6ea62dc0c53e55398a67c3f6',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'RSETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4b89179dafe5c36ae611208b5590fef9153b7daa',
        poolV3Fee: 0.0001,
        apr: 0.0014,
        tvlStaking: '1015.99',
        tvlUsd: '1015.99',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1691,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0x5f30dc1561f1ff2554be4255eede3f35a4231dd9',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x7fcdc35463e3770c2fb992716cd070b63540b947',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '42732.41',
        tvlUsd: '42732.41',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1693,
        createdAt: '2024-08-15T10:34:22.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:22.000Z',
        beacon: '0xb21935cefcd05125106ea2f5062fc9e900dd2ebe',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'GRAI/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x060d8a5a7c03882e33aca8fc304babe869e21ee9',
        poolV3Fee: 0.0005,
        apr: 0.2028,
        tvlStaking: '12.04',
        tvlUsd: '12.04',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1694,
        createdAt: '2024-08-15T10:34:25.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:25.000Z',
        beacon: '0x23006cd1ae6b8cbc8082963febf61524ff7ccd08',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ZRO/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x152703894d31e54437d01b03bdd21c03583e9709',
        poolV3Fee: 0.0025,
        apr: 1.3006,
        tvlStaking: '1339.48',
        tvlUsd: '1339.48',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1695,
        createdAt: '2024-08-15T10:34:25.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:25.000Z',
        beacon: '0xf3196975ce145d78651a37f9f537c0f028b7db98',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USDC/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa1f9159e11ad48524c16c9bf10bf440815b03e6c',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '1243.56',
        tvlUsd: '1243.56',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1696,
        createdAt: '2024-08-15T10:34:25.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:25.000Z',
        beacon: '0x4972c4103560691a77481c605c5cc6082ea10e54',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WBTC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x843ac8dc6d34aeb07a56812b8b36429ee46bdd07',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '2339.47',
        tvlUsd: '2339.47',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1697,
        createdAt: '2024-08-15T10:34:25.000Z',
        chainId: 42161,
        dateOfAdd: '2024-08-15T10:34:25.000Z',
        beacon: '0x9225617fade4334c9831ab66408894fbab12b97a',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe37304f7489ed253b2a46a1d9dabdca3d311d22e',
        poolV3Fee: 0.0001,
        apr: 0.1388,
        tvlStaking: '2.16',
        tvlUsd: '2.16',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1853,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x86552636df368ec78e1b29d90725dbb5be62c726',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDE/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xaf7b48ae2f4773fd44f9208cca3db5ae7bfa7e37',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '37811.93',
        tvlUsd: '37811.93',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1854,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0xcd5a006f02fd219a769ab26a7c0076c8c766e882',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'XUSD/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x67ab7dc903a10838a0de8861dfdff3287cf98e5c',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '10413.55',
        tvlUsd: '10413.55',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1855,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0xbf690a7dafd24e3e205a7f85ece8e8ebaf93e7e7',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/XUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x7548bd60cb8f627a9b8ed94f8ca174348dbe6a05',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '85540.79',
        tvlUsd: '85540.79',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1856,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x4a41ab6afe4113048ad9f6afcc50ca6770e0336e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3dd2fdba71282083d440687cce9e4231aaac534e',
        poolV3Fee: 0.0001,
        apr: 2e-5,
        tvlStaking: '802.25',
        tvlUsd: '802.25',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1857,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x10dd9468bf6d3b1643f75f495e3122eed4129808',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/XUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x421803da50d3932caa36bd1731d36a0e2af93542',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '2078626.13',
        tvlUsd: '2078626.13',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1858,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x299b19cdbc02660aabb0cf15a7e696b2ea415c0d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ZRO/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4cef551255ec96d89fec975446301b5c4e164c59',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '3976633.94',
        tvlUsd: '3976633.94',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1859,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x1e51fc738042b6d193a634517ab5e1f2e8538b73',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WSTETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xab007665a4dfd24830f0ca19206f9fbd7c3aa85f',
        poolV3Fee: 0.0005,
        apr: 0.0441,
        tvlStaking: '15615.80',
        tvlUsd: '15615.80',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1860,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x921036063f4f77dd2f654f07d4f257e07624c8be',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WSTETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc7341e85996eeb05897d3dec79448b6e4ccc09cf',
        poolV3Fee: 0.0005,
        apr: 0.0149,
        tvlStaking: '3161.10',
        tvlUsd: '3161.10',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1861,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0xc09131ef5549feda362bb06a3205c488456f5387',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'CRV/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa95b0f5a65a769d82ab4f3e82842e45b8bbaf101',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '3667617.41',
        tvlUsd: '3667617.41',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1862,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x76e227f3decb6510847efb9c774065310193a420',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'FRAX/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1ebcf8831b93450ea81b0619c5e05b98751c8322',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '56637.29',
        tvlUsd: '56637.29',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1863,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0xcf5bca2322633da2d153dc07507f220f73434017',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'PENDLE/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb08a8794a5d3ccca3725d92964696858d3201909',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1007736.56',
        tvlUsd: '1007736.56',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1864,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x48dd370829c74ea5fdd0ca42f743e1774af1008e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'PENDLE/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x50e7b9293aef80c304234e86c84a01be8401c530',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '993676.49',
        tvlUsd: '993676.49',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1865,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x7d640a67ad9bb0682216a32ac506b56842caa16b',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'PENDLE/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc6af8e73e2261264ef95466b97b13e03bd88165e',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '394745.42',
        tvlUsd: '394745.42',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1866,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x429abe5b679227570d3cb7357ac573f8285c8f95',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/RETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x09ba302a3f5ad2bf8853266e271b005a5b3716fe',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '416879.19',
        tvlUsd: '416879.19',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1867,
        createdAt: '2024-09-09T12:06:28.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:28.000Z',
        beacon: '0x784b73cfb261c8301efc33ecbb77aa6f74f63325',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/UNI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc24f7d8e51a64dc1238880bd00bb961d54cbeb29',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1228582.57',
        tvlUsd: '1228582.57',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1868,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x7d8266692a2a8693b67805985d5270187c692222',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'UNI/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xd97c8ee1c1e47f50a66e69d5ad155f882e38b0e5',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '31642.22',
        tvlUsd: '31642.22',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1869,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x3275ad7f78f5a3ec36b95caa967b5d20988d642c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/UNI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x05477c22a5349cee601500da0489dad137fd6bfa',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '63679.21',
        tvlUsd: '63679.21',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1870,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x27cd463a31344012c533075a9765df8919a1bbef',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'RDNT/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x446bf9748b4ea044dd759d9b9311c70491df8f29',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '21969.73',
        tvlUsd: '21969.73',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1871,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x47437deb94fdf21e24b4212e3649d76314da9d84',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'GNS/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc91b7b39bbb2c733f0e7459348fd0c80259c8471',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '221881.04',
        tvlUsd: '221881.04',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1872,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x99219e47784e8884bfa0862832ae22d536ace858',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'TAP/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5918aca9ae924e6eaaa3d293bb92bdec9ab79338',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '93.58',
        tvlUsd: '93.58',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1873,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x880a10f217db9137ef3fd36fc9b239743dc00cd8',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/GMX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x80a9ae39310abf666a87c743d6ebbd0e8c42158e',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '13611066.24',
        tvlUsd: '13611066.24',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1874,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x4511724d54470465d3b4a59544881c17ba7f8e0c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'RSETH/WSTETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5baf59a6e6df0ee95bce8c43daa05b288e340e7d',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '172013.64',
        tvlUsd: '172013.64',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1875,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x9887b36df40ba28e6d2b8dcd32055964a308a554',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc82819f72a9e77e2c0c3a69b3196478f44303cf4',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '732992.01',
        tvlUsd: '732992.01',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1876,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x5e23ed8a5e2a30061507f5d2c70f4ecf114ac5ab',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc473e2aee3441bf9240be85eb122abb059a3b57c',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '6604962.54',
        tvlUsd: '6604962.54',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1877,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x4d2d411dd9838602d3078ba0a973928ff92f32ff',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ARB/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb0f6ca40411360c03d41c5ffc5f179b8403cdcf8',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1644091.18',
        tvlUsd: '1644091.18',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1878,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x624f56598a1ec408a1884c23f5e2083e9259b5e2',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WBTC/ARB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x689c96ceab93f5e131631d225d75dea3fd37747e',
        poolV3Fee: 0.003,
        apr: 0.0089,
        tvlStaking: '17860.11',
        tvlUsd: '17860.11',
        enabled: false,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1879,
        createdAt: '2024-09-09T12:06:31.000Z',
        chainId: 42161,
        dateOfAdd: '2024-09-09T12:06:31.000Z',
        beacon: '0x53b13b0d37d6b9c7811c4fdac5d9a8e70083b600',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'LINK/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x32a5746ba6826828716cc1a394bc33301ebc7656',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '912894.51',
        tvlUsd: '912894.51',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2181,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0xd72b229858a4b2198e8653a625baf59167fce5b7',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'EGP/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x02c12fd05cb0d26579789abcfdc58b07db755236',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '12.59',
        tvlUsd: '12.59',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2182,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0xecccccb82216c8c021bd5a9cdeac633b7bfd957a',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'SQD/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc24b560c7f8a1a50c2336cd8917af61b5e14984f',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '278156.41',
        tvlUsd: '278156.41',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2183,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0xeb57556138aeb89ebeaf428bb2677d28edb4013e',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'PENDLE/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x042691f78269ba3d6325c945044239758aecc275',
        poolV3Fee: 0.0005,
        apr: 0.0918,
        tvlStaking: '1524.05',
        tvlUsd: '1524.05',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2184,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0xfe9d3df2863318258e1f9cdb697a95f17de1e119',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ZRO/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf0346b437fe43e64fa799c2bd3cf5db1f7e9327c',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1.33',
        tvlUsd: '1.33',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2185,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0x9334ab7c05efe0da8cdf2efa823b58c95370d915',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ZRO/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x152703894d31e54437d01b03bdd21c03583e9709',
        poolV3Fee: 0.0025,
        apr: 0.605,
        tvlStaking: '2879.55',
        tvlUsd: '2879.55',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2186,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0x730fa09be97255713f87a378aa59ea0ae9274876',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WBTC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5a17cbf5f866bde11c28861a2742764fac0eba4b',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '503.41',
        tvlUsd: '503.41',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2187,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0xd2d3605ae7770712451fa8186c154fa84e6420aa',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/ARB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0d7c4b40018969f81750d0a164c3839a77353efb',
        poolV3Fee: 0.0005,
        apr: 0.0251,
        tvlStaking: '6280.41',
        tvlUsd: '6280.41',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2188,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0xcf1b698d129ba215dcc38564aba0e0ed6be5df18',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'RSETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4b89179dafe5c36ae611208b5590fef9153b7daa',
        poolV3Fee: 0.0001,
        apr: 0.0073,
        tvlStaking: '201.84',
        tvlUsd: '201.84',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2189,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0x044a9aee4dda77569d76b1c9d6dc83ab19d1887a',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/ETHX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe2d9b612446180334d56e10e82dc78e3dee814b0',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2190,
        createdAt: '2024-10-30T10:22:54.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:22:54.000Z',
        beacon: '0xd41d13b8e29c11f65521239f16ed9d06bf793e2e',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WETH/TIA.N',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfeb104864f3ad0c75e6b1bb4a0edb3f89e562e6e',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '483.53',
        tvlUsd: '483.53',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2191,
        createdAt: '2024-10-30T10:23:02.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:23:02.000Z',
        beacon: '0x2e5cac68025c7918cd1e0efaf987fca3a94d0760',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WBTC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4bfc22a4da7f31f8a912a79a7e44a822398b4390',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '37677.38',
        tvlUsd: '37677.38',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2192,
        createdAt: '2024-10-30T10:23:02.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:23:02.000Z',
        beacon: '0xfdf955d4cc9b88c603c3e12037671b911ca7a999',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USD+/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfe193d41bf8ee691bec999bce0981b6d06c89394',
        poolV3Fee: 0.0001,
        apr: 0.0416,
        tvlStaking: '5298.96',
        tvlUsd: '5298.96',
        enabled: false,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2193,
        createdAt: '2024-10-30T10:23:02.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:23:02.000Z',
        beacon: '0xbfbd24c424499159ccd6997931590e82d69fc7a8',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WBTC/SOLVBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcfbcc53e96908cc3719f2807457db0b89870c4de',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '19842.10',
        tvlUsd: '19842.10',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2194,
        createdAt: '2024-10-30T10:23:02.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:23:02.000Z',
        beacon: '0x2a98d2cb1ee8f13e763e65034b718b8a7d9599b8',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USDT+/XUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8a06339abd7499af755df585738ebf43d5d62b94',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '63416.13',
        tvlUsd: '63416.13',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2195,
        createdAt: '2024-10-30T10:23:02.000Z',
        chainId: 42161,
        dateOfAdd: '2024-10-30T10:23:02.000Z',
        beacon: '0x28dff68cef359398ad33dac0febe4225e80d5ba6',
        calculationConnector: '',
        source: '',
        origin: '0x5e09acf80c0296740ec5d6f643005a4ef8daa694',
        vaultFactoryId: 35,
        rewardTokens: ['0x1b896893dfc86bb67cf57767298b9073d2c1ba2c'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USD0/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x858dff46915d3f81bb7ff06158b2806164acb2a0',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '329.32',
        tvlUsd: '329.32',
        enabled: true,
        dexFactory: {
          id: 84768,
          chainId: 42161,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2950,
        createdAt: '2024-12-05T10:43:52.000Z',
        chainId: 42161,
        dateOfAdd: '2024-12-05T10:43:52.000Z',
        beacon: '0xbea23004e2fed40f88d87b4b7a3555098dfcd445',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WBTC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0e4831319a50228b9e450861297ab92dee15b44f',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '18112573.53',
        tvlUsd: '18112573.53',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2951,
        createdAt: '2024-12-05T10:43:52.000Z',
        chainId: 42161,
        dateOfAdd: '2024-12-05T10:43:52.000Z',
        beacon: '0x43f122b028c5fc857e6937a6ccda51bc1e259e32',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WBTC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x6985cb98ce393fce8d6272127f39013f61e36166',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '905735.90',
        tvlUsd: '905735.90',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2952,
        createdAt: '2024-12-05T10:43:52.000Z',
        chainId: 42161,
        dateOfAdd: '2024-12-05T10:43:52.000Z',
        beacon: '0xcfdef68fc802a7a0315e6beb20d0c7eb47132f0b',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x6f38e884725a116c9c7fbf208e79fe8828a2595f',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '2473885.24',
        tvlUsd: '2473885.24',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2953,
        createdAt: '2024-12-05T10:43:52.000Z',
        chainId: 42161,
        dateOfAdd: '2024-12-05T10:43:52.000Z',
        beacon: '0x55d2f204ce41b2320e5db429d84690c544987f41',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USD0',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x42161084d0672e1d3f26a9b53e653be2084ff19c',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '76155.91',
        tvlUsd: '76155.91',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2954,
        createdAt: '2024-12-05T10:43:52.000Z',
        chainId: 42161,
        dateOfAdd: '2024-12-05T10:43:52.000Z',
        beacon: '0x748b843ac8b809f0271cc546d6a619720cb3a1fd',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/AAVE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xdd672b3b768a16b9bcb4ee1060d3e8221435beaa',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '4203216.07',
        tvlUsd: '4203216.07',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2955,
        createdAt: '2024-12-05T10:43:52.000Z',
        chainId: 42161,
        dateOfAdd: '2024-12-05T10:43:52.000Z',
        beacon: '0x3853f71fca10dadcb4f17cc7bbd9ed6d02003d81',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/AAVE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3db70832f48f8c01ee041671f7bb1cfaa2677584',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '134852.80',
        tvlUsd: '134852.80',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3116,
        createdAt: '2024-12-11T20:48:30.000Z',
        chainId: 42161,
        dateOfAdd: '2024-12-11T20:48:30.000Z',
        beacon: '0x5c5eaf7ecb1467c3be34a9224e7846eb1626d2b6',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 35,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'EMP/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0ad1e922e764df5ab6d636f5d21ecc2e41e827f0',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '43079.14',
        tvlUsd: '43079.14',
        enabled: true,
        dexFactory: {
          id: 95045,
          chainId: 42161,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
    ],
    profitClaimer: '0x20b563f85f0b43bd30b452ee87931733ec5c0208',
  },
  {
    id: 37,
    factory: '0xd4f1a99212e5be72426bde45abadef66d7d6edf3',
    chainId: 10,
    name: 'op',
    enabled: true,
    migrator: '0x554837ccf9caf9029f6f6e01ec49ef8403417204',
    zapper: '0x1a7b1f23c0aaabc346e56fe0e9b73904a76da3f8',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.055',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0xdcc906dc8ba0c92edfe7e7d003e9b3cd99d4fa60',
      '0x65bf4ba3aac39a066b95de67cc07f2abaf9baf34',
      '0xd1a34d6c11135efdf921b152ee294eb094b14eee',
    ],
    underlyingZapperTokensWl: [
      '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
      '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
      '0x9560e827af36c94d2ac33a39bce1fe78631088db',
      '0x4200000000000000000000000000000000000042',
    ],
    farms: [
      {
        id: 276,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x79187c7803210f467b378af3f1a0c84d1a1b3ec9',
        calculationConnector: '',
        source: '',
        origin: '0x04b739f3488e4ca48a1638d945d41b9ae33424e5',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xdff90e4a6c229565f25337b1db9fa12f6d8cb118',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'THALES/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0194,
        tvlStaking: '128471.86',
        tvlUsd: '128471.86',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 277,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xb104843a85a5bbf641da50ea0b07d5216ee94fae',
        calculationConnector: '',
        source: '',
        origin: '0x34632b0b9f8f8e5c911ab2679d38fd4ad08c59c9',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x5954e5b20260c0cdd35c93bbda98d1f2c5abecaf',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'GNODE/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.3869,
        tvlStaking: '5526.73',
        tvlUsd: '5526.73',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 278,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xc741d1f5d2cc880c351e8749606c9e00ddcfa18b',
        calculationConnector: '',
        source: '',
        origin: '0x8d2723fe2bfc3e9c2515a8789dadf8c82f58f04f',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x4ca2f3ceddb88c847d9204124a6edfa0172a7dee',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'GNODE/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0751,
        tvlStaking: '12770.79',
        tvlUsd: '12770.79',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 279,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xa1701c0747934465ced09bcf27d6b136186174d2',
        calculationConnector: '',
        source: '',
        origin: '0x06145ef79cfad7f057bc8ae68ec8c8c41e4d13e1',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x69a9b0f791507c50b413d24abb761acb5ac52728',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'RING/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.294,
        tvlStaking: '423966.69',
        tvlUsd: '423966.69',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 280,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x842af8690554b8efffd6891bc32e779a6baa846c',
        calculationConnector: '',
        source: '',
        origin: '0xec9df85f362d3ebc4b9ca0ed7d7fdecf8cfbdeb8',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x7a7f1187c4710010db17d0a9ad3fce85e6ecd90a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'RED/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.394,
        tvlStaking: '81824.56',
        tvlUsd: '81824.56',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 281,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x0d5c1c94fa0a27758e2c386230e390b5ff82326f',
        calculationConnector: '',
        source: '',
        origin: '0x261725c82e93b4ce6892e42c5b06501a3db36046',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x4e316557f63c2156eafdfec08f31df4957136203',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'RED/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.4067,
        tvlStaking: '84291.33',
        tvlUsd: '84291.33',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 282,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xf486c8914c0370cac3e90423c117908d495ccc80',
        calculationConnector: '',
        source: '',
        origin: '0x8c61ebd8f40bf920e9065db80d194541d895aa80',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xa08fb94a933eaea787f8191a5a980c4403dc015c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'VELO/BLU',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.5433,
        tvlStaking: '60962.60',
        tvlUsd: '60962.60',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 283,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x4b2f898b987f3e60e64fe73a37180e55bbf99f8d',
        calculationConnector: '',
        source: '',
        origin: '0x8166f06d50a65f82850878c951fca29af5ea7db2',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x615b9dd61f1f9a80f5bcd33a53eb79c37b20addc',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/BLU',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0841,
        tvlStaking: '10391.95',
        tvlUsd: '10391.95',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 284,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x2ed5fe7baab652b7e343740d7b3da5f1186d8093',
        calculationConnector: '',
        source: '',
        origin: '0x90715a670b9117e5a956af808061adbde073741f',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x25c488e5f69ac334ac1e8f786d890a97ec1bf713',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DF/USX',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0415,
        tvlStaking: '142562.92',
        tvlUsd: '142562.92',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 285,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xb8e01357c5f483649cc9882d1a25393463620226',
        calculationConnector: '',
        source: '',
        origin: '0x60861f228af12461a6d42c970b3eff5648504b13',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x18c830f6a32a06cf2ac4262e977a096f12bdab8d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'KUJI/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.5788,
        tvlStaking: '9522.32',
        tvlUsd: '9522.32',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 286,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xedfe71f5c35d2881ff6752ce30938342d7d49de3',
        calculationConnector: '',
        source: '',
        origin: '0xbcd875faded3d2b9458ea6b86bd5283075d78a06',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x6e6046e9b5e3d90eac2abba610bca725834ca5b3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'UNLOCK/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0827,
        tvlStaking: '562.58',
        tvlUsd: '562.58',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 287,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xb4a09bb30a3d7eb0ddf97b72663dca3d199fb5dc',
        calculationConnector: '',
        source: '',
        origin: '0xbfd8583b46cf82e1f7b23435762a58b2116a8037',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x439c8a3704bdf52fec25bc271d67baa2bd204104',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EXTRA/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1253,
        tvlStaking: '5635.60',
        tvlUsd: '5635.60',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 288,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xe0be93541962b5293e8836b09af6c6ce763fb381',
        calculationConnector: '',
        source: '',
        origin: '0x6bf9b9c779cd56e42ccff916955b6352b51166b8',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xa8e4fa96327c5a93e159bd781f3ccfd860519d82',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/MET',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0312,
        tvlStaking: '433382.68',
        tvlUsd: '433382.68',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 289,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xf6844902ddb08ed2cd4014ae2981b84b689091f6',
        calculationConnector: '',
        source: '',
        origin: '0xd2d304c2cdbf74be9cdcc6f7a4eb94c5a9b4f488',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x4e60495550071693bc8bdffc40033d278157eac7',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SONNE/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1168,
        tvlStaking: '13745.68',
        tvlUsd: '13745.68',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 291,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xd3304893458a2f47cb5a73a5be7d433410b5f922',
        calculationConnector: '',
        source: '',
        origin: '0xd85a08e8f475f8b6276c7d6bdf17d45736fea621',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xe5f28fc43bb40cdf7202ebe406793815b6f07fbd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'THALES/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.2113,
        tvlStaking: '3160.63',
        tvlUsd: '3160.63',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 292,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x529ec99227db2cd46ee9e60b3bc4fdc1d1dbd291',
        calculationConnector: '',
        source: '',
        origin: '0x5ae3a1d8fa88785adf7c9a43d2e60b63be3d4892',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x477fa18b063b7728409570d274f7a055e3da0d6e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EXTRA/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.2379,
        tvlStaking: '11232.33',
        tvlUsd: '11232.33',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 293,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x1fbd69843736d6be1801dfb2d6f884102b45565b',
        calculationConnector: '',
        source: '',
        origin: '0x57e13e46401da3cc1dd5abad73d72f71a2c2c2ec',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xa8c507ddf3ebedbf251f6f643a7d891532745467',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/DUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 1.0513,
        tvlStaking: '721.04',
        tvlUsd: '721.04',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 294,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x1f5c35696219ad817ba2f3b9f057a4686cfb52ac',
        calculationConnector: '',
        source: '',
        origin: '0x84195de69b8b131ddaa4be4f75633fcd7f430b7c',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x8134a2fdc127549480865fb8e5a9e8a8a95a54c5',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2174,
        tvlStaking: '208479.96',
        tvlUsd: '208479.96',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 295,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xd6f0a48820eefb1e4a92cc1e0f241d7c1e34e8a9',
        calculationConnector: '',
        source: '',
        origin: '0x5bca1d006cd356cc1af72183dcedf093a3eb56d7',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xa80ad5c1f8c21b34b427ea432530ae7ff36e3926',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'VELO/OPXVELO',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.2523,
        tvlStaking: '90269.11',
        tvlUsd: '90269.11',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 296,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xd9219bba3293554ea72560fac3dc991f9714a818',
        calculationConnector: '',
        source: '',
        origin: '0x324d5b0c7c054eaea91cf7411478ff317611efb2',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xbf75051f6e6df9fecf90d9bebbbb08a85950858c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'FRAX/DUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0315,
        tvlStaking: '56863.42',
        tvlUsd: '56863.42',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 297,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xd6ab9f5f3691ab6190b948b6a690f9f4366a31f4',
        calculationConnector: '',
        source: '',
        origin: '0x8329c9c93b63db8a56a3b9a0c44c2edabd6572a8',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x58e6433a6903886e440ddf519ecc573c4046a6b2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.085,
        tvlStaking: '455320.39',
        tvlUsd: '455320.39',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 298,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xce9d546427077d89f269ad23cd491e8048032e62',
        calculationConnector: '',
        source: '',
        origin: '0x31d553e63a92d5dc89fce8c2e753ba422faa2b93',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x9269f5199b01b7b7dd38321b85c3f34ee3f28f7f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'UNIDX/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 366.8939,
        tvlStaking: '1426.71',
        tvlUsd: '1426.71',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 299,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x979b53952c3af2d86cf8a5aa0318cb8ca466b102',
        calculationConnector: '',
        source: '',
        origin: '0xce4f1e466a8e320c39c798907e84884616615af8',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xc37a0a37664aeb3848f98c5dd5d7ae286a1e9ebd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'FRAX/MAI',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 300,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xf35d4d8fb9569e56ec578b45d3d38d31c3ee3d28',
        calculationConnector: '',
        source: '',
        origin: '0x5c5a8b5f31350a73382736604b0a76e2df18196a',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xcecc5dacc7b09d35e19b1c5c47a65bc822a9c559',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'KUJI/RETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 1.1657,
        tvlStaking: '2331.72',
        tvlUsd: '2331.72',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 301,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x195533f7f9617ae2b0cede7bca6f9c5887b1e066',
        calculationConnector: '',
        source: '',
        origin: '0x0f30716960f0618983ac42be2982ffec181af265',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xe9581d0f1a628b038fc8b2a7f5a7d904f0e2f937',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OP/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.062,
        tvlStaking: '1073812.94',
        tvlUsd: '1073812.94',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 302,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x9a088eb6ae6e6f5386fbeb641fd29c837f131727',
        calculationConnector: '',
        source: '',
        origin: '0xa688080ca069231c6d5713cd009662ea54437a02',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xfa09479d72e2b3f8b6df63399772237ad6658d76',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ALUSD/MAI',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1356,
        tvlStaking: '2350.26',
        tvlUsd: '2350.26',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 303,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x72fab27c35baa1e3350cf1ee65a3726ddb33e53f',
        calculationConnector: '',
        source: '',
        origin: '0x191a495f6d3481797c189ed14e88c205f20d69c0',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x88391365c225973032275db256b9d15f845d2c72',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/OPENX',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1729,
        tvlStaking: '258941.18',
        tvlUsd: '258941.18',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 304,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xb64da7156d9921eced792bbe6fa3cae60ee81d53',
        calculationConnector: '',
        source: '',
        origin: '0xb4d10f151d79a35b953d97e912c8332c946499f3',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xe54e4020d1c3afdb312095d90054103e68fe34b0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/MAI',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0174,
        tvlStaking: '19978.16',
        tvlUsd: '19978.16',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 305,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xd97fa3dca4b92accfe20dd446e2eeab543482238',
        calculationConnector: '',
        source: '',
        origin: '0x5b97b8a28bd16e3a46e2baf85a25d946f2bc36cd',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x95a05d06decf8e1eb93ae09b612fbd342f2f9e2e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/WUSDR',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1217,
        tvlStaking: '16410.87',
        tvlUsd: '16410.87',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 306,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xce75f3ca3a202aa3289223b8edfbe47785372e28',
        calculationConnector: '',
        source: '',
        origin: '0x3c1367b0b1f63704124858e9dfa7f1a1a66aa152',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x2fe304b407c7fab2a3c10962f14db751468a4f5b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OP/FRXETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0241,
        tvlStaking: '25543.10',
        tvlUsd: '25543.10',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 307,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x741611bb46cc7c8dae9c660e1cfd471c7c3c901f',
        calculationConnector: '',
        source: '',
        origin: '0xbdfbb54957262b19a32825aa70d67e55e116cb45',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x41cc89b91d0abe260f2cb53c1abda07b321e71df',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'CHI/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 3.9426,
        tvlStaking: '367650.44',
        tvlUsd: '367650.44',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 308,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x5ef7d64b89c150491c76a0027e969d36f3265e92',
        calculationConnector: '',
        source: '',
        origin: '0xa904cdc7c135dcb03e8f96eaa11ea2bcb9e065a5',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xefe139aa71b674168f5823360a824b3714f2718d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OP/EURA',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.3199,
        tvlStaking: '500.88',
        tvlUsd: '500.88',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 309,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x7e3405f275ae7b53880a2a37646a62d8f0f7c9a0',
        calculationConnector: '',
        source: '',
        origin: '0x1239c54d9fd91e6ecec8eaad80df0fed43c47673',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xf2d42c46528116362aca448837a0236459b53c63',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TAROT/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.4076,
        tvlStaking: '217253.80',
        tvlUsd: '217253.80',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 310,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xced661569530a71ea53c28585ec7c24a6da93158',
        calculationConnector: '',
        source: '',
        origin: '0x18a492ad4e4f6b3ed1c16d78322c6c2800c954b6',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xdb61f9b480f0a8b817811cfaa89a1c219c355224',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'LYRA/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 40.6571,
        tvlStaking: '3625.60',
        tvlUsd: '3625.60',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 311,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x90e930f0dd50b38d1c909b051d498a0d31febd70',
        calculationConnector: '',
        source: '',
        origin: '0x749fa76454dbfb528532578512deb1f512d3e804',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x0e88a5bff34d39da66bdd32b82dc89a32d7bb6c9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/HOP',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.2798,
        tvlStaking: '140486.95',
        tvlUsd: '140486.95',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 312,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xc8bc78937457437fab3c094cd89e4ab6aeae0869',
        calculationConnector: '',
        source: '',
        origin: '0xcfa050836c3e5dfa98d065d2f365cfd78a9011f9',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x6ed6df1c23c51cb7cc67a348cc8d9e6108ea3bfe',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/MOOBIFI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0111,
        tvlStaking: '646787.26',
        tvlUsd: '646787.26',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 313,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xf60236784f50c66c299ba84f72295810aa1ccab3',
        calculationConnector: '',
        source: '',
        origin: '0x255e21f207888b6ca4400524c75cc70dede6b968',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xf6ffb55bfb4f149b725211e7ef1cc9f3a67c5b01',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MSOP/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0937,
        tvlStaking: '72418.54',
        tvlUsd: '72418.54',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 315,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xb5fa4b2569e7d595016cfc7e6f8ae85296f3e15f',
        calculationConnector: '',
        source: '',
        origin: '0xdfe0eea4b7ca157cb1faf73fac2135164b375fb0',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x917aa69d539d6518440dd0bea2eaac142a8d5610',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MSETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0781,
        tvlStaking: '1653072.07',
        tvlUsd: '1653072.07',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 316,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xba4ace937279b9db560c3b7041902a6ae37af3bc',
        calculationConnector: '',
        source: '',
        origin: '0xb3381d38e872d31cd87122a2ce66afb9a3e6cd7b',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x4ed90ca704f4f6f3955169f202ea35365e41b424',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/PERP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.6872,
        tvlStaking: '1418.28',
        tvlUsd: '1418.28',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 317,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xf26266c819bef2069766df401f7d6306103deee7',
        calculationConnector: '',
        source: '',
        origin: '0xf9ddd38a4e0c3237563dbb651d1a155551e54ad6',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xe148d6ae042de77c1f9fe0d6c495ebfd7b705b4c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/MSUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1842,
        tvlStaking: '855690.68',
        tvlUsd: '855690.68',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 318,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xe769b20eda107026e46e9012250eb45ea1d801da',
        calculationConnector: '',
        source: '',
        origin: '0xf686424d4f3572e4624bddf8a00fb77fe748237c',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x2e931de1fcb2681dc98601e0b513308da9c5ceae',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TAROT/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.4189,
        tvlStaking: '1548.71',
        tvlUsd: '1548.71',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 320,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x67a4e6536fcfe80bd4ff16b8e86b22a95b64d3e6',
        calculationConnector: '',
        source: '',
        origin: '0x3ae58f00450d4d8caa63e30e44ab49e48e301114',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x7e1357fa56c0ecfe69daf22e08489ae8de56d86c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OP/DHT',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0453,
        tvlStaking: '30257.26',
        tvlUsd: '30257.26',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 322,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xc24d13c9da055e874feee24b72a3069eb597c59b',
        calculationConnector: '',
        source: '',
        origin: '0x172a58d5e8c11ee554b09d924d5e2c3afadd44c0',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x4d7959d17b9710be87e3657e69d946914221bb88',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/ALUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0104,
        tvlStaking: '30666.01',
        tvlUsd: '30666.01',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 323,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xee2e3a7300e27d8448c55a604468afbd6e445492',
        calculationConnector: '',
        source: '',
        origin: '0x2f434cad1525c38ff21aa60dd55e8a2c924fe1bf',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x2f318c7c3835df46146768e0c981fbad8b45483d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'GRAI/LUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.074,
        tvlStaking: '1275.93',
        tvlUsd: '1275.93',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 324,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x395bffa0ed166da4bf02e711ae7adb1195d7b9cf',
        calculationConnector: '',
        source: '',
        origin: '0x09cebb82d64fdb0649b3c2020259b86bd7ff0a5a',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x1f8b46abe1eabf5a60cbbb5fb2e4a6a46fa0b6e6',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'FRAX/DOLA',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 325,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x57ce1ef57b9b42834aabdeec8147f888c92bad3a',
        calculationConnector: '',
        source: '',
        origin: '0x0e9a70551e121aae0c2bafa056fc60caca465a1d',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xc3439bc1a747e545887192d6b7f8be47f608473f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OATH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 7.5132,
        tvlStaking: '163.48',
        tvlUsd: '163.48',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 326,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x04e931f609741e4864c56d95132b9e707a472128',
        calculationConnector: '',
        source: '',
        origin: '0xa1034ed2c9eb616d6f7f318614316e64682e7923',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xb720fbc32d60bb6dcc955be86b98d8fd3c4ba645',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/DOLA',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1141,
        tvlStaking: '5010.20',
        tvlUsd: '5010.20',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 327,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xa473ce1d067ea7043878403208f78c55596b4e14',
        calculationConnector: '',
        source: '',
        origin: '0x876101fc03b37fd7c621e093ae9a47f6a2527191',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x71d53b5b7141e1ec9a3fc9cc48b4766102d14a4a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/SNX',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0508,
        tvlStaking: '188611.50',
        tvlUsd: '188611.50',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 329,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xbc8ad8ace0e10a5e8673360d7fad5e7927fb7afe',
        calculationConnector: '',
        source: '',
        origin: '0x36691b39ec8fa915204ba1e1a4a3596994515639',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x0df083de449f75691fc5a36477a6f3284c269108',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OP/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.1903,
        tvlStaking: '111774.15',
        tvlUsd: '111774.15',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 330,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x8b95c6387066db900a9b48012710fb7a793750ab',
        calculationConnector: '',
        source: '',
        origin: '0xbac89e3d69a28be4b3e436d590a7c921a6b19d81',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x4be2cbe40521279b8fc561e65bb842bf73ec3a80',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/AGEUR',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 4.2021,
        tvlStaking: '3243.18',
        tvlUsd: '3243.18',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 331,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x6002dbf822a2132707aa12c4ca5f82d2d837cef1',
        calculationConnector: '',
        source: '',
        origin: '0x53f31a40570dab360a16f8a7f913dbe84f5d1c5c',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x8542dd4744edea38b8a9306268b08f4d26d38581',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'FRAX/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 332,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x580e49699b28d99c024f91aefebb22836c93862f',
        calculationConnector: '',
        source: '',
        origin: '0x95aab5e4525b93a84d7b1b9a028dcfd84a411e4a',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xed47e3ce6d9c05f562c469ab1bf1244cc697aa73',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/USX',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.4293,
        tvlStaking: '4563.17',
        tvlUsd: '4563.17',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 334,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xe58ba1c0d20ff97c17158b0dc3f0501784696a0b',
        calculationConnector: '',
        source: '',
        origin: '0xcc53cd0a8ec812d46f0e2c7cc5aadd869b6f0292',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xd25711edfbf747efce181442cc1d8f5f8fc8a0d3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0421,
        tvlStaking: '1274409.20',
        tvlUsd: '1274409.20',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 335,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x07fbf6e6bf31ebedcd158e813479e18a5d3ea50c',
        calculationConnector: '',
        source: '',
        origin: '0x55a272304456355242f6690863b5c8d5c512ff71',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x6d5ba400640226e24b50214d2bbb3d4db8e6e15a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/SUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1368,
        tvlStaking: '15578.46',
        tvlUsd: '15578.46',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 336,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x326d30e6b835061d2ed590069b14b39f63004e75',
        calculationConnector: '',
        source: '',
        origin: '0x121de0e978d117590588cb37533ef121c8826a8a',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x6387765ffa609ab9a1da1b16c455548bfed7cbea',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/LUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0619,
        tvlStaking: '15161.95',
        tvlUsd: '15161.95',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 337,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x07808206b636a0038173b63cd5c58e0f33ad7e0e',
        calculationConnector: '',
        source: '',
        origin: '0x21cda2b68318651dcc2c1006ea815e528bfe6db4',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x56770b94279539416855fe29ef14b26438b5e421',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'STG/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1064,
        tvlStaking: '15298.84',
        tvlUsd: '15298.84',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 338,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xccd2f0e59e073e5cc52a293f284c8f55ff0f9460',
        calculationConnector: '',
        source: '',
        origin: '0x325c9cbbf46aaecd4354b9ee793197aa78ebf682',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xff5318f81dd791e92d51b8a54fa3538832d2890d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SFRXETH/FRXETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0005,
        tvlStaking: '84890.53',
        tvlUsd: '84890.53',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 339,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x9a6ea62e7075953f3efbb5cade55534fa52e915c',
        calculationConnector: '',
        source: '',
        origin: '0x236593e0139a542afed346f5d8de7f52034ef9ab',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x6e57b9e54ea043a829584b22182ad22bf446926c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBTC/TBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0006,
        tvlStaking: '1838010.39',
        tvlUsd: '1838010.39',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 340,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x77d0637d84938a07be27c2674028e1f0f2c1dc70',
        calculationConnector: '',
        source: '',
        origin: '0xa8e0754dd8ef3700ac8478fdb8d4b8473de3817c',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xaf03f51de7a0e62bf061f6fc3931cf79166b0a29',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'FRAX/ALUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 342,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x3be8e868d9270597a94b64e6dbd65ae2f82c14b0',
        calculationConnector: '',
        source: '',
        origin: '0x10c9a929c02b6dccc0373d7869f0165e4952bdab',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xb545592e38b603f4a904a5260a6ffc538bfcb424',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'IB/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0111,
        tvlStaking: '85374.99',
        tvlUsd: '85374.99',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 343,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x9884bc592f596d592259a9d40470d34adc427ec2',
        calculationConnector: '',
        source: '',
        origin: '0xe7630c9560c59ccbf5eed8f33dd0cca2e67a3981',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x0493bf8b6dbb159ce2db2e0e8403e753abd1235b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.1161,
        tvlStaking: '53851.61',
        tvlUsd: '53851.61',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 344,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xf9555058ce4f9cd6f2727702b28088b463955cb5',
        calculationConnector: '',
        source: '',
        origin: '0x89af7f95f8532f32ea82b43abadf41a50b57d907',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xadbb23bcc3c1b9810491897cb0690cf645b858b1',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/TBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0643,
        tvlStaking: '29203.00',
        tvlUsd: '29203.00',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 345,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xf328fdcad5d20eef517e7b3fb1fb89d12831fc4e',
        calculationConnector: '',
        source: '',
        origin: '0x065b2613ae8e182112f2519b58bb842889596fc7',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xf04458f7b21265b80fc340de7ee598e24485c5bb',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/LUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1029,
        tvlStaking: '2667.52',
        tvlUsd: '2667.52',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 346,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x7adbe78249ca1c39240ed666f9864e1c5ae40a64',
        calculationConnector: '',
        source: '',
        origin: '0xa876c69ec3a99347b00635c60bd32ae3b4a02758',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x3f42dc59dc4df5cd607163bc620168f7ff7ab970',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/FRXETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0019,
        tvlStaking: '122388.29',
        tvlUsd: '122388.29',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 347,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x171db6a47860c65467fddf333a51d2cfc425f539',
        calculationConnector: '',
        source: '',
        origin: '0x6a38cdef57a9d3aa0a7f9295778ffdc0b4350117',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xe8b8bff1e415258eb3d5fa8deee9c38406e609cd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDT/LUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1898,
        tvlStaking: '1380.20',
        tvlUsd: '1380.20',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 348,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x67ce63eb7d213668cc0eaca31dbd15aab7257b8f',
        calculationConnector: '',
        source: '',
        origin: '0xa288791de22d1f1afad9807acdfdce5caa22d10e',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x3dd9556a521d6e57be480c94da102fedf0429aba',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'JEUR/EURA',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0843,
        tvlStaking: '50151.33',
        tvlUsd: '50151.33',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 349,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xb35c7415718a0ebe0d8a9401c50dcde3b2f17eb0',
        calculationConnector: '',
        source: '',
        origin: '0x9f82a8b19804141161c582cfea1b84853340a246',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x6da98bde0068d10ddd11b468b197ea97d96f96bc',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WSTETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0018,
        tvlStaking: '338851.33',
        tvlUsd: '338851.33',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 350,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xa3df5d42491724160bee507e4b8cc2da59872b51',
        calculationConnector: '',
        source: '',
        origin: '0xfc0b9a9c2b63e6acaca91a77a80bfa83c615e6c5',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x1ad06ca54de04dbe9e2817f4c13ecb406dcbeaf0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ALETH/FRXETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0078,
        tvlStaking: '204552.14',
        tvlUsd: '204552.14',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 351,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x589b1d34aa3a5c1b58b805a4f173688ef55010e9',
        calculationConnector: '',
        source: '',
        origin: '0xc16adbf2d01d6524b79cbb610ce31d5db80eee3c',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xa1055762336f92b4b8d2edc032a0ce45ead6280a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ALETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0392,
        tvlStaking: '6658364.10',
        tvlUsd: '6658364.10',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 352,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0xafe78ddb48ecc6c1f1b0e90e623253ccf2adca34',
        calculationConnector: '',
        source: '',
        origin: '0x6dd083cee9638e0827dc86805c9891c493f34c56',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x36e3c209b373b861c185ecdbb8b2ebdd98587bdb',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0856,
        tvlStaking: '89569.66',
        tvlUsd: '89569.66',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 353,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x85b780a6e56d6aa34b7eeb796f678adf1f67aa21',
        calculationConnector: '',
        source: '',
        origin: '0x8d2653dc52e123d653011a335a5c37cdc268f2af',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xc5c247580a4a6e4d3811c0da6215057aac480bac',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WSTETH/LDO',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0397,
        tvlStaking: '153209.03',
        tvlUsd: '153209.03',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 354,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x3e31e7b3c980b2ce91f114eb27039bc824241e4a',
        calculationConnector: '',
        source: '',
        origin: '0xa2f27d183a4e409c734367712f9344328f8ec98d',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x2b47c794c3789f499d8a54ec12f949eecce8ba16',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0272,
        tvlStaking: '16896.81',
        tvlUsd: '16896.81',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 366,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x4fdc1f571b6d00e05128f40aa7ab79e6d700c444',
        calculationConnector: '',
        source: '',
        origin: '0xfac0cf9e487356ddc72443061dfdb109885b04fd',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x844d7d2fca6786be7de6721aabdff6957ace73a0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OVN/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0664,
        tvlStaking: '25464.48',
        tvlUsd: '25464.48',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 367,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x47510cada28e96c5b97f545e8d85954879580291',
        calculationConnector: '',
        source: '',
        origin: '0x93e1152951ccfb02b1ad4d8a4afc68b28cac0614',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x0b28c2e41058edc7d66c516c617b664ea86eec5d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USD+/DOLA',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.581,
        tvlStaking: '1366.47',
        tvlUsd: '1366.47',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 368,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x0b02364cc67e15f654f5606e3e72f761c833771d',
        calculationConnector: '',
        source: '',
        origin: '0x89913088bf483c65325fbd43ce15051b78d762d4',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xd330841ef9527e3bd0abc28a230c7ca8dec9423b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'FRAX/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 106.9075,
        tvlStaking: '723.75',
        tvlUsd: '723.75',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 369,
        createdAt: '',
        chainId: 10,
        dateOfAdd: '',
        beacon: '0x2b2d949581dc68acd88c16da19a412c291c70dec',
        calculationConnector: '',
        source: '',
        origin: '0x4bc0547661f40e712a9793c3b99a14a68049a836',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x667002f9dc61ebcba8ee1cbeb2ad04060388f223',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USD+/DAI+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2693,
        tvlStaking: '37480.22',
        tvlUsd: '37480.22',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1632,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0xfbd75c84aa133c55e77fd398c634d0e3cc0985a6',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/AXLUSDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa8a5356ee5d02fe33d72355e4f698782f8f199e8',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '288851.48',
        tvlUsd: '288851.48',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1633,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0xd4cd0c44b570df7b44aa34a7c277655cc4d83a98',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/WLD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xd1f1bad4c9e6c44dec1e9bf3b94902205c5cd6c3',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '187449.77',
        tvlUsd: '187449.77',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1634,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0x37a46a9f11d1507f034a06b185afeb53ae4e9409',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'OP/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1c3140ab59d6caf9fa7459c6f83d4b52ba881d36',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '105094.38',
        tvlUsd: '105094.38',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1635,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0x26a251b1c2408824f3fdf51c40ea58a055d679ee',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WSTETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x04f6c85a1b00f6d9b75f91fd23835974cc07e65c',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '149669.70',
        tvlUsd: '149669.70',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1636,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0xf23b838ce74a9dde342a5202ddb8c98d19671ffb',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/SNX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0392b358ce4547601befa962680bede836606ae2',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '703824.07',
        tvlUsd: '703824.07',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1637,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0x0a2822f627f724558fffa7adb017462005b339b3',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x68f5c0a2de713a54991e01858fd27a3832401849',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1781446.34',
        tvlUsd: '1781446.34',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1638,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0x52c9906e172f6b6a2d335ccf5a2fec4fa3802a81',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfc1f3296458f9b2a27a0b91dd7681c4020e09d05',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '378843.24',
        tvlUsd: '378843.24',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1639,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0x7625da82d4986c198291ad0128c3c42891c965a7',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'SUSD/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xadb35413ec50e0afe41039eac8b930d313e94fa4',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '96576.46',
        tvlUsd: '96576.46',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1640,
        createdAt: '2024-06-14T15:41:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-06-14T15:41:21.000Z',
        beacon: '0xa07557dd1e8c5805932075b3434f2d09709d7212',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 37,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xc36442b4a4522e871399cd717abdd847ab11fe88',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/WLD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2ae3d6096d8215ac2acddf30c60caa984ea5debe',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '273448.20',
        tvlUsd: '273448.20',
        enabled: true,
        dexFactory: {
          id: 95050,
          chainId: 10,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3094,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x628b41edcb273cc55694601601068318391534fd',
        calculationConnector: '',
        source: '',
        origin: '0x239e26393e3e1b8865f9e829b83a210d1fa91f0d',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x92fb369363498d8bfefc4eb705d8c91a51d22c45',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'VELO/WOPTIDOGE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0672,
        tvlStaking: '15345.39',
        tvlUsd: '15345.39',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3095,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x488d9369f2a5a317bf57ea44d64e5717d1863e2b',
        calculationConnector: '',
        source: '',
        origin: '0xeda74e1c6ec8bf477c87719ffdf8b8c173154dea',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x10df8a154c806f74c589466214b1c831c2315173',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/WOPTIDOGE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1096,
        tvlStaking: '16941.81',
        tvlUsd: '16941.81',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3096,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x84a4e77fc0af155346da5c62827f90c32f8a7d80',
        calculationConnector: '',
        source: '',
        origin: '0x462793590e5e09d163c36ea3442d43cbd363f9df',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x503320622687b218d4eb488c25295676934497b0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WSTETH/ETH1S',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.4163,
        tvlStaking: '0.43',
        tvlUsd: '0.43',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 3097,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x582c1bf07ad75f1330ab8a62360e1ba0be4f5e71',
        calculationConnector: '',
        source: '',
        origin: '0xa297ec7ce00abf3a1836cff39f07534ed8bc788a',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xa925ef1ef90e2932fd4cb0554d1f34cf2ee00d96',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TKN/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0658,
        tvlStaking: '6344.20',
        tvlUsd: '6344.20',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3098,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x2352bc6a38f536c847456486d2f0460ed275e3a0',
        calculationConnector: '',
        source: '',
        origin: '0x6843823b4bdedd8a85134d6d0d59d88830ef9f00',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x0a8f0d4b3de04afade29ca0c84743177c4bcebb6',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TKN/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.09,
        tvlStaking: '10448.86',
        tvlUsd: '10448.86',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3099,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x9079ae3c0131941479fda5df99cb0ef6b741e741',
        calculationConnector: '',
        source: '',
        origin: '0x3132cc562c39fb9abaea11411987031c5144c85d',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x6ea20dbc05f58ed607c374e545bfb402d5796770',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/TLX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2951,
        tvlStaking: '19301.31',
        tvlUsd: '19301.31',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3100,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x846c2b01ecd354ccfef0d4ae474a74a27b58381d',
        calculationConnector: '',
        source: '',
        origin: '0xe9bb6746d2c1a8d4e943be85434d89516ff223c0',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x8f47041adbef5bf321c9f63a0660326614ab6b60',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/KWENTA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.4218,
        tvlStaking: '13970.67',
        tvlUsd: '13970.67',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3101,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x4be8933e124618ea40c1bce3e6aa24d5094dc32c',
        calculationConnector: '',
        source: '',
        origin: '0x6d8eb99a72dc97081da30b0e18fe03097cc291c2',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x60c94fdf6c72fad78c16a52c0c3fdc3c6504305d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/WELL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.4534,
        tvlStaking: '184056.67',
        tvlUsd: '184056.67',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3102,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x733c72cd61967f69b2ffbfa06afe9b8c14bb3846',
        calculationConnector: '',
        source: '',
        origin: '0x8686cb49a95cd78f5fdf916c6f339f1256989967',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x4b322314d6f7239f094f40d93e7d9c4a3081c625',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/ALCX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1662,
        tvlStaking: '20861.49',
        tvlUsd: '20861.49',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3103,
        createdAt: '2024-12-10T21:54:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:29.000Z',
        beacon: '0x55c0074203b8cebba31fdde7489b2dd3a1c93a53',
        calculationConnector: '',
        source: '',
        origin: '0x73d5c2f4eb0e4eb15b3234f8b880a10c553da1ea',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x707ba27189e8bf89e43b2198e6b88aac4720124f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/TAROT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.6075,
        tvlStaking: '588354.82',
        tvlUsd: '588354.82',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3104,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0xbc4b829bc3d4b084ebc7a173b50a746f3efd5a22',
        calculationConnector: '',
        source: '',
        origin: '0x76ec1ef8c0f72ccdfbb661664c6cb0ac187d2fb5',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xf3c45b45223df6071a478851b9c17e0630fdf535',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EXA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0854,
        tvlStaking: '260429.47',
        tvlUsd: '260429.47',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3105,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0xb32d665b48ae1c7170606e2e315ad7c22fa8432e',
        calculationConnector: '',
        source: '',
        origin: '0x580da48a9a6b9e460e3c9806fc920cbec0e5f184',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xf2d3941b6e1cbd3616061e556eb06986147715d1',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HAI/KITE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.085,
        tvlStaking: '71068.28',
        tvlUsd: '71068.28',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3106,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0x20e4bb7a1ba61273a4573080f53977ad6e7993f7',
        calculationConnector: '',
        source: '',
        origin: '0x601827ae1d4d11a84521007e21cfb39c964d5db8',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x62191c893df8d26ac295ba1274a00975dc07190c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/OPP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2718,
        tvlStaking: '88754.89',
        tvlUsd: '88754.89',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3107,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0x016f165dc7d3b62cdddbadd4e1ef27b0f627dab7',
        calculationConnector: '',
        source: '',
        origin: '0x5f049ec8de41446e022b625b1b1fbfa06526b970',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xe0b1da86d17b884c4d246e218a67ae3466ad841c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/PERP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3395,
        tvlStaking: '197232.10',
        tvlUsd: '197232.10',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3108,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0x65a7bc63b32625cd7a5c60bd78f653643282eac9',
        calculationConnector: '',
        source: '',
        origin: '0xd2cd1217fa7d2b2647f1052f128cbad85dd72c4b',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xd5fe49a4c0fc482ee757df703a3a332db209ac2e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HAI/PXETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 2.0731,
        tvlStaking: '34.48',
        tvlUsd: '34.48',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3109,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0x69342034edaaf176539f3e49607e764f3aaca029',
        calculationConnector: '',
        source: '',
        origin: '0xdaaa1681fe853eca38ba5f12b04004841d543c99',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xf4638dc488f9c826dc40250515592e678e447238',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OP/KITE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1729,
        tvlStaking: '21060.39',
        tvlUsd: '21060.39',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3110,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0xa46fd62a971f377b72e015681e9eb9b37ffd4051',
        calculationConnector: '',
        source: '',
        origin: '0x4cb9961b3418e0b96a1b3d38f9be4de4c04889ac',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x3eb92113c00f476512bde4c46920ef0a3d42eb0f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MODE/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 5.2563,
        tvlStaking: '2352.80',
        tvlUsd: '2352.80',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3111,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0xde6f08c026fa323e4337933769b3bb9ae52e2f63',
        calculationConnector: '',
        source: '',
        origin: '0xff6b058484517bf58450dfc4a6eb53f1a2171775',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xa0a215de234276cac1b844fd58901351a50fec8a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1023,
        tvlStaking: '2013488.67',
        tvlUsd: '2013488.67',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3112,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0x0a2a8260dd5cc193c2852fc1a7caa3d7abafbc80',
        calculationConnector: '',
        source: '',
        origin: '0x2637bc0468c6948c7f7d6984a5072f9e2bd66f38',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xdb1fe6da83698885104da02a6e0b3b65c0b0de80',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'POOL/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0593,
        tvlStaking: '177204.57',
        tvlUsd: '177204.57',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3113,
        createdAt: '2024-12-10T21:54:35.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:35.000Z',
        beacon: '0xc9987be70a5d2e20de1f2bcf4e1460ee730841cd',
        calculationConnector: '',
        source: '',
        origin: '0x5a8a27b77d1d85f86de917e912112b44b8596fc9',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xf117719d5460ed6090814213433cb8d4e07bd583',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/EXTRA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1845,
        tvlStaking: '78663.33',
        tvlUsd: '78663.33',
        enabled: true,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3114,
        createdAt: '2024-12-10T21:54:41.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:41.000Z',
        beacon: '0xfb6eb15fbc45c65b5f4860aa502f44d6fa617ebc',
        calculationConnector: '',
        source: '',
        origin: '0x0b09767ba62084ad6db640d9fc7e5e9badaa1bbe',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0xe9b168fa9409eaffa07679196c7568317baf80ed',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'FRAX/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 3115,
        createdAt: '2024-12-10T21:54:41.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-10T21:54:41.000Z',
        beacon: '0x45ef3753c11c9d6e878dc7d6fe8a064d98d40a60',
        calculationConnector: '',
        source: '',
        origin: '0x46234e581b55e6d6324b11d9aca29b94687a7f4c',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x6da87897bb36d0e2bc4e69c407935bcc7fa9d9c9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/DHT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0863,
        tvlStaking: '11839.06',
        tvlUsd: '11839.06',
        enabled: false,
        dexFactory: {
          id: 84728,
          chainId: 10,
          address: '',
          name: 'Velodrome v2',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3137,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x3b0bfacfb57e1fdb2a9c99a801f5959575c339f9',
        calculationConnector: '',
        source: '',
        origin: '0x15d715c142169bf93bc6c8c670c208dc3acce17e',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/SUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3c01ec09d15d5450fc702dc4353b17cd2978d8a5',
        poolV3Fee: 0.0001,
        apr: 0.0856,
        tvlStaking: '22065.04',
        tvlUsd: '22065.04',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3138,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x61f0e3285a33b80e87ba5abde117d89f0505de01',
        calculationConnector: '',
        source: '',
        origin: '0xf5fa0513327f5160dd7d52471d2531eef36f59df',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/MAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3a545744f5d0e9425e34741afd9e388d5d0e6dfb',
        poolV3Fee: 0.003,
        apr: 1.4816,
        tvlStaking: '15574.48',
        tvlUsd: '15574.48',
        enabled: false,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 3139,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x5fa89efaf2472886cddb2069120dc6c424f49b81',
        calculationConnector: '',
        source: '',
        origin: '0x434e3122f5d8d4e6c5b6b7b1dc71cff25f3b5a97',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/CBETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x68387b6647742b11486e65078b39716469572962',
        poolV3Fee: 0.0001,
        apr: 0.016,
        tvlStaking: '11216.75',
        tvlUsd: '11216.75',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3140,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x2229a465e98ac9b48f1a59f3bb6359719f718182',
        calculationConnector: '',
        source: '',
        origin: '0x0b377a418096af18391f25b71489073ed3cd9607',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2fa71491f8070fa644d97b4782db5734854c0f6f',
        poolV3Fee: 0.0001,
        apr: 0.0324,
        tvlStaking: '94346.27',
        tvlUsd: '94346.27',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3141,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x05f0f8f32ebe2bf73f16ba39b5f7eef8f9667211',
        calculationConnector: '',
        source: '',
        origin: '0x8159f9176fbe229c12687e90671caf2965844edf',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfd5f39c74e63f1dace336350afdf11e85bbd56f4',
        poolV3Fee: 0.0001,
        apr: 0.2872,
        tvlStaking: '33410.80',
        tvlUsd: '33410.80',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3142,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x8dddcb372a324b64ac05bf0031a800734bb2c0f7',
        calculationConnector: '',
        source: '',
        origin: '0x23d18fdf7c2b927d73b6743eb672847ab0245cea',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/SDAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x131525f3fa23d65dc2b1eb8b6483a28c43b06916',
        poolV3Fee: 0.0001,
        apr: 0.1964,
        tvlStaking: '126043.13',
        tvlUsd: '126043.13',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3143,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0xaf94448bee976e415a189c1cf650af459082b808',
        calculationConnector: '',
        source: '',
        origin: '0xb2218a2cfef38ca30ae8c88b41f2e2bdd9347e3e',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WSTETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xbf30ff33cf9c6b0c48702ff17891293b002dfea4',
        poolV3Fee: 0.000115,
        apr: 0.0052,
        tvlStaking: '33298628.70',
        tvlUsd: '33298628.70',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3144,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x3a1400aba8bca2941a7928d6863ae70eac1e083b',
        calculationConnector: '',
        source: '',
        origin: '0x12205c343ca851faa9a90fd2f2c1a9a2a0b06719',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/LUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8ac2f9dac7a2852d44f3c09634444d533e4c078e',
        poolV3Fee: 0.0001,
        apr: 6.2897,
        tvlStaking: '1066.14',
        tvlUsd: '1066.14',
        enabled: false,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3145,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x9622577537e65901fcb926f0307dd6273cf3e9f2',
        calculationConnector: '',
        source: '',
        origin: '0xca573537505cce0d03963002e870d74d2cfe8cff',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1737275d53a5ca5dac582a493aa32c85ba2cfad3',
        poolV3Fee: 0.0001,
        apr: 0.0939,
        tvlStaking: '263699.39',
        tvlUsd: '263699.39',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3146,
        createdAt: '2024-12-16T23:16:21.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:21.000Z',
        beacon: '0x466a2c8fe98015ad65885a55ac634a52f3081263',
        calculationConnector: '',
        source: '',
        origin: '0xdda458696f5ef402c9ea16f17abb2295c7090d5b',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WBTC/TBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8949a8e02998d76d7a703cac9ee7e0f529828011',
        poolV3Fee: 0.0001,
        apr: 0.0012,
        tvlStaking: '3590147.36',
        tvlUsd: '3590147.36',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3147,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0x38bb33d1c17813c8e2fb29e601b38a36558b179e',
        calculationConnector: '',
        source: '',
        origin: '0xc762d18800b3f78ae56e9e61ad7be98a413d59de',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x84ce89b4f6f67e523a81a82f9f2f14d84b726f6b',
        poolV3Fee: 0.0001,
        apr: 0.0281,
        tvlStaking: '562410.91',
        tvlUsd: '562410.91',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3148,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0x72cfb8adc1ec3b7768fcb7630447172007706e13',
        calculationConnector: '',
        source: '',
        origin: '0x08779c120ef897ca0565059f8e60efc2ccd2a98e',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WBTC/UNIBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xd4bee5632960572c83f66f5a5a32b8d8d49355ae',
        poolV3Fee: 0.0001,
        apr: 0.1898,
        tvlStaking: '2025.93',
        tvlUsd: '2025.93',
        enabled: false,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3149,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0xb6247156729e799ffc948807f164776d77c433ae',
        calculationConnector: '',
        source: '',
        origin: '0x0bc14c45ada63fee25a23c5fed1007798cd11e0d',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WSTETH/EZETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb71ac980569540ce38195b38369204ff555c80be',
        poolV3Fee: 0.0001,
        apr: 0.002,
        tvlStaking: '178233.79',
        tvlUsd: '178233.79',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3150,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0xefc2420467f50952febf1befe629ec25e09e1826',
        calculationConnector: '',
        source: '',
        origin: '0x863cacdcfc16517790f4436ac7ca4fc916b53a80',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1d72b49f81832ef8155d8dedfce9cd122367e3b3',
        poolV3Fee: 0.0005,
        apr: 0.6772,
        tvlStaking: '15047.79',
        tvlUsd: '15047.79',
        enabled: false,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3151,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0x3e28b678970de2c11e8dd09c02a3b838d8d126cc',
        calculationConnector: '',
        source: '',
        origin: '0xa561da1dcd64cdb52049398900de36f0205a31a2',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/LUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xbafb44286c5ecafb1f26a6649e15c49fc1c49882',
        poolV3Fee: 0.0005,
        apr: 8.2593,
        tvlStaking: '253.89',
        tvlUsd: '253.89',
        enabled: false,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3152,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0x6c7c565972c602c64ed9d69d4117892b04f59a2f',
        calculationConnector: '',
        source: '',
        origin: '0xf88561fe937a6190ffc488d18ac844b3025ee700',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9da9d8dcdac3cab214d2bd241c3835b90aa8ffde',
        poolV3Fee: 0.0004,
        apr: 0.5905,
        tvlStaking: '17912.53',
        tvlUsd: '17912.53',
        enabled: false,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3153,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0x5e74769b10e256b9e543425f149348b3aaa82e4d',
        calculationConnector: '',
        source: '',
        origin: '0xded023b976de3bbe6aea56678564e992113f8ea1',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/WSTETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xee1bac98527a9fdd57fccf967817215b083ce1f0',
        poolV3Fee: 0.000775,
        apr: 0.3675,
        tvlStaking: '371725.64',
        tvlUsd: '371725.64',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3154,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0x6a6b66ed8a84c31f212aa563c750ce99cb92c77d',
        calculationConnector: '',
        source: '',
        origin: '0xa75127121d28a9bf848f3b70e7eea26570aa7700',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x478946bcd4a5a22b316470f5486fafb928c0ba25',
        poolV3Fee: 0.00076,
        apr: 0.9288,
        tvlStaking: '2697272.72',
        tvlUsd: '2697272.72',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3155,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0x9c9ec1c31d55a72285b072442f660b509fe97679',
        calculationConnector: '',
        source: '',
        origin: '0xcf2a0adade4138d7ea6ebc4c143dbe4c98d9a65a',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/WBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x319c0dd36284ac24a6b2bee73929f699b9f48c38',
        poolV3Fee: 0.0005,
        apr: 0.1946,
        tvlStaking: '821403.58',
        tvlUsd: '821403.58',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: true,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3156,
        createdAt: '2024-12-16T23:16:29.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:29.000Z',
        beacon: '0xd4a59cd207c8e20f9679582183e82f2c83d5078d',
        calculationConnector: '',
        source: '',
        origin: '0x94b3e34950c756cfe0cb2c9de2749b164d80ecc5',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/TBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xec3d9098bd40ec741676fc04d4bd26bccf592aa3',
        poolV3Fee: 0.003,
        apr: 0.2358,
        tvlStaking: '637464.31',
        tvlUsd: '637464.31',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: true,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3157,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0x9cb71d0874b7ebf6a4740142476b59eafb6f7589',
        calculationConnector: '',
        source: '',
        origin: '0x5a11170e36037618035e1778bbf652ea09ea8bed',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xebd5311bea1948e1441333976eadcfe5fbda777c',
        poolV3Fee: 0.0027,
        apr: 0.2414,
        tvlStaking: '1579010.65',
        tvlUsd: '1579010.65',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3158,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0x8f7c81ddb3d673cefafb7e748e77288b7297dc8f',
        calculationConnector: '',
        source: '',
        origin: '0xa94fd4d173b30966847883a8c021fb9a4b5c6021',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WSTETH/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe5cf854f63152067059afd38e03fefb6cbe25df3',
        poolV3Fee: 0.003,
        apr: 0.1591,
        tvlStaking: '352366.01',
        tvlUsd: '352366.01',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3159,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0x68fb8d2cb79d7c609ace8bda36033e2779fffa8a',
        calculationConnector: '',
        source: '',
        origin: '0x5b3fa026036ec92cb8654ccba8cf6bfc9747659a',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/OP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4dc22588ade05c40338a9d95a6da9dcee68bcd60',
        poolV3Fee: 0.00077,
        apr: 0.375,
        tvlStaking: '2570622.62',
        tvlUsd: '2570622.62',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3160,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0x35de9b7378a4699e1612401181ca3971e83d3d93',
        calculationConnector: '',
        source: '',
        origin: '0x2943e5347bdb7c371143686a241770d7cadcb9c2',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'TBTC/T',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3ea594548afabfb27e314e766f06d2dff819bb56',
        poolV3Fee: 0.003,
        apr: 106.1638,
        tvlStaking: '250.40',
        tvlUsd: '250.40',
        enabled: false,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3161,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0x39ecbaddb11a2d0368659761b3a632a272aa7944',
        calculationConnector: '',
        source: '',
        origin: '0x41160e66fcaa10cbb148ace60bc2a22d609ec519',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/MOOBIFI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x173cdc71e29d5cffa6d090ad99f555a24b8831f9',
        poolV3Fee: 0.01,
        apr: 0.1978,
        tvlStaking: '197682.00',
        tvlUsd: '197682.00',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3162,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0xc369c43a28b4ad9e4a76acbf273936ca05e35a62',
        calculationConnector: '',
        source: '',
        origin: '0xc8c7b5ae61d97be7d02d606629059487066dc9cf',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x7cfc2da3ba598ef4de692905fedca32565ab836e',
        poolV3Fee: 0.003,
        apr: 2.3769,
        tvlStaking: '144581.96',
        tvlUsd: '144581.96',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3163,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0x9fec2165b015322cfdebba67ebfd588a5027a54a',
        calculationConnector: '',
        source: '',
        origin: '0x6a3bd3ad6698ae8024cc55aa985701502d519982',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x39ed27d101aa4b7ce1cb4293b877954b8b5e14e5',
        poolV3Fee: 0.003,
        apr: 0.682,
        tvlStaking: '932119.83',
        tvlUsd: '932119.83',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3164,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0x4a104739f599e31e6002a181431d64d760a522e5',
        calculationConnector: '',
        source: '',
        origin: '0xf93be583b4a2b6209ab2e9b8d83b54f72b1b04ef',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/SNX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf25bbc18a607bbe218c87ba1ff0e673d9b53dd58',
        poolV3Fee: 0.003,
        apr: 0.2147,
        tvlStaking: '186043.11',
        tvlUsd: '186043.11',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3165,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0xe257bd3c31e8d9f28924ca67b3a5de7425adc6fb',
        calculationConnector: '',
        source: '',
        origin: '0x5a860991eaccb154b23cc6531944d5cc95eb3687',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/WLD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4e5541815227e3272c405886149f45d2f437c7ff',
        poolV3Fee: 0.0027,
        apr: 5.9632,
        tvlStaking: '40215.57',
        tvlUsd: '40215.57',
        enabled: true,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3166,
        createdAt: '2024-12-16T23:16:39.000Z',
        chainId: 10,
        dateOfAdd: '2024-12-16T23:16:39.000Z',
        beacon: '0xbb0db4da573ee9fe2c6dfd78bba092c760bddd2a',
        calculationConnector: '',
        source: '',
        origin: '0xc8e920afba0ff326ec45f35e6ec3c387570ceba8',
        vaultFactoryId: 37,
        rewardTokens: ['0x9560e827af36c94d2ac33a39bce1fe78631088db'],
        rewardTokenType: '',
        stakingToken: '0x416b433906b1b72fa758e166e239c43d68dc6f29',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/KWENTA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x522dc96e6fd6f78a4e7433d0ee05b7087e515236',
        poolV3Fee: 0.01,
        apr: 0.4022,
        tvlStaking: '4690.71',
        tvlUsd: '4690.71',
        enabled: false,
        dexFactory: {
          id: 95122,
          chainId: 10,
          address: '',
          name: 'Velodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
    ],
    profitClaimer: '0x2da67ab2e56a68a6dfcfb8cd6f22362c87637bdf',
  },
  {
    id: 38,
    factory: '0x9b7e30644a9b37eebaa7158129b03f5a3088659d',
    chainId: 250,
    name: 'fantom',
    enabled: true,
    migrator: '0xc28440c54c01f8bd1067ac7b40c4358d5031dd29',
    zapper: '0x7a48008cdf83dad2cf22ce0708e9db754b5356ba',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.055',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0x070e3526b408a0554ddf8eaec3e5e27aaf12f98a',
      '0xe5597c5fe0c7b46a50e2077712cb8a03c8291e65',
    ],
    underlyingZapperTokensWl: [
      '0x28a92dde19d9989f39a49905d7c9c2fac7799bdf',
      '0x049d68029688eabf473097a2fc38ef61633a3c7a',
    ],
    farms: [
      {
        id: 263,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x802be84ed8972be070e65277494dda9523a9f689',
        calculationConnector: '',
        source: '',
        origin: '0x18b4f774fdc7bf685daeef66c2990b1ddd9ea6ad',
        vaultFactoryId: 38,
        rewardTokens: ['0x841fad6eae12c286d1fd18d1d525dffa75c7effe'],
        rewardTokenType: '',
        stakingToken: '0xec7178f4c41f346b2721907f5cf7628e388a7a58',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/BOO',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0001,
        tvlStaking: '1460355.88',
        tvlUsd: '1460355.88',
        enabled: false,
        dexFactory: {
          id: 84721,
          chainId: 250,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 264,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x16ba914b05a35cf15e1cef083b8b2cea3a604827',
        calculationConnector: '',
        source: '',
        origin: '0x18b4f774fdc7bf685daeef66c2990b1ddd9ea6ad',
        vaultFactoryId: 38,
        rewardTokens: ['0x841fad6eae12c286d1fd18d1d525dffa75c7effe'],
        rewardTokenType: '',
        stakingToken: '0x6f86e65b255c9111109d2d2325ca2dfc82456efc',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/MIM',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 3e-5,
        tvlStaking: '59096.42',
        tvlUsd: '59096.42',
        enabled: false,
        dexFactory: {
          id: 84721,
          chainId: 250,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 268,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xd1ef55e31702e61765a560e0db9b13b83905785c',
        calculationConnector: '',
        source: '',
        origin: '0x9c9c920e51778c4abf727b8bb223e78132f00aa4',
        vaultFactoryId: 38,
        rewardTokens: [
          '0x841fad6eae12c286d1fd18d1d525dffa75c7effe',
          '0x1b6382dbdea11d97f24495c9a90b7c88469134a4',
        ],
        rewardTokenType: '',
        stakingToken: '0xa196c7754f4ec79de55bb5db82187bbe82275f7f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AXLUSDC/WFTM',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0004,
        tvlStaking: '79431.77',
        tvlUsd: '79431.77',
        enabled: false,
        dexFactory: {
          id: 84721,
          chainId: 250,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 269,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x3a75d337d4eb65c85988e2e4eede5b0a1494b7e6',
        calculationConnector: '',
        source: '',
        origin: '0x9c9c920e51778c4abf727b8bb223e78132f00aa4',
        vaultFactoryId: 38,
        rewardTokens: [
          '0x841fad6eae12c286d1fd18d1d525dffa75c7effe',
          '0x28a92dde19d9989f39a49905d7c9c2fac7799bdf',
        ],
        rewardTokenType: '',
        stakingToken: '0x90469acbc4b6d877873cd4f1cca54fde8075a998',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '20321.83',
        tvlUsd: '20321.83',
        enabled: false,
        dexFactory: {
          id: 84721,
          chainId: 250,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 271,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xca33651aa7ff26b863a4e78f01757da097bd35a8',
        calculationConnector: '',
        source: '',
        origin: '0x863730009c8e1a460e244ce8cf71f56783f517c3',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x3d6c56f6855b7cc746fb80848755b0a9c3770122',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/EQUAL',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1151,
        tvlStaking: '5402034.37',
        tvlUsd: '5402034.37',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 272,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x5141c1cc13e303101abb9f3ab2338b2338581095',
        calculationConnector: '',
        source: '',
        origin: '0x2cefc62fa6959867b34d417b1b1d714ec6529148',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x77cfee25570b291b0882f68bac770abf512c2b5c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AXLUSDC/WFTM',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1191,
        tvlStaking: '188985.34',
        tvlUsd: '188985.34',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 273,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x7f6b4d856b26fb2ca8db67af05664082b5b8f66b',
        calculationConnector: '',
        source: '',
        origin: '0x4cd7d49c8f15debe4962dca788e47265dadcdd3b',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0xa300ba34abb9e1c08b7b72fb481aa0a8d714f45d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/BAY',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 274,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xab77aa00896b9350352343287622a2de96876a11',
        calculationConnector: '',
        source: '',
        origin: '0x2f059b4093d808c95afc49b3d27a0c19a8f80b1c',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x99b7daaf2468edcfbadd67df9bcea14d1a030675',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/TAROT',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1296,
        tvlStaking: '524287.26',
        tvlUsd: '524287.26',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 275,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x96fd46da758a00c64ead0dce283a004b68216d3a',
        calculationConnector: '',
        source: '',
        origin: '0xb42d237b033dca3b5f02a170e239ab5205acd26f',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0xffe9c27f0a12dabe5c5bd46d144a5c0140725566',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/DEUS',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.3081,
        tvlStaking: '7896.31',
        tvlUsd: '7896.31',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 355,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x2f569c25b4fde4650b95e7c55f48af6137c4eaf4',
        calculationConnector: '',
        source: '',
        origin: '0x863730009c8e1a460e244ce8cf71f56783f517c3',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x3d6c56f6855b7cc746fb80848755b0a9c3770122',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/EQUAL',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1585,
        tvlStaking: '28032.31',
        tvlUsd: '28032.31',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 356,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xdd94bad3d76c878bd1d653cb34d41dbacda08906',
        calculationConnector: '',
        source: '',
        origin: '0x2cefc62fa6959867b34d417b1b1d714ec6529148',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x77cfee25570b291b0882f68bac770abf512c2b5c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AXLUSDC/WFTM',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0564,
        tvlStaking: '4311.23',
        tvlUsd: '4311.23',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 357,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x77732feefc9c6f906095b55fafadb9fa53dacd30',
        calculationConnector: '',
        source: '',
        origin: '0x4cd7d49c8f15debe4962dca788e47265dadcdd3b',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0xa300ba34abb9e1c08b7b72fb481aa0a8d714f45d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/BAY',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 358,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x32386ce071278c7551e1274b8514676211a32c5b',
        calculationConnector: '',
        source: '',
        origin: '0x2f059b4093d808c95afc49b3d27a0c19a8f80b1c',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x99b7daaf2468edcfbadd67df9bcea14d1a030675',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/TAROT',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.072,
        tvlStaking: '19752.10',
        tvlUsd: '19752.10',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 359,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x8bfca652af31f8154fc72fe254c17ce214fb1f4f',
        calculationConnector: '',
        source: '',
        origin: '0xb42d237b033dca3b5f02a170e239ab5205acd26f',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0xffe9c27f0a12dabe5c5bd46d144a5c0140725566',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/DEUS',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.3081,
        tvlStaking: '7896.31',
        tvlUsd: '7896.31',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 360,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xe2a326918f853cdceb591063087d76d83143a187',
        calculationConnector: '',
        source: '',
        origin: '0x863730009c8e1a460e244ce8cf71f56783f517c3',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x3d6c56f6855b7cc746fb80848755b0a9c3770122',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/EQUAL',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1151,
        tvlStaking: '5402034.37',
        tvlUsd: '5402034.37',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 361,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xa110df00277a6ae4fbd83853793c630bdc68fe79',
        calculationConnector: '',
        source: '',
        origin: '0x2cefc62fa6959867b34d417b1b1d714ec6529148',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x77cfee25570b291b0882f68bac770abf512c2b5c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AXLUSDC/WFTM',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1191,
        tvlStaking: '188985.34',
        tvlUsd: '188985.34',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 362,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xff9dd8117599a8c1e173e3d4d82ff51824a89e50',
        calculationConnector: '',
        source: '',
        origin: '0x4cd7d49c8f15debe4962dca788e47265dadcdd3b',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0xa300ba34abb9e1c08b7b72fb481aa0a8d714f45d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/BAY',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 363,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x71b1ae58a43641888f24808d5b2baaa189e225a6',
        calculationConnector: '',
        source: '',
        origin: '0x2f059b4093d808c95afc49b3d27a0c19a8f80b1c',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x99b7daaf2468edcfbadd67df9bcea14d1a030675',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/TAROT',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1296,
        tvlStaking: '524287.26',
        tvlUsd: '524287.26',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 364,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x54ef85b6c2f2b56faa88439a08188dade175d3a3',
        calculationConnector: '',
        source: '',
        origin: '0xb42d237b033dca3b5f02a170e239ab5205acd26f',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0xffe9c27f0a12dabe5c5bd46d144a5c0140725566',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/DEUS',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.3081,
        tvlStaking: '7896.31',
        tvlUsd: '7896.31',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 365,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0x3a939dd0210561a2131a672cae7f1a209578d2f3',
        calculationConnector: '',
        source: '',
        origin: '0x863730009c8e1a460e244ce8cf71f56783f517c3',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x3d6c56f6855b7cc746fb80848755b0a9c3770122',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/EQUAL',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1151,
        tvlStaking: '5402034.37',
        tvlUsd: '5402034.37',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 386,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xe309910c337022ed25418aefb4024d5cf70f6832',
        calculationConnector: '',
        source: '',
        origin: '0x2f059b4093d808c95afc49b3d27a0c19a8f80b1c',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0x99b7daaf2468edcfbadd67df9bcea14d1a030675',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/TAROT',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1296,
        tvlStaking: '524287.26',
        tvlUsd: '524287.26',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 489,
        createdAt: '',
        chainId: 250,
        dateOfAdd: '',
        beacon: '0xeccf32c9e0ba843fa844b796aefb4ee6cec2f24e',
        calculationConnector: '',
        source: '',
        origin: '0xb42d237b033dca3b5f02a170e239ab5205acd26f',
        vaultFactoryId: 38,
        rewardTokens: ['0x3fd3a0c85b70754efc07ac9ac0cbbdce664865a6'],
        rewardTokenType: '',
        stakingToken: '0xffe9c27f0a12dabe5c5bd46d144a5c0140725566',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WFTM/DEUS',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.6701,
        tvlStaking: '3630.57',
        tvlUsd: '3630.57',
        enabled: false,
        dexFactory: {
          id: 84723,
          chainId: 250,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
    ],
    profitClaimer: '0x7a3b299e9cbcb01610c223f103033a5feb213b6a',
  },
  {
    id: 39,
    factory: '0x6b714e6296b8b977e1d5ecb595197649e10a3db1',
    chainId: 43114,
    name: 'avax',
    enabled: true,
    migrator: '0x1cb869012ea16130d443a553eef98309add87a79',
    zapper: '0x8164d00123cc6f6953a67cd1cb2df35d4c6f4976',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.055',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0xb3dbd4d49b88786ba0432154407d8852e417b052',
      '0x4f994e49cbf6187a3e1970c7179f1dc5d3b6cd91',
      '0xc99ed38eee442fbfbe1c8c84fee10191ff6bc149',
    ],
    underlyingZapperTokensWl: [
      '0xc7198437980c041c805a1edcba50c1ce5db95118',
      '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
    ],
    farms: [
      {
        id: 373,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x2d312270ab996bfde151e2930fdc43d2bcc1e42d',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0xe28984e1ee8d431346d32bec9ec800efb643eef4',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WAVAX/USDT.E',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 11.2238,
        tvlStaking: '123821.96',
        tvlUsd: '123821.96',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 374,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0xeb7235f6b45a91236475e1d373421cc99242a2e0',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0x7c05d54fc5cb6e4ad87c6f5db3b807c94bb89c52',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH.E/WAVAX',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 1.009,
        tvlStaking: '1283264.06',
        tvlUsd: '1283264.06',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 375,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x56eb1be90899c560d1ba73a62da2a4f6a4094995',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0xbd918ed441767fe7924e99f6a0e0b568ac1970d9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC.E/WAVAX',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 11.806,
        tvlStaking: '181858.71',
        tvlUsd: '181858.71',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 376,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x21bd85c88c9548ccd5df91d3e3d6cf16530aad34',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0x5875c368cddd5fb9bf2f410666ca5aad236dabd4',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'LINK.E/WAVAX',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.7949,
        tvlStaking: '296146.46',
        tvlUsd: '296146.46',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 378,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0xe45a0e96fcd66ca1489f895c015c75129b285b64',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0xe530dc2095ef5653205cf5ea79f8979a7028065c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'QI/WAVAX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.1614,
        tvlStaking: '439183.46',
        tvlUsd: '439183.46',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 379,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x37daae80f1545b2515512586c63d55c6ded706a3',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0x8a9c36bc3ced5ecce703a4da8032218dfe72fe86',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC.E/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.812,
        tvlStaking: '169115.07',
        tvlUsd: '169115.07',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 380,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x05a3e1545b361255f11af85eabbcb69011a3c2ce',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0x0e0100ab771e9288e0aa97e11557e6654c3a9665',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WAVAX/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 7.0074,
        tvlStaking: '780151.98',
        tvlUsd: '780151.98',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 381,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x058b60d746dcbaadaa41b44c0cafd0dd92b48ad9',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0x1784b2ff6841d46163fbf817b3feb98a0e163e0f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'PNG/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.9892,
        tvlStaking: '277658.88',
        tvlUsd: '277658.88',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 382,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0xb14a70f24f346fc41edd841102fc461e5f85a678',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0xe3ba3d5e3f98eeff5e9eddd5bd20e476202770da',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDT/WAVAX',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 11.1276,
        tvlStaking: '219180.18',
        tvlUsd: '219180.18',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 383,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x7ba8c9e7be886a19d19f35adc1c2147e3cbf04b0',
        calculationConnector: '',
        source: '',
        origin: '0x1f806f7c8ded893fd3cae279191ad7aa3798e928',
        vaultFactoryId: 39,
        rewardTokens: ['0x60781c2586d68229fde47564546784ab3faca982'],
        rewardTokenType: '',
        stakingToken: '0x9d86243ae7008ec1f9cce83c49d76f7a557b80cf',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBTC.E/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 5.3319,
        tvlStaking: '62550.54',
        tvlUsd: '62550.54',
        enabled: false,
        dexFactory: {
          id: 84729,
          chainId: 43114,
          address: '',
          name: 'Pangolin',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 384,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x1dd7cbbcf549de2113602704b0bd34351cb439e6',
        calculationConnector: '',
        source: '',
        origin: '0xe68b719edb685d63c58a133005f0fb307eb5f289',
        vaultFactoryId: 39,
        rewardTokens: ['0x3712871408a829c5cd4e86da1f4ce727efcd28f6'],
        rewardTokenType: '',
        stakingToken: '0xa13403733db5c101490436cfff012f6ac93a6097',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'YAK/WAVAX',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.4473,
        tvlStaking: '1674.67',
        tvlUsd: '1674.67',
        enabled: false,
        dexFactory: {
          id: 84730,
          chainId: 43114,
          address: '',
          name: 'Glacier',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 385,
        createdAt: '',
        chainId: 43114,
        dateOfAdd: '',
        beacon: '0x7e67ddd84ef777bea207fcee71325500b62cdcce',
        calculationConnector: '',
        source: '',
        origin: '0xb8ef1caf4a1a0c3d69724657b179c8836da1737d',
        vaultFactoryId: 39,
        rewardTokens: ['0x3712871408a829c5cd4e86da1f4ce727efcd28f6'],
        rewardTokenType: '',
        stakingToken: '0x2071a39da7450d68e4f4902774203df208860da2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'GLCR/WAVAX',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0493,
        tvlStaking: '385.36',
        tvlUsd: '385.36',
        enabled: false,
        dexFactory: {
          id: 84730,
          chainId: 43114,
          address: '',
          name: 'Glacier',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1187,
        createdAt: '2024-03-15T09:43:50.000Z',
        chainId: 43114,
        dateOfAdd: '2024-03-15T09:43:50.000Z',
        beacon: '0xe6e508f260dbcb4db9106d1d44fb0b9524d705d0',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 39,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x655c406ebfa14ee2006250925e54ec43ad184f8b',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDT/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x804226ca4edb38e7ef56d16d16e92dc3223347a0',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '181563.00',
        tvlUsd: '181563.00',
        enabled: true,
        dexFactory: {
          id: 95083,
          chainId: 43114,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1188,
        createdAt: '2024-03-15T09:43:50.000Z',
        chainId: 43114,
        dateOfAdd: '2024-03-15T09:43:50.000Z',
        beacon: '0x8709ad1356ad8fc653759a40479f18b9c67153db',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 39,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x655c406ebfa14ee2006250925e54ec43ad184f8b',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH.E/WAVAX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x7b602f98d71715916e7c963f51bfebc754ade2d0',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '3504039.06',
        tvlUsd: '3504039.06',
        enabled: true,
        dexFactory: {
          id: 95083,
          chainId: 43114,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1189,
        createdAt: '2024-03-15T09:43:50.000Z',
        chainId: 43114,
        dateOfAdd: '2024-03-15T09:43:50.000Z',
        beacon: '0x9c8cf50c5af04a8d5fd5fd22fe62f2c6d83a76c1',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 39,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x655c406ebfa14ee2006250925e54ec43ad184f8b',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WAVAX/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfae3f424a0a47706811521e3ee268f00cfb5c45e',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '12605276.23',
        tvlUsd: '12605276.23',
        enabled: true,
        dexFactory: {
          id: 95083,
          chainId: 43114,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1190,
        createdAt: '2024-03-15T09:43:50.000Z',
        chainId: 43114,
        dateOfAdd: '2024-03-15T09:43:50.000Z',
        beacon: '0xe035ddcac8cd71146da847338ca5a30c25ef7219',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 39,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x655c406ebfa14ee2006250925e54ec43ad184f8b',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WAVAX/XAVA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x94e909ca096e2add53c01a0aab3e7d63e9b7e313',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1015.57',
        tvlUsd: '1015.57',
        enabled: false,
        dexFactory: {
          id: 95083,
          chainId: 43114,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
    ],
    profitClaimer: '0x95db83cad7c78fb411f1ecb4b99ed2dff156b61e',
  },
  {
    id: 40,
    factory: '0x714c94b9820d7d73e61510e4c18b91f995a895c1',
    chainId: 8453,
    name: 'base',
    enabled: true,
    migrator: '0x8e3b66ed6865ce6ac5a9c64e5099e86c7cdab6be',
    zapper: '0x9c66a9008e55a7557fb457607f3f028762326a4a',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.055',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0x11d3c371ce50a93fcff4c0b7fe7e3dc8703c907e',
      '0x6304ff0ce5e63d1530f66059f05326e949e354d1',
      '0xade7015bc4a63d4df15c3311ad6bdd87024ad58f',
    ],
    underlyingZapperTokensWl: [
      '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
    ],
    farms: [
      {
        id: 452,
        createdAt: '2023-12-15T10:58:07.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-15T10:58:07.000Z',
        beacon: '0x84b4280be0f39ebfd647adc0b07f806d4d0187d1',
        calculationConnector: '',
        source: '',
        origin: '0x52eaecac2402633d98b95213d0b473e069d86590',
        vaultFactoryId: 40,
        rewardTokens: ['0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4'],
        rewardTokenType: '',
        stakingToken: '0x9bb646bf0f4da44bfaf3d899e774de065731edfe',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'CBETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.033,
        tvlStaking: '6340653.90',
        tvlUsd: '6340653.90',
        enabled: true,
        dexFactory: {
          id: 84732,
          chainId: 8453,
          address: '',
          name: 'Alienbase',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 453,
        createdAt: '2023-12-15T10:58:07.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-15T10:58:07.000Z',
        beacon: '0x57322aa5ae2e8e0152de619a2ce6730e52a14b71',
        calculationConnector: '',
        source: '',
        origin: '0x52eaecac2402633d98b95213d0b473e069d86590',
        vaultFactoryId: 40,
        rewardTokens: ['0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4'],
        rewardTokenType: '',
        stakingToken: '0xd97a40434627d5c897790de9a3d2e577cba5f2e0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DAI+/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '32128.25',
        tvlUsd: '32128.25',
        enabled: false,
        dexFactory: {
          id: 84732,
          chainId: 8453,
          address: '',
          name: 'Alienbase',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 454,
        createdAt: '2023-12-15T10:58:07.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-15T10:58:07.000Z',
        beacon: '0x5c5f821e1cb3f688bd9813142900f5fcd3876bb8',
        calculationConnector: '',
        source: '',
        origin: '0x52eaecac2402633d98b95213d0b473e069d86590',
        vaultFactoryId: 40,
        rewardTokens: ['0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4'],
        rewardTokenType: '',
        stakingToken: '0xef24722d5dae32dc155d961561cffbc5f347eee7',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '128650.07',
        tvlUsd: '128650.07',
        enabled: true,
        dexFactory: {
          id: 84732,
          chainId: 8453,
          address: '',
          name: 'Alienbase',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 455,
        createdAt: '2023-12-15T10:58:53.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-15T10:58:53.000Z',
        beacon: '0x2385b629219cb86088e2a54139f0424549006497',
        calculationConnector: '',
        source: '',
        origin: '0x52eaecac2402633d98b95213d0b473e069d86590',
        vaultFactoryId: 40,
        rewardTokens: ['0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4'],
        rewardTokenType: '',
        stakingToken: '0x553666081db0a8fdb337560009932852059d589a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USD+/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '45613.64',
        tvlUsd: '45613.64',
        enabled: false,
        dexFactory: {
          id: 84732,
          chainId: 8453,
          address: '',
          name: 'Alienbase',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 456,
        createdAt: '2023-12-15T10:58:53.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-15T10:58:53.000Z',
        beacon: '0xf39ecfc0c7330479a4bc2a1846a7f09675002ef6',
        calculationConnector: '',
        source: '',
        origin: '0x52eaecac2402633d98b95213d0b473e069d86590',
        vaultFactoryId: 40,
        rewardTokens: ['0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4'],
        rewardTokenType: '',
        stakingToken: '0xacbff2edbcf8089adec9706ff3cb6df2502a30e1',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDBC/AXLUSDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '25656.01',
        tvlUsd: '25656.01',
        enabled: false,
        dexFactory: {
          id: 84732,
          chainId: 8453,
          address: '',
          name: 'Alienbase',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 457,
        createdAt: '2023-12-15T10:58:53.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-15T10:58:53.000Z',
        beacon: '0x2d90202279b15a7e8b9d1624efd0dbda195aae50',
        calculationConnector: '',
        source: '',
        origin: '0x52eaecac2402633d98b95213d0b473e069d86590',
        vaultFactoryId: 40,
        rewardTokens: ['0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4'],
        rewardTokenType: '',
        stakingToken: '0xd79ef386f26e40b5e60e4aeb324f2678f6ebbf49',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ALB/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0857,
        tvlStaking: '122181.71',
        tvlUsd: '122181.71',
        enabled: true,
        dexFactory: {
          id: 84732,
          chainId: 8453,
          address: '',
          name: 'Alienbase',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 458,
        createdAt: '2023-12-20T10:21:23.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:21:23.000Z',
        beacon: '0x0031543f2fa3e0022688470f63e7a3aeabaa58f5',
        calculationConnector: '',
        source: '',
        origin: '0xeca7ff920e7162334634c721133f3183b83b0323',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xb4885bc63399bf5518b994c1d0c153334ee579d0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.1603,
        tvlStaking: '396240.07',
        tvlUsd: '396240.07',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 459,
        createdAt: '2023-12-20T10:21:23.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:21:23.000Z',
        beacon: '0x22464a3c443d965de895b33399e1afd2097c87be',
        calculationConnector: '',
        source: '',
        origin: '0xeae066c25106006fb386a3a8b1698a0cb6931c1a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x0b25c51637c43decd6cc1c1e3da4518d54ddb528',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DOLA/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0029,
        tvlStaking: '399326.20',
        tvlUsd: '399326.20',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 460,
        createdAt: '2023-12-20T10:21:23.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:21:23.000Z',
        beacon: '0xd15a0cafc0553a99d865e48989d8b899195a2879',
        calculationConnector: '',
        source: '',
        origin: '0xdf7c8f17ab7d47702a4a4b6d951d2a4c90f99bf4',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xa6385c73961dd9c58db2ef0c4eb98ce4b60651e8',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/WSTETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.002,
        tvlStaking: '1507461.68',
        tvlUsd: '1507461.68',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 461,
        createdAt: '2023-12-20T10:21:23.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:21:23.000Z',
        beacon: '0x8dfd0fd3f52bed848f1cf47da3df7cffe8cae2e2',
        calculationConnector: '',
        source: '',
        origin: '0x87803cb321624921cedaad4555f07daa0d1ed325',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x1b05e4e814b3431a48b8164c41eac834d9ce2da6',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DAI+/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1016,
        tvlStaking: '10104.68',
        tvlUsd: '10104.68',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 462,
        createdAt: '2023-12-20T10:21:23.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:21:23.000Z',
        beacon: '0x35874b61b69e61a7da09c84a611a46a706864185',
        calculationConnector: '',
        source: '',
        origin: '0x9a202c932453fb3d04003979b121e80e5a14ee7b',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x2223f9fe624f69da4d8256a7bcc9104fba7f8f75',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AERO/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.1332,
        tvlStaking: '677882.35',
        tvlUsd: '677882.35',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 463,
        createdAt: '2023-12-20T10:21:23.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:21:23.000Z',
        beacon: '0x0dec5beed15beb42658ac9f6a45a8e61ad49ccd9',
        calculationConnector: '',
        source: '',
        origin: '0x025137c819298654162de2609f407514de4bb027',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xb5e331615fdba7df49e05cdeaceb14acdd5091c3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HYUSD/EUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1164,
        tvlStaking: '3666136.35',
        tvlUsd: '3666136.35',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 464,
        createdAt: '2023-12-20T10:21:23.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:21:23.000Z',
        beacon: '0xfc6b9a72312c5efb09d1b77a8e61b0dafaa881dc',
        calculationConnector: '',
        source: '',
        origin: '0xdf9d427711cce46b52feb6b2a20e4aeaea12b2b7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x44ecc644449fc3a9858d2007caa8cfaa4c561f91',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'CBETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0025,
        tvlStaking: '350401.05',
        tvlUsd: '350401.05',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 465,
        createdAt: '2023-12-20T10:21:23.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:21:23.000Z',
        beacon: '0x5b48d41201308fdb83f9a68aed89a380b3c81ffd',
        calculationConnector: '',
        source: '',
        origin: '0xf64957c35409055776c7122ac655347ef88eaf9b',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x3fc28bfac25fc8e93b5b2fc15efbbd5a8aa44efe',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WUSDR/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0641,
        tvlStaking: '99387.73',
        tvlUsd: '99387.73',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 466,
        createdAt: '2023-12-20T10:22:55.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:22:55.000Z',
        beacon: '0xdc35f985fcf8f70e56ee88930957aa588ce67e94',
        calculationConnector: '',
        source: '',
        origin: '0xc01e2ff20501839db7b28f5cb3ed2876fea3d6b1',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xf6aec4f97623e691a9426a69baf5501509fca05d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MAI/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1886,
        tvlStaking: '7589.39',
        tvlUsd: '7589.39',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 467,
        createdAt: '2023-12-20T10:22:55.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:22:55.000Z',
        beacon: '0xedd6cbf0beb4ae4fb23cfff1c00e2b29128f7ee3',
        calculationConnector: '',
        source: '',
        origin: '0xcea0a2228145d0fd25de083e3786ddb1ea184296',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xffa3f8737c39e36dec4300b162c2153c67c8352f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/WELL',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.2285,
        tvlStaking: '50894.44',
        tvlUsd: '50894.44',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 468,
        createdAt: '2023-12-20T10:22:55.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:22:55.000Z',
        beacon: '0xf8c4abf9818cf1e33f451db8d398f998ddc6a805',
        calculationConnector: '',
        source: '',
        origin: '0xfae8c18d83655fbf31af10d2e9a1ad5ba77d0377',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x2722c8f9b5e2ac72d1f225f8e8c990e449ba0078',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TBTC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0662,
        tvlStaking: '358091.69',
        tvlUsd: '358091.69',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 469,
        createdAt: '2023-12-20T10:22:55.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:22:55.000Z',
        beacon: '0xaead5637f03516f9a65253a8ec0de758a4ef6b3d',
        calculationConnector: '',
        source: '',
        origin: '0x1457da0dcbe22249408bb2d1e24bd2f1484d7620',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x5bfb340fa9305abb164fb0248d0d82fc3d82c3bb',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EUSD/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1046,
        tvlStaking: '671.86',
        tvlUsd: '671.86',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 470,
        createdAt: '2023-12-20T10:22:55.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:22:55.000Z',
        beacon: '0xf7146828ea250394cc0ad99303313246b259dcc6',
        calculationConnector: '',
        source: '',
        origin: '0xde23611176b16720346f4df071d1aa01752c68c1',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x8b432c54d6e8e1b8d1802753514ab53044af1861',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DOLA/MAI',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.2464,
        tvlStaking: '4112.32',
        tvlUsd: '4112.32',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 471,
        createdAt: '2023-12-20T10:22:55.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:22:55.000Z',
        beacon: '0x1ea62dcb4a3777066f96f968ec4956f7bf2c308e',
        calculationConnector: '',
        source: '',
        origin: '0x7ec1926a50d2d253011cc9891935ebc476713bb1',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x9e4cb8b916289864321661ce02cf66aa5ba63c94',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/DEUS',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.5836,
        tvlStaking: '603260.94',
        tvlUsd: '603260.94',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 472,
        createdAt: '2023-12-20T10:22:55.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:22:55.000Z',
        beacon: '0x78537de908bef0ad8fadc18f5e0e5fc567556dc4',
        calculationConnector: '',
        source: '',
        origin: '0x36bda777ccbefe881ed729aff7f1f06779f4199a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x9287c921f5d920ceee0d07d7c58d476e46acc640',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.1742,
        tvlStaking: '6285.61',
        tvlUsd: '6285.61',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 473,
        createdAt: '2023-12-20T10:22:55.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:22:55.000Z',
        beacon: '0xed0e5e264d746848a95a6ee015e6a82fe827f91d',
        calculationConnector: '',
        source: '',
        origin: '0x1cfc45c5221a07da0de958098a319a29fbbd66fe',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x27a8afa3bd49406e48a074350fb7b2020c43b2bd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0135,
        tvlStaking: '53054.02',
        tvlUsd: '53054.02',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 474,
        createdAt: '2023-12-20T10:23:31.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:31.000Z',
        beacon: '0x5170267672f06157a18747e895d43a938404587d',
        calculationConnector: '',
        source: '',
        origin: '0x00b2149d89677a5069ed4d303941614a33700146',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x61366a4e6b1db1b85dd701f2f4bfa275ef271197',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'OVN/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0332,
        tvlStaking: '218180.41',
        tvlUsd: '218180.41',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 475,
        createdAt: '2023-12-20T10:23:31.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:31.000Z',
        beacon: '0x6de50850d78fb7ff515a9c24cd8daa182508409e',
        calculationConnector: '',
        source: '',
        origin: '0x62052d68a7dba58079b7d70a40796cabaab2a95f',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x3f386acc3a8e9194cf6279c219df8dd3c5b71974',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/THALES',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0681,
        tvlStaking: '24581.40',
        tvlUsd: '24581.40',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 476,
        createdAt: '2023-12-20T10:23:31.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:31.000Z',
        beacon: '0x530399a4918c9a653f4129cf2e9ee03903d01443',
        calculationConnector: '',
        source: '',
        origin: '0xa5972f0c07a2d1cc5a8457c28d88ec4f3c009864',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x4a3636608d7bc5776cb19eb72caa36ebb9ea683b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USD+/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0658,
        tvlStaking: '4096.52',
        tvlUsd: '4096.52',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 477,
        createdAt: '2023-12-20T10:23:31.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:31.000Z',
        beacon: '0x74a2603ab758ddeb019b8ef1cdd98646b2296961',
        calculationConnector: '',
        source: '',
        origin: '0x98f44ce76bdcad37f00a98b275631b1d796862fa',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xa819af1cc8abe618ea8abadeb464960f7451ceab',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/UNIDX',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 169.722,
        tvlStaking: '358.52',
        tvlUsd: '358.52',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 478,
        createdAt: '2023-12-20T10:23:31.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:31.000Z',
        beacon: '0x5e93eceed0b3af3809b9ee016a275224bc83bcf0',
        calculationConnector: '',
        source: '',
        origin: '0xa81dac2e9caa218fcd039d7cedeb7847cf362213',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x2d25e0514f23c6367687de89bd5167dc754d4934',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/TAROT',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.2033,
        tvlStaking: '1892921.03',
        tvlUsd: '1892921.03',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 479,
        createdAt: '2023-12-20T10:23:31.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:31.000Z',
        beacon: '0xe9b5d3133d68fae9211521b5e07fe2bef113a716',
        calculationConnector: '',
        source: '',
        origin: '0x26d6d4e9e3faf1c7c19992b1ca792e4a9ea4f833',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x82a0c1a0d4ef0c0ca3cfda3ad1aa78309cc6139b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AERO/WSTETH',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.059,
        tvlStaking: '395632.78',
        tvlUsd: '395632.78',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 480,
        createdAt: '2023-12-20T10:23:31.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:31.000Z',
        beacon: '0x50d6050c5dc2905e544bdee74d39c7d58ccef8a8',
        calculationConnector: '',
        source: '',
        origin: '0x15093ed45c2a3f88393d41bc436003e2b8115ad5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xf89042057d079debe2a65a1a899e48e0e825105f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/DOG',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1375,
        tvlStaking: '19928.74',
        tvlUsd: '19928.74',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 481,
        createdAt: '2023-12-20T10:23:31.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:31.000Z',
        beacon: '0xa79e77bc92e767a43cb5d3dd1e460e80a574d672',
        calculationConnector: '',
        source: '',
        origin: '0x50f0249b824033cf0af0c8b9fe1c67c2842a34d5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x723aef6543aece026a15662be4d3fb3424d502a9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TBTC/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0913,
        tvlStaking: '90751.60',
        tvlUsd: '90751.60',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 482,
        createdAt: '2023-12-20T10:23:57.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:57.000Z',
        beacon: '0x25be2ef570faeb50bfa4916f1da0966c8efa06da',
        calculationConnector: '',
        source: '',
        origin: '0x96a24ab830d4ec8b1f6f04ceac104f1a3b211a01',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x7f670f78b17dec44d5ef68a48740b6f8849cc2e6',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0914,
        tvlStaking: '8225500.25',
        tvlUsd: '8225500.25',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 483,
        createdAt: '2023-12-20T10:23:57.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:57.000Z',
        beacon: '0x10fee58c1aebe9d09075f8d86b4c83a02a8ce3ee',
        calculationConnector: '',
        source: '',
        origin: '0x275535f82f287073ceebc653862e4e43868aa65c',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xa56be957d432a5d0edc040b27078d9726f54e7f6',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EURA/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 1.9584,
        tvlStaking: '25.64',
        tvlUsd: '25.64',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 484,
        createdAt: '2023-12-20T10:23:57.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:57.000Z',
        beacon: '0x617d8817e31afc6567a5857b90df926cd61df826',
        calculationConnector: '',
        source: '',
        origin: '0xe69e310ce7dbc2f43a8671e140d435c0128a725e',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x8c7d15fcb443e07c5dc980901a6281f96d87c10f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'LUSD/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0278,
        tvlStaking: '1040.26',
        tvlUsd: '1040.26',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 485,
        createdAt: '2023-12-20T10:23:57.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:57.000Z',
        beacon: '0x21940b07ba4e8150df633960f1dfcd666bde257d',
        calculationConnector: '',
        source: '',
        origin: '0x2692cc440416b7f8252406d84e9d66f0c48c069e',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x5f43555b02507133ecd5b78218283ed849b07eac',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDBC/THALES',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3263,
        tvlStaking: '3811.10',
        tvlUsd: '3811.10',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 486,
        createdAt: '2023-12-20T10:23:57.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:57.000Z',
        beacon: '0x64b4ba06b726362263fd75457810865feb65d157',
        calculationConnector: '',
        source: '',
        origin: '0xf05a3de3dd6910042f506c6105bc14920c4289b6',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x2b7704f1cb9324cd8586b33c6c540cbd64e58237',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EXTRA/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.5315,
        tvlStaking: '2039.10',
        tvlUsd: '2039.10',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 487,
        createdAt: '2023-12-20T10:23:57.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:57.000Z',
        beacon: '0x06ab74f9d03fb6cf47d727dda5a0a744c8871d3c',
        calculationConnector: '',
        source: '',
        origin: '0xdab27a1bcb9526ad9335b793d14977aea9e4b5b9',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x9b4db2f16199b8639ba386f44903ea2d51d65e43',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MTA/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 1.0146,
        tvlStaking: '202.52',
        tvlUsd: '202.52',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 488,
        createdAt: '2023-12-20T10:23:57.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-20T10:23:57.000Z',
        beacon: '0x6ef805c6665507e41f8fceba46f38ea212e620b2',
        calculationConnector: '',
        source: '',
        origin: '0xe5ff63862097b32d3ed30551e290d66f1548973f',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x84ff3b6e2046579fb2f2b891ce18ee10b5fbdbf2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EXTRA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1879,
        tvlStaking: '380612.32',
        tvlUsd: '380612.32',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 512,
        createdAt: '2023-12-28T10:53:33.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-28T10:53:33.000Z',
        beacon: '0x0aacd23e4d937cb7269cfbc57d908d867700fae0',
        calculationConnector: '',
        source: '',
        origin: '0x4ee5994aafce64dc8c8c63eb9ad23a8d2d756c10',
        vaultFactoryId: 40,
        rewardTokens: ['0x54016a4848a38f257b6e96331f7404073fd9c32c'],
        rewardTokenType: '',
        stakingToken: '0x83240b049fa89b65be714aed68e5b074df6aac84',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0047,
        tvlStaking: '1082.72',
        tvlUsd: '1082.72',
        enabled: false,
        dexFactory: {
          id: 84743,
          chainId: 8453,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 513,
        createdAt: '2023-12-28T10:53:33.000Z',
        chainId: 8453,
        dateOfAdd: '2023-12-28T10:53:33.000Z',
        beacon: '0x3f463437dc8a01dc784f3a85b0fd2f23904843ab',
        calculationConnector: '',
        source: '',
        origin: '0x190fc4fdb5d6aa5c625ff0e45899cda15ce3c95f',
        vaultFactoryId: 40,
        rewardTokens: ['0x54016a4848a38f257b6e96331f7404073fd9c32c'],
        rewardTokenType: '',
        stakingToken: '0xc825c67ca3a80d487c339a6c16bb84f7dca16012',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/SCALE',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1455,
        tvlStaking: '15449.95',
        tvlUsd: '15449.95',
        enabled: true,
        dexFactory: {
          id: 84743,
          chainId: 8453,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1185,
        createdAt: '2024-02-22T12:48:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-02-22T12:48:43.000Z',
        beacon: '0x675ac7ab66c8c74b00bc4193ba1be0aae9ad2ac5',
        calculationConnector: '',
        source: '',
        origin: '0xde41799de5fb357f501dd9386acee424e816f7a6',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xcaedc2561356b6a01a94e3c0438011459e91fbb9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/WELS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0386,
        tvlStaking: '115535.24',
        tvlUsd: '115535.24',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1186,
        createdAt: '2024-02-22T12:48:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-02-22T12:48:43.000Z',
        beacon: '0xdfd59260987ad08c26b8a3952ad062b576be5da3',
        calculationConnector: '',
        source: '',
        origin: '0x4f09bab2f0e15e2a078a227fe1537665f55b8360',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x6cdcb1c4a4d1c3c6d054b27ac5b77e89eafb971d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2616,
        tvlStaking: '78481521.75',
        tvlUsd: '78481521.75',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1246,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x73e682a39f53baeb13098e30f8b5a11a8538b194',
        calculationConnector: '',
        source: '',
        origin: '0x519bbd1dd8c6a94c46080e24f316c14ee758c025',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xcdac0d6c6c59727a65f871236188350531885c43',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1158,
        tvlStaking: '22454209.30',
        tvlUsd: '22454209.30',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1247,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x714fbd304ba7927f45e37670e5f0a20d65790675',
        calculationConnector: '',
        source: '',
        origin: '0xccff5627cd544b4cbb7d048139c1a6b6bde67885',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xf213f2d02837012dc0236cc105061e121bb03e37',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DOLA/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0118,
        tvlStaking: '942420.96',
        tvlUsd: '942420.96',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1248,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x593704a7f7a72b03fc67614f61c8ff6144f7123c',
        calculationConnector: '',
        source: '',
        origin: '0x526b3d92ff55263dd24e3e14ccd0f5c2dab81d3b',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xe96c788e66a97cf455f46c5b27786191fd3bc50b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC+/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0014,
        tvlStaking: '13518.21',
        tvlUsd: '13518.21',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1249,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0xa87ffef7d76c08b20d6af2e928a4bb0bdbcf8797',
        calculationConnector: '',
        source: '',
        origin: '0x793f22ab88dc91793e5ce6adbd7e733b0bd4733e',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x7a034374c89c463dd65d8c9bcfe63bcbced41f4f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/EUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0629,
        tvlStaking: '1629519.02',
        tvlUsd: '1629519.02',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1250,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x26c43fefbda6f2602491282800492a6bbd8e1174',
        calculationConnector: '',
        source: '',
        origin: '0x9280df579cea690caf5c31601cb71564bb6fa6b7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x2a1463cebe85315224c536afd389b381b43f3206',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/MAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1208,
        tvlStaking: '5034043.46',
        tvlUsd: '5034043.46',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1251,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x0e413988e92254344090e23551ed0c97b599da34',
        calculationConnector: '',
        source: '',
        origin: '0x32cd891fa6c52bd324b9ef1b35f2e6e948eeeaf3',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x8f24dd646e2ae3615767ebdccc6691c54c41793f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/YFX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 11969.674,
        tvlStaking: '498.85',
        tvlUsd: '498.85',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1252,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0xe3a0fa7c5732596aeff8564844ae006982bbc76c',
        calculationConnector: '',
        source: '',
        origin: '0xfee9c0a1fe38e56494b913786534760165b495ab',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x97e6ff909f30d034f1dc9721e2939cea57116d95',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/SUUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 59.6703,
        tvlStaking: '173.39',
        tvlUsd: '173.39',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1253,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x50ab43fe581465304a1fdd463c47d76658d9d3f2',
        calculationConnector: '',
        source: '',
        origin: '0xa1d8f6a8ec2236a9919eb7e990bb27791c139a37',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x20000fbfedfd172821821c9c59284129b04ffb2e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TYBG/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.951,
        tvlStaking: '124806.03',
        tvlUsd: '124806.03',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1254,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x5ac193e23e9f5a5bc85be0701e282d8a30835f9b',
        calculationConnector: '',
        source: '',
        origin: '0x350545d8d440ffabac5f38dc2b6a917a0dfddbb5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x1307f36bc34081401497a873522570aeba4cde90',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/MTA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 239.3001,
        tvlStaking: '9.31',
        tvlUsd: '9.31',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1255,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0xb1da84257d34d3e563008adec587bcb4bcf60a99',
        calculationConnector: '',
        source: '',
        origin: '0x2cc76ef706b2fc694f86c633b880a6dde81687f1',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x413d78628d688edcde29518199a3a3db955068ec',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MAI/EUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 5.5839,
        tvlStaking: '43.31',
        tvlUsd: '43.31',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1256,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x44122b521ce5923a86cf4dda5033b62641d2521a',
        calculationConnector: '',
        source: '',
        origin: '0x434a8eea016357be462eb6ade1b99f9f9f5ff2c3',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x323121cd6f6274c9aeb9f87e0664c8fda5d343a5',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TBTC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0512,
        tvlStaking: '955472.94',
        tvlUsd: '955472.94',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1257,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x33ab518882c70a43cc469bd0393f347faa6a63e2',
        calculationConnector: '',
        source: '',
        origin: '0xe157d5a0c9a533ebbdeadb43633ce76d61816778',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x1a9f461a371559f82976fa18c46a6a0d29f131d0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/TKN',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0559,
        tvlStaking: '247127.10',
        tvlUsd: '247127.10',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1258,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0xa18b5bdb65aafc27623bf44ec051b9dde2bb62c4',
        calculationConnector: '',
        source: '',
        origin: '0x4acfd43dad13c5312fd0021c837167d294d7fcf9',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xf91e0dfe1265b914182de54e08c9ca2068beddde',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/MET',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0634,
        tvlStaking: '2128508.28',
        tvlUsd: '2128508.28',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1259,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0xf4146ba527a4fbe6e0034a9de60a6c99ffdc98fc',
        calculationConnector: '',
        source: '',
        origin: '0xcbfeaed3dd9310406c046fb496c7e77f7571a808',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x4cc2fefb2635c86b1bae1b58e0f60fb43e95e264',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SONNE/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.6896,
        tvlStaking: '393.28',
        tvlUsd: '393.28',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1260,
        createdAt: '2024-03-28T20:18:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:39.000Z',
        beacon: '0x56e9ccb6a8adb3c3cf51850c94c6bbf00319c460',
        calculationConnector: '',
        source: '',
        origin: '0xa8c37a644bdf3297c6e19a48150af3b7069294fc',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xf53b7af40be75043eeba493c622f4f56b3c27a31',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'LUSD/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2087,
        tvlStaking: '5680.97',
        tvlUsd: '5680.97',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1261,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0xacca48a47b8fb091b2daff2b0e4a0b1df9403283',
        calculationConnector: '',
        source: '',
        origin: '0x67d128f56ebace1341f17e0bd20e0653034f7ccb',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x9d933f0af9dc01a6f9e5d2e6dcb25b6d0837ea81',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBASEDOGE/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.085,
        tvlStaking: '34398.86',
        tvlUsd: '34398.86',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1262,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0xdb504bd017095bc00c5b56146a40e12cb020bcf1',
        calculationConnector: '',
        source: '',
        origin: '0xf460124c6146800c6c061a6fc40c14677523bc90',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xeff0891e5a1bd47a8f1e77abebfee4145974d088',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/JARVIS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0673,
        tvlStaking: '543073.67',
        tvlUsd: '543073.67',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1263,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0x01b35c4d655cdd41303234fef5da6fc97882091e',
        calculationConnector: '',
        source: '',
        origin: '0x1cb5503ed87caf12fa56e67219bac798eb51f5a7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x08b935148ab10d3699cb8d944519e8213abe6f1d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3937,
        tvlStaking: '5304.68',
        tvlUsd: '5304.68',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1264,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0x66f793f41f54471cb39934726114b382126272d4',
        calculationConnector: '',
        source: '',
        origin: '0xc5170e37875cfd19872692e1086c49f205b5fca6',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xf185f82a1948d014bae23d30b06fa8da35110315',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/DEUS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.7296,
        tvlStaking: '44426.56',
        tvlUsd: '44426.56',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1265,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0x7be8cdf3f5b3993c50d2e98418ee6ce763db2f14',
        calculationConnector: '',
        source: '',
        origin: '0xf42c2da9e11ae1b272c0f4dfd03ab40d06aa709e',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x688b0380360c84135769d4f75d70038119846a8e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/DHT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0241,
        tvlStaking: '14299.41',
        tvlUsd: '14299.41',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1266,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0xb287b962eedc5671570221417199490eb4f57f39',
        calculationConnector: '',
        source: '',
        origin: '0xe8cda9cd77e847a283766e7122452c9155fd094f',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xcc79bfa7a3212d94390c358e88afcd39294549ca',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SNX/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0479,
        tvlStaking: '110844.10',
        tvlUsd: '110844.10',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1267,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0x77ed0c8143abb6a74076a84bbebd5601e727999b',
        calculationConnector: '',
        source: '',
        origin: '0xacf2c5e2c6e54b0ae44daef6c12136bceab88d07',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x45d8c7bf5be7c99d39cdc724f60497bd79546458',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AERO/ZOOMER',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1804,
        tvlStaking: '18102.94',
        tvlUsd: '18102.94',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1268,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0x87f99fe451755af9954e25d66d4a87ed2498e534',
        calculationConnector: '',
        source: '',
        origin: '0xa0ebbc0f5adcc34e7ca3ea5bac654c00817b8f0b',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x951fdfa193d92c74c9e35ea8c8c757cbcbb85147',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/VELA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 3.1601,
        tvlStaking: '253.27',
        tvlUsd: '253.27',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1269,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0x0d03539fb3680b3137d0ab37c7119587be998c35',
        calculationConnector: '',
        source: '',
        origin: '0x50793b917ae25ab859f67406f271eeb05c7521fa',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xc95582235d8905ea7dac517286bec72f653fa24b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/XEN',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0813,
        tvlStaking: '3309.41',
        tvlUsd: '3309.41',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1270,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0x742599e653866457158f41fa848a905d0471ea97',
        calculationConnector: '',
        source: '',
        origin: '0x640e9ef68e1353112ff18826c4eda844e1dc5ed0',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x67b00b46fa4f4f24c03855c5c8013c0b938b3eec',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DAI/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.001,
        tvlStaking: '9289.31',
        tvlUsd: '9289.31',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1271,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0x78a4de1a511a4c7770d60f50e214655f1fb6be9d',
        calculationConnector: '',
        source: '',
        origin: '0x76bb14cc51d409987ea34a158ba51643f81bb82e',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xfd8aa87c97d32345bfe4f753acf25729008331c9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TBTC/T',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0477,
        tvlStaking: '9920.99',
        tvlUsd: '9920.99',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1273,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0xb556d69407d91542166ea0a44316ed01e235f30a',
        calculationConnector: '',
        source: '',
        origin: '0xd1d3cbd443443d6cfee567c5a85b94df633cdcab',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x5e14319d52c9c18a04bfbbe12dd3a0fe3c1a816a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/NPC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1398,
        tvlStaking: '69860.65',
        tvlUsd: '69860.65',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1274,
        createdAt: '2024-03-28T20:18:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-03-28T20:18:45.000Z',
        beacon: '0xe03703022632123cea244d6e4ab5d5f757683721',
        calculationConnector: '',
        source: '',
        origin: '0xca311e2460eab52b3f2008b5cdef0486556bafb3',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xb7a0b6322834014f95841e643dffa7bb9b9dc0ed',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/BETS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 29.3231,
        tvlStaking: '1388.74',
        tvlUsd: '1388.74',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1377,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0xceeb67b01539af21e412ebf8cd581c2e50ccbaa8',
        calculationConnector: '',
        source: '',
        origin: '0xb4f1cd310453f86ecf52554b6bcbab543667a446',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x90359da9715411b828769ab9343fa2732f726e19',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WELS/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0815,
        tvlStaking: '6846.39',
        tvlUsd: '6846.39',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1378,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0xfe93518b64cf5eb9f1341c2a9d318c231506ef17',
        calculationConnector: '',
        source: '',
        origin: '0x86a1260ab9f758026ce1a5830bdff66dbcf736d5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x2c4909355b0c036840819484c3a882a95659abf3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/DEGEN',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0363,
        tvlStaking: '279312.25',
        tvlUsd: '279312.25',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1379,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x1d36fa7311c9e50f2db6026a214cda14b7f12e87',
        calculationConnector: '',
        source: '',
        origin: '0x8fcc385d8d7f3a2e087853a79531630bf96575e8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x4a311ac4563abc30e71d0631c88a6232c1309ac5',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MOG/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1064,
        tvlStaking: '324436.57',
        tvlUsd: '324436.57',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1380,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x1c1b79aa7e2ed285000a90eeef97a69e34117244',
        calculationConnector: '',
        source: '',
        origin: '0x6318373c5a01224094bf0b1ac88562345b2fb91e',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x0c8bf3cb3e1f951b284ef14aa95444be86a33e2f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EZETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0035,
        tvlStaking: '17195.54',
        tvlUsd: '17195.54',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1381,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x29903380fa1c55e8a9d81856d3154e01022c1ddf',
        calculationConnector: '',
        source: '',
        origin: '0x93a7ddbd64f0835f99b6d248ce058fd90c68666c',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xeb956b77d455e33b41bbe6052dbe4388dcfd729b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ANIME/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.551,
        tvlStaking: '2761.04',
        tvlUsd: '2761.04',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1382,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0xc20222737aee73f327a7f75e4fba27f3aec43597',
        calculationConnector: '',
        source: '',
        origin: '0xdd1fd2beee67a3ada2277fc44aa69c5c0d753449',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x06709c364dd4e2f5b0c10b1ebf80b2ce483dbdc5',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/QI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.5665,
        tvlStaking: '56204.92',
        tvlUsd: '56204.92',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1383,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x2af64a0906d0e418cc1d4ccc3a01d2e6c81104d4',
        calculationConnector: '',
        source: '',
        origin: '0xbd62cad65b49b4ad9c7aa9b8bdb89d63221f7af5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x21594b992f68495dd28d605834b58889d0a727c7',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'VIRTUAL/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2806,
        tvlStaking: '5076281.83',
        tvlUsd: '5076281.83',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1384,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x0c4e0a56bcb6a688d4edf110562537d634190551',
        calculationConnector: '',
        source: '',
        origin: '0x82fdf8f646c6dcf7966734146486114f60c7def5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xd88b9f7185f404015b665e070a5ef03a7e26661f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'TKN/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2284,
        tvlStaking: '313825.06',
        tvlUsd: '313825.06',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1385,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x4b697ccab87a526f9740bdcb5c732dc3589b20f6',
        calculationConnector: '',
        source: '',
        origin: '0x2f1c1492f6057808c3fd16eef67e0237fbaebf4b',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x862a9d8443bbf74cf86bc05afc8e05c63319dc1e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/SEXY',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1612,
        tvlStaking: '241990.98',
        tvlUsd: '241990.98',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1386,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0xe5418d3814e7cfd30496055d1ce9bac3311f80af',
        calculationConnector: '',
        source: '',
        origin: '0x666c383e4eab3328660a85d1c41ffdce9d85d8ee',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x139e9f235588a9720e7eab045da29dc781c4b658',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/DOGINME',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1945,
        tvlStaking: '338962.45',
        tvlUsd: '338962.45',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1387,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x3b6e5c4079d4a4faae20b7bbb2efe6b2145e12bf',
        calculationConnector: '',
        source: '',
        origin: '0x3d9e2d8af6ff16a62217c8a559ee5987c72acb86',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x253da544f498b85429f6acdc6e98b36b36c1c824',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/L2VE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.161,
        tvlStaking: '8524.42',
        tvlUsd: '8524.42',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1388,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0xcdb1b7a4de83a97a796d7751e5d06b93025e0a31',
        calculationConnector: '',
        source: '',
        origin: '0x190351cf2a6e2ac19a528b283e0748ed0652799d',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x95f04b5594e2a944ca91d56933d119841eef9a99',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'RSR/BSDETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.041,
        tvlStaking: '123354.23',
        tvlUsd: '123354.23',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1389,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0xdbefdb6ca3f7e94eee752d4aa2c1fcb53aa7a3e8',
        calculationConnector: '',
        source: '',
        origin: '0xb00ec5ccd55b47d92e29496ca322b1f64a5c24b5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xaace080ea9ce5e7942ea826d311b6170bdfcf73b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/TOWER',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.386,
        tvlStaking: '283360.88',
        tvlUsd: '283360.88',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1390,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x48fef7a40098c1bed2453dfede1854891a764cc6',
        calculationConnector: '',
        source: '',
        origin: '0xeacfc84b210f27cc5999191a55ba39cb4e4c8902',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xdab27fb1923fc017e941d837040add59b9aff9fd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBASEDOGE/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3938,
        tvlStaking: '17812.81',
        tvlUsd: '17812.81',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1391,
        createdAt: '2024-04-26T15:03:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:43.000Z',
        beacon: '0x9948230a6e8ae26c900ce5def03f2ac6876bc667',
        calculationConnector: '',
        source: '',
        origin: '0xcec1d4eff7d6a785447ff48c336fee57a29804d0',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x448686ca47fbe77d8fc9eec6829837bf45e8ea75',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'YFX/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.4826,
        tvlStaking: '646.00',
        tvlUsd: '646.00',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1392,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0x183171ee2687eeada64feff8cf0e8bf15037e942',
        calculationConnector: '',
        source: '',
        origin: '0x67d128f56ebace1341f17e0bd20e0653034f7ccb',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x9d933f0af9dc01a6f9e5d2e6dcb25b6d0837ea81',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBASEDOGE/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.085,
        tvlStaking: '34398.86',
        tvlUsd: '34398.86',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1393,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0x997d869ce23cf3a94c0b254451a1982406260507',
        calculationConnector: '',
        source: '',
        origin: '0x2c477011bb6df2828da8367bae4c5ba7381c0240',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xb21b821ec1bb22d0241ae425e07e14d1ccea4aed',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/PRIME',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1911,
        tvlStaking: '8230.79',
        tvlUsd: '8230.79',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1394,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0x84f3bd1e979b88286bf33e86e1a17a7c25226a0b',
        calculationConnector: '',
        source: '',
        origin: '0xd962615116faf0d2a9db99310db8126cf700ec1b',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x6689a0582bafcc286a81dc38d76e0470acd17275',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/AAG',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.8419,
        tvlStaking: '2384.83',
        tvlUsd: '2384.83',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1396,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0xd0469e0e975b4bc427addf98ce9dbbf012a8a961',
        calculationConnector: '',
        source: '',
        origin: '0x77abe39cd429ea55b0fb065b74ca3e3b3c7c13da',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xd07b4d7cea966b6e8087c8be3347e4b790679785',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HPC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1851,
        tvlStaking: '2632.87',
        tvlUsd: '2632.87',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1397,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0x57d7cd0470032802094e1f8e907293be918a4246',
        calculationConnector: '',
        source: '',
        origin: '0x931143b901a1c81ba1657cf0f2acd126f75ca4fd',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x8f5f1d63599362115e7f9fe71bfd5ab883d82c82',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/TN100X',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.6655,
        tvlStaking: '448740.64',
        tvlUsd: '448740.64',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1398,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0xf860b6cfc626cdae49cee4ac472d2264bf7278dd',
        calculationConnector: '',
        source: '',
        origin: '0xfc16ec17c86e3fb9f501f50e659bc5d5545a197f',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xc41430a2090f0640e93322c6347c6740b4bdf9cd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/YFX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.2073,
        tvlStaking: '531.95',
        tvlUsd: '531.95',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1399,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0x41c368b878cb032611b3191725385d4a4598b75b',
        calculationConnector: '',
        source: '',
        origin: '0x346c6cfac949e9d7fca69cff0a882c06e86c9245',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x17cf4abb54a9d18c90fa0e36b8669ab0f4936f2e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/CHAD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.9047,
        tvlStaking: '9713.19',
        tvlUsd: '9713.19',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1400,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0x9cc3cc8f3d38e03f0c3070a22abd760b7e74e408',
        calculationConnector: '',
        source: '',
        origin: '0x8c021a56b951b22491aa74404275732281367ba5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xda74029240f657a7be372906290300dbb8f1bccd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'GROW/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.8217,
        tvlStaking: '1736.67',
        tvlUsd: '1736.67',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1402,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0xd908b15d7a285cb7a0397af3e996dbf15b6c7f8f',
        calculationConnector: '',
        source: '',
        origin: '0x45d3ef9d20f9ea644ab9bc706e630311050de370',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x267d950110d9ed57999c3451b89c35a9d278c074',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AERO/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.6022,
        tvlStaking: '5246.74',
        tvlUsd: '5246.74',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1403,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0xa7a48b3fc37b1ca2a59fad34641632421f26f2b2',
        calculationConnector: '',
        source: '',
        origin: '0xeab862191a4d917d2d16e2faf0859448ff5bedb7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xe25bc9133d26f62c9fa03b6750f3f3ba57e9eb44',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SFRXETH/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.4016,
        tvlStaking: '1574.76',
        tvlUsd: '1574.76',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1404,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0xf4bb1fecf365344286ab53bfd6b1c264a15ed481',
        calculationConnector: '',
        source: '',
        origin: '0x744462994510ccd987f697752bd46d1155f8022f',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x554eca2a48136724294ce47fb7bfe9aadfcee3c6',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SONNE/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 2.7882,
        tvlStaking: '7929.58',
        tvlUsd: '7929.58',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1405,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0x1bf9982aff15083883665fd13855c014360ec974',
        calculationConnector: '',
        source: '',
        origin: '0x65b4a4b9813e37da640bbef8abdd8e47100be5f8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x7810f8f3253ced11e8c56c6c8497f3134055d44c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AERO/TAROT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2575,
        tvlStaking: '2778459.56',
        tvlUsd: '2778459.56',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1406,
        createdAt: '2024-04-26T15:03:51.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:51.000Z',
        beacon: '0x77bd96724b1f9e9b7122ce187e613eb25c089ec0',
        calculationConnector: '',
        source: '',
        origin: '0x68b896e8b47f3d7a2399376d76706204b0b6e32e',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x70faafb3c7990771f6724c00f2574437bf805a9f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SUUSD/EMTRG',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.027,
        tvlStaking: '1534.91',
        tvlUsd: '1534.91',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1407,
        createdAt: '2024-04-26T15:03:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:55.000Z',
        beacon: '0xfeea66cde1be42c63f0aee9863b1564478d5c445',
        calculationConnector: '',
        source: '',
        origin: '0x6664867531c0fdd058881153fabe7d2162833b07',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x688f778c51db4d990bf1abaf8d33fd95e48c6641',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'EXTRA/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1115,
        tvlStaking: '55490.57',
        tvlUsd: '55490.57',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1408,
        createdAt: '2024-04-26T15:03:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:55.000Z',
        beacon: '0x5f42c54f9ecbd89246d7fad74c63acfaa91d67d0',
        calculationConnector: '',
        source: '',
        origin: '0xc7d62524c372125830a234f0e197c335d0f973fe',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xc91ce85da7fb4523926a2930e930a8b52a7b85b2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'KWENTA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 4.7409,
        tvlStaking: '24.14',
        tvlUsd: '24.14',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1409,
        createdAt: '2024-04-26T15:03:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:55.000Z',
        beacon: '0x42209c9678812fed5e52e8f9b9d50ebd5a7fe8d4',
        calculationConnector: '',
        source: '',
        origin: '0x62b2da7b10dde762b3b020aaee409786b548684c',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x1f019b4420936a800ff6f54c00d9da05445de433',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/USX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.015,
        tvlStaking: '549477.46',
        tvlUsd: '549477.46',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1410,
        createdAt: '2024-04-26T15:03:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:55.000Z',
        beacon: '0x5e05bff0967c6c6a5f0996840acee70dcbfbaf04',
        calculationConnector: '',
        source: '',
        origin: '0x969c70383a95704c6a35497d8c77bf38dc152e63',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x8e9154ac849e839d60299e85156bcb589de2693a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DOLA/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0011,
        tvlStaking: '164441.38',
        tvlUsd: '164441.38',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1411,
        createdAt: '2024-04-26T15:03:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-04-26T15:03:55.000Z',
        beacon: '0x7a02dc96e9d77dcf1adc3a422d3c09bbf08f9417',
        calculationConnector: '',
        source: '',
        origin: '0x1fdbf0e9bdb3b8e8305871471de91a8243fa9c2c',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x6de6b99274821f7f675a5794cd759c54bdc180b1',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'NORMIE/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 268.4895,
        tvlStaking: '37.42',
        tvlUsd: '37.42',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1476,
        createdAt: '2024-05-23T14:41:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-23T14:41:43.000Z',
        beacon: '0x923b83b558f0a14c2f7da961788e8621efb11b77',
        calculationConnector: '',
        source: '',
        origin: '0x44a927dd8f6def04f76b00cece9804bf441dc6b1',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xb37642e87613d8569fd8ec80888ea6c63684e79e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/KLIMA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1051,
        tvlStaking: '197133.37',
        tvlUsd: '197133.37',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1477,
        createdAt: '2024-05-23T14:41:43.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-23T14:41:43.000Z',
        beacon: '0x4f69a08e1ea2558a2a0092517748d5f7bef811be',
        calculationConnector: '',
        source: '',
        origin: '0x950ad950d6f07491ef2c150545a6a2ab7adc03f4',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x958682ec6282bc7e939fa8ba9397805c214c3a09',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/KLIMA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0969,
        tvlStaking: '108526.96',
        tvlUsd: '108526.96',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1485,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0xe03c3ef74bff81f1a556816ca92d1b2cfb5cf2ac',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/CIRCLE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xda679706ff21114ac9fac5198bff24543f357a16',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '417565.53',
        tvlUsd: '417565.53',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1486,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0x3bdb2ba15b71ca2ec64021847e044bf35adf3ab6',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/DEGEN',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc9034c3e7f58003e6ae0c8438e7c8f4598d5acaa',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '2526939.80',
        tvlUsd: '2526939.80',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1487,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0xbe28163f376b28a92761b16341d3aff3bd8c7d1e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3d5d143381916280ff91407febeb52f2b60f33cf',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1723997.76',
        tvlUsd: '1723997.76',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1488,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0x8a95d3f9173b78feaa9ca48dee81e80a52d271ae',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/BSHIB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf4348227607b166917b9f50cf51979e376995b73',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '48370.04',
        tvlUsd: '48370.04',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1489,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0xfefb0763c2a74a28d58d79eccbf06b4463ec748a',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/BRETT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x76bf0abd20f1e0155ce40a62615a90a709a6c3d8',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1129256.98',
        tvlUsd: '1129256.98',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1490,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0xe387bd73f81934fca02cd288e43bd10ba76ad151',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/TOSHI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4b0aaf3ebb163dd45f663b38b6d93f6093ebc2d3',
        poolV3Fee: 0.01,
        apr: 0.1692,
        tvlStaking: '1829240.87',
        tvlUsd: '1829240.87',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1491,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0x42fd7dccd329ae969982a88b982a20b884dcf1c9',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/ROOST',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4200000000000000000000000000000000000006',
        poolV3Fee: 0,
        apr: 0,
        tvlStaking: '272467.15',
        tvlUsd: '272467.15',
        enabled: false,
        dexFactory: {
          id: 95012,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1492,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0x925d197f61a01ff1644ac890c4fa20e744e906ce',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/BRETT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xba3f945812a83471d709bce9c3ca699a19fb46f7',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '4800280.49',
        tvlUsd: '4800280.49',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1493,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0xa9a7321e8b0c5cbe7135c9d55e9f85df4aed80a3',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'HIGHER/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcc28456d4ff980cee3457ca809a257e52cd9cdb0',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '197593.05',
        tvlUsd: '197593.05',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1494,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0x5ab1e0ae6636fcf9b4f9f21498e6de567083c76b',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/FUNGI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8ce9b689018fc94f44540b62ba6e10dc8b346448',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '252065.26',
        tvlUsd: '252065.26',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1495,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0x824190f8c089155c4c1b2b9e7182ec18676cbe38',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/NORMIE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4200000000000000000000000000000000000006',
        poolV3Fee: 0,
        apr: 0,
        tvlStaking: '579.77',
        tvlUsd: '579.77',
        enabled: false,
        dexFactory: {
          id: 95012,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1496,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0x9f26670b0a7e6a31e237287ca79791e6f267abe4',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/CHOMP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xd95bae63641d822dc591bd4aca7a64e53eac76f9',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '284592.43',
        tvlUsd: '284592.43',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1497,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0xc6200c4a59048abe1ba66111fab46eb8b4f572d1',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/RWA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfbfa69c021105e8f97ea12cf9d385e875d0f9e8f',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '45534.46',
        tvlUsd: '45534.46',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1498,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0xe89397396833d8b000a0bfeed1b3cb87205b6b1d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/ROCK',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x6d33206adb1462992c642ba5dd4f4e16beb4d047',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '43718.00',
        tvlUsd: '43718.00',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1499,
        createdAt: '2024-05-24T20:29:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:15.000Z',
        beacon: '0x7e0c9fee019ca3d10379652e132d9a25f1cadb4c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'NOGS/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe22a2dfaaaaec8a7b2b7acb4909eaaa5c5bd6e64',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1393106.84',
        tvlUsd: '1393106.84',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1500,
        createdAt: '2024-05-24T20:29:19.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:19.000Z',
        beacon: '0xd425947f59908c013a2266be96f1bd1806dd6b6c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/$MFER',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x7ec18abf80e865c6799069df91073335935c4185',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1737501.79',
        tvlUsd: '1737501.79',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1501,
        createdAt: '2024-05-24T20:29:19.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:19.000Z',
        beacon: '0xba9e3ebab06dccc3ea401b551d7db7ba42d50bec',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/NORMILIO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xbeaab7dbfa682636fb855ac19ea583eb06478852',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '105972.16',
        tvlUsd: '105972.16',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1502,
        createdAt: '2024-05-24T20:29:19.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:19.000Z',
        beacon: '0x0b5f2a88575226fe9b34840ada3234fbc4023985',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/DOGINME',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xade9bcd4b968ee26bed102dd43a55f6a8c2416df',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1632526.76',
        tvlUsd: '1632526.76',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1503,
        createdAt: '2024-05-24T20:29:19.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-24T20:29:19.000Z',
        beacon: '0x2b40b814961c475a3f9c8a5c88d057fca865b9aa',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/BRIUN',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x82ad659c2f152aad59bb37cbc5e7663a2de0c607',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '90482.51',
        tvlUsd: '90482.51',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1504,
        createdAt: '2024-05-28T08:40:01.000Z',
        chainId: 8453,
        dateOfAdd: '2024-05-28T08:40:01.000Z',
        beacon: '0xa1a5039966618baa7e167e94bd43e2a4f91e2466',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/SPEC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8055e6de251e414e8393b20adab096afb3cf8399',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1134294.21',
        tvlUsd: '1134294.21',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1643,
        createdAt: '2024-07-09T13:50:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-07-09T13:50:21.000Z',
        beacon: '0x03db9582f6024698dae2153481596847e72e7624',
        calculationConnector: '',
        source: '',
        origin: '0xd1e5855accb803c0ec03aa382a4f115acd3903b6',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xf629864e8b4914284f79641ef9ce034c161f26ae',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/CTX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1678,
        createdAt: '2024-08-08T15:43:05.000Z',
        chainId: 8453,
        dateOfAdd: '2024-08-08T15:43:05.000Z',
        beacon: '0x479c4fa0a2f591d31fce38480f9ef34692f6096a',
        calculationConnector: '',
        source: '',
        origin: '0xe4be724e22fefeb2969f53865222e58c496ef5d7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xfea9e8a7daef9497fff3e3501ed504984f96aa33',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WELS/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.0764,
        tvlStaking: '3852.84',
        tvlUsd: '3852.84',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2021,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x04e04fdf11f71facc874c384b2a6079c36e12698',
        calculationConnector: '',
        source: '',
        origin: '0xf1ae7589f6fa9345f39370fa50ce0bfeabe2b9bf',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x80326ed67271fb298d674c43aef3bc437b801b0e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ZUN/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3993,
        tvlStaking: '2044.85',
        tvlUsd: '2044.85',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2022,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x185c112f64b0e01cdf037331835fb54e6887c7d5',
        calculationConnector: '',
        source: '',
        origin: '0x78459058680eb5d6e35d18cda969bac2c0b305d5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x5fcfe2a2bc5954e6065428f6d8693814ef0491ac',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ZUN/ZUNETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 4.7038,
        tvlStaking: '117.98',
        tvlUsd: '117.98',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2023,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x8d06063c379a50d81c094aae94468156f27b1d1a',
        calculationConnector: '',
        source: '',
        origin: '0x43da0491ddb804a0437d4a7dfaee1fee1b41a856',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x887de0c0aa6c1d5e781b17867b29734f84dc1372',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/PEGG',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0434,
        tvlStaking: '158818.35',
        tvlUsd: '158818.35',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2024,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0xf8407c24e01a7fa1c0914a93b6da293e0778d58b',
        calculationConnector: '',
        source: '',
        origin: '0xc601b888db7f9f1792c332c538736b8dd03c3279',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x3225b7a01f8f3e68d89292141e22f1c6829e08cd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'PEGG/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0566,
        tvlStaking: '21841.07',
        tvlUsd: '21841.07',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2025,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x907067f089f2a7f12a4ce8e19dcdc761a1c4bcae',
        calculationConnector: '',
        source: '',
        origin: '0x076c466b97b7c0dafacfdf855de150eb0e5adb58',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x6d7da1a335dabca718e4ee5357041c96550d7563',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WELS/PEGG',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0668,
        tvlStaking: '9544.25',
        tvlUsd: '9544.25',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2026,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x5027eca762c66949a4956c09c380f6a7825e54e2',
        calculationConnector: '',
        source: '',
        origin: '0x937c527eb4f27030f6667078c64982b3202257d5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x37785d5be19d0d9559d4634a5385c72c419b25da',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/RFL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3212,
        tvlStaking: '631528.28',
        tvlUsd: '631528.28',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2027,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x3411fdb00366cea8bc5666392f952004fd6cbe9d',
        calculationConnector: '',
        source: '',
        origin: '0x4a64623fc6b1b008aa9d655f748c01f8b5552a26',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xd448670823ff9667848c821bee829c642f67e064',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/RWAX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0505,
        tvlStaking: '31494.94',
        tvlUsd: '31494.94',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2028,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x68565d467f98493ea8b684cfd481c84d82c1e355',
        calculationConnector: '',
        source: '',
        origin: '0x9b42e5f8c45222b2715f804968251c747c588fd7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x0fac819628a7f612abac1cad939768058cc0170c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ION/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.5685,
        tvlStaking: '189866.93',
        tvlUsd: '189866.93',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2029,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x3589d5880509985f55eedeaf4c5199fd2c9a4ea1',
        calculationConnector: '',
        source: '',
        origin: '0xcc38e1fc0f8bd866143f672d9e4340f05d262543',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xe96a4e9ea3a2c6db214174738a19eb7dbb8a3069',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/SPX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1357,
        tvlStaking: '1481020.93',
        tvlUsd: '1481020.93',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2030,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x5652acd6ac528963a0bc693aec22b93b701341c2',
        calculationConnector: '',
        source: '',
        origin: '0xf96bc096dd1e52dce4d595b6c4b8c5d2200db1e5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x598299fb3f3829f7ba08662948706cdff7ec2350',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/SAM',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.0382,
        tvlStaking: '185797.31',
        tvlUsd: '185797.31',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2031,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0xcebd133badc10f808d289616784706b513953eab',
        calculationConnector: '',
        source: '',
        origin: '0x8351616f224a035aa5ee6b9f74a68659701af3e9',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x0aa3e62f4d97c404012352e881a2d0f2712c24a2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/RECORD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.695,
        tvlStaking: '153502.03',
        tvlUsd: '153502.03',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2032,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x1c3c5bd46947aba52ab90b8d9bd8032378329092',
        calculationConnector: '',
        source: '',
        origin: '0x5b41a91cc14496e7fcc381595dc2680ef71b6462',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x0b15b1d434f86ecaa83d14398c8db6d162f3921e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'LUSD/POOL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1632,
        tvlStaking: '15218.49',
        tvlUsd: '15218.49',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2033,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x9ab3ad1f90af047b90fd6811179763af48a7dc00',
        calculationConnector: '',
        source: '',
        origin: '0xb0fc063ff618f6110adb3565c4f13b1a3b9527a8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x77e09a5043820820390904357463bfb739a76104',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'BCT/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2034,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x9ad46a0949f5ef8d9fb4fa6b5f0fe936d7a99a53',
        calculationConnector: '',
        source: '',
        origin: '0x2bed28eda5b8902ff20256ac001aa6a4beb1cec2',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x14f7ce67e16c435c876aff4092eb547584121312',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/LRDS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.7844,
        tvlStaking: '1202862.83',
        tvlUsd: '1202862.83',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2035,
        createdAt: '2024-10-16T15:24:37.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:37.000Z',
        beacon: '0x2c09f7857cdf5b606c1a36ca74e6ac918e8789ff',
        calculationConnector: '',
        source: '',
        origin: '0xce0358dff7bcf904f21425f6fee7f8e6115372cd',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x68cfb52c74827f91e1f664ffed634f849aece455',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HBR/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.0211,
        tvlStaking: '578.53',
        tvlUsd: '578.53',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2036,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xa57316891f8cb67d8f21faa807574b14a43bd5d8',
        calculationConnector: '',
        source: '',
        origin: '0x8c44e7f913d0893cd5a3cbbb2fcd59785a7801ab',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xb909f567c5c2bb1a4271349708cc4637d7318b4a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'VIRTUAL/CBBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1664,
        tvlStaking: '2755842.30',
        tvlUsd: '2755842.30',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2037,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xc3c6915d52575502b6c87727c93072cf0865eb8c',
        calculationConnector: '',
        source: '',
        origin: '0x68dba60beef5fdd4663588950a196fccc8b7a166',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xa32ecde2c559c462610ed35740cc2b9642133c9b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/MOZ',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1581,
        tvlStaking: '3557.18',
        tvlUsd: '3557.18',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2038,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0x01d4f26784f9bba6026f2b40cc824c74cfe3d211',
        calculationConnector: '',
        source: '',
        origin: '0x34bf49c57c8a6a766c99909a3513258a3db7e393',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xf471d220f16cc9c3400b5bd97d728072a87b9c75',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'BET/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2039,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xf3f432856659424277c6f81bd215ff144e5298d6',
        calculationConnector: '',
        source: '',
        origin: '0xe3da183cdbbd0f01867605c632f1e275e7ed6e3d',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xd3c2fa602b8da5b0b9c25dfbe7f2f31bb512db13',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'BAVA/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 428.5949,
        tvlStaking: '3633.50',
        tvlUsd: '3633.50',
        enabled: false,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2040,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0x2e11ef0e5a91436b1acdc726d034c4ec89a4459e',
        calculationConnector: '',
        source: '',
        origin: '0xf07fcb6f97622972f19ef0de444268ce23a4a75b',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xaa721dc836b5195f33f09b7713f73171a0030e36',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/SKR',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 3.4051,
        tvlStaking: '15980.33',
        tvlUsd: '15980.33',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2041,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xa59571dde1ebd9bc43e4ebc5a9e0eb5b64bf8c83',
        calculationConnector: '',
        source: '',
        origin: '0xc418d71a9c4756c54f414e128ecc6a2448ded100',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x63b9877618e27081181a59f9ca52040ada1332fc',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/XCAD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.115,
        tvlStaking: '30384.83',
        tvlUsd: '30384.83',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2042,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0x52fc1b6ab22e925aa1fabe11b7debe1098d96419',
        calculationConnector: '',
        source: '',
        origin: '0xf2470b185647d1fd0f432c223ab0e80e0b23dcd3',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x1dda8b6469df243971381f1f3f4137814ca68722',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WMTX/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2241,
        tvlStaking: '310584.81',
        tvlUsd: '310584.81',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2043,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xe9c62a329c4bce468f509823ada3775c224a94b3',
        calculationConnector: '',
        source: '',
        origin: '0xad978bdbcc8a44dea4d773a8df9ff7f73dd288d8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xcdb55b284257fd5f879598ba9e4b852bb0c3edf1',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/XSWAP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.4774,
        tvlStaking: '131058.66',
        tvlUsd: '131058.66',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2044,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0x75eb11e5aa47d8f654c719c3e725e0379fb4f9ce',
        calculationConnector: '',
        source: '',
        origin: '0xd3011443522e904092232cd7c73586d0b1b61418',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x0d4953d2bde145d316296cc72cce509d899a5529',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/LUCHA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1871,
        tvlStaking: '328871.12',
        tvlUsd: '328871.12',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2045,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xcf4527e199c6a9bfa2279d6840fd8b94f4752740',
        calculationConnector: '',
        source: '',
        origin: '0x9b49ca7c6c41f01971e2453078a357415cb3adda',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xfc13b664e814098f08f10ba0fb23b1bb916f344e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AERO/L2VE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0875,
        tvlStaking: '15179.99',
        tvlUsd: '15179.99',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2046,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xa3e97bbc0e014894c6ee2c50c248047642ed1b14',
        calculationConnector: '',
        source: '',
        origin: '0xea2c1c05c17eed888d0027f17ee23637dff66feb',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xc02dc3a9b6ead739c56cdea716d8fec4ffe4c799',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/MOXIE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1262,
        tvlStaking: '7686.85',
        tvlUsd: '7686.85',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2047,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xc08c43247fb8b9b005493897d2c8be2e2c852842',
        calculationConnector: '',
        source: '',
        origin: '0x218ae1b36bba8993beb2284f56ef20f598fef564',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x1416d46ebf8afc4efe1942d7d8e14459aabc7891',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/HLSP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0009,
        tvlStaking: '56290.96',
        tvlUsd: '56290.96',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2048,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0xbce7c035f821a99f2ebfeff56a814747369fbc0d',
        calculationConnector: '',
        source: '',
        origin: '0xd4ecf20068e5fa849abe62f9523a90f8c073f203',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0xe140c5930889c4064a3d11b17bb04fe7224a5cdc',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/OX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3052,
        tvlStaking: '29349.28',
        tvlUsd: '29349.28',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2049,
        createdAt: '2024-10-16T15:24:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-16T15:24:45.000Z',
        beacon: '0x53be4f61f273bcc853e12fc5f8a87d3281ef7eac',
        calculationConnector: '',
        source: '',
        origin: '0xd1d3cbd443443d6cfee567c5a85b94df633cdcab',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x5e14319d52c9c18a04bfbbe12dd3a0fe3c1a816a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/NPC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1398,
        tvlStaking: '69860.65',
        tvlUsd: '69860.65',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2196,
        createdAt: '2024-10-30T18:14:49.000Z',
        chainId: 8453,
        dateOfAdd: '2024-10-30T18:14:49.000Z',
        beacon: '0x1f08a3b300757f655001850964412e945224adf7',
        calculationConnector: '',
        source: '',
        origin: '0x7b6964440b615ac1d31bc95681b133e112fb2684',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x89d0f320ac73dd7d9513ffc5bc58d1161452a657',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/WELL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3535,
        tvlStaking: '16275636.02',
        tvlUsd: '16275636.02',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2219,
        createdAt: '2024-11-11T10:39:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:39:47.000Z',
        beacon: '0x0efcad3888525bf2407c80ccaab2b05df0ed77ce',
        calculationConnector: '',
        source: '',
        origin: '0xdd234dbe2eff53bed9e8fc0e427ebcd74ed4f429',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/SUPEROETHB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x6446021f4e396da3df4235c62537431372195d38',
        poolV3Fee: 0.0004,
        apr: 0.0067,
        tvlStaking: '860571918.86',
        tvlUsd: '860571918.86',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2220,
        createdAt: '2024-11-11T10:39:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:39:47.000Z',
        beacon: '0xfed999742ee5ee9adbba9222e3b7f1545d7cada6',
        calculationConnector: '',
        source: '',
        origin: '0x2a1f7bf46bd975b5004b61c6040597e1b6117040',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/WSTETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x861a2922be165a5bd41b1e482b49216b465e1b5f',
        poolV3Fee: 0.0001,
        apr: 0.063,
        tvlStaking: '11729676.39',
        tvlUsd: '11729676.39',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2279,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0xec2e56ebd31c34e588362f9005dc317a3be81641',
        calculationConnector: '',
        source: '',
        origin: '0xc6b4fe83fb284bdde1f1d19f0b5beb31011b280a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'EZETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xdc7ead706795eda3feda08ad519d9452badf2c0d',
        poolV3Fee: 0.003,
        apr: 0.0319,
        tvlStaking: '175246.49',
        tvlUsd: '175246.49',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2280,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0x59cfe9aa97fa6890782a9abd139e7a4f9747bc41',
        calculationConnector: '',
        source: '',
        origin: '0xcb4b8aed321e22b0b87d9e41538408404433ac70',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'DOLA/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x96331fcb46a7757854d9e26aff3aca2815d623fd',
        poolV3Fee: 0.003,
        apr: 0.0896,
        tvlStaking: '14020.37',
        tvlUsd: '14020.37',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2281,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0x5f42aec006b9f07a69284727a1fe270feb845fb3',
        calculationConnector: '',
        source: '',
        origin: '0xb57ec27f68bd356e300d57079b6cdbe57d50830d',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'TBTC/CBBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x138acee5573fa09e7f215965ff60898cc33c6330',
        poolV3Fee: 0.0001,
        apr: 0.0392,
        tvlStaking: '6530515.44',
        tvlUsd: '6530515.44',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2283,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0x9df12d748019c6b30d773d47fb7027c8f804b375',
        calculationConnector: '',
        source: '',
        origin: '0x7e62007c19c9b9d581354b29c57c61c41b50851a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USD+/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x20086910e220d5f4c9695b784d304a72a0de403b',
        poolV3Fee: 0.0001,
        apr: 0.0335,
        tvlStaking: '21582.33',
        tvlUsd: '21582.33',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2284,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0x6190ef1e0573e90bdb170f9c74b6deaeb3cd6822',
        calculationConnector: '',
        source: '',
        origin: '0x956d84430523fd383e790956eeaab5b448620cdc',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/AXLUSDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x43b97febdadad12afde21baa96eb762bc26d13f3',
        poolV3Fee: 0.0001,
        apr: 0.0446,
        tvlStaking: '66681.99',
        tvlUsd: '66681.99',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2285,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0x6de1e3210189a00a112d49e8a5e4ea0e0c4f26a6',
        calculationConnector: '',
        source: '',
        origin: '0x958ee1605aed682dae998ae47af7122c641a292c',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDZ/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4ef1e503c4f1e5664ac98294d0e42ddc9c0ff961',
        poolV3Fee: 0.0001,
        apr: 1.2149,
        tvlStaking: '1126.27',
        tvlUsd: '1126.27',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2286,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0xee899a7103c6649ad2b3edf2bf50364f8f3bc506',
        calculationConnector: '',
        source: '',
        origin: '0x9cc802bf83aed8e8c1b19d051dd2d85e1f931973',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USD+/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe9c137071861fba0359eeccb5865c2588d1be2be',
        poolV3Fee: 0.0001,
        apr: 0.2403,
        tvlStaking: '5510.59',
        tvlUsd: '5510.59',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2287,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0x9106b949e3ce80b914adb72f06a467ed7c70dea2',
        calculationConnector: '',
        source: '',
        origin: '0x1f6c9d116ce22b51b0bc666f86b038a6c19900b8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'EURC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe846373c1a92b167b4e9cd5d8e4d6b1db9e90ec7',
        poolV3Fee: 0.0005,
        apr: 0.1514,
        tvlStaking: '2917926.10',
        tvlUsd: '2917926.10',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2288,
        createdAt: '2024-11-11T10:40:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:47.000Z',
        beacon: '0xf1060b53961fcbe6e9e3435a8ffe2c80dfbc92e1',
        calculationConnector: '',
        source: '',
        origin: '0x7d90e903936dad918fac797913925c7598d233f8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'XPUFETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcdf927c0f7b81b146c0c9e9323eb5a28d1bfa183',
        poolV3Fee: 0.0005,
        apr: 0.0009,
        tvlStaking: '214555.85',
        tvlUsd: '214555.85',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2289,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0xaf6d2e23c5edc047523ed7868f7760b632b867c4',
        calculationConnector: '',
        source: '',
        origin: '0xf3295461eb9f0acec52f2efb9e9788ed86f57f47',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'EURC/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa51c7a5a121ad3d73e2e9888bb016e07bdd5ba94',
        poolV3Fee: 0.0005,
        apr: 0.0305,
        tvlStaking: '169509.64',
        tvlUsd: '169509.64',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2290,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0xceacfa04f9e2f57344d90b7313ef352711d274ca',
        calculationConnector: '',
        source: '',
        origin: '0xf00d67799cd4e1a77d14671149b599a96dcd38ec',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WBLT/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x7ce345561e1690445eefa0db04f59d64b65598a8',
        poolV3Fee: 0.008,
        apr: 0.1666,
        tvlStaking: '1060813.41',
        tvlUsd: '1060813.41',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2291,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0x63aa9ab02c38f7707ef817d8bb894c8d6c0af269',
        calculationConnector: '',
        source: '',
        origin: '0x381baa9990c5aa04015936a2ec37d4d2da519899',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'CBBTC/UBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9ed7eb51a8e6af23d77180acc32a3312a06bdc79',
        poolV3Fee: 0.0005,
        apr: 0.0459,
        tvlStaking: '19365.43',
        tvlUsd: '19365.43',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2292,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0x1d81bf1cf37f22aa1b4dc33ae36ecf12f9c82540',
        calculationConnector: '',
        source: '',
        origin: '0x41b2126661c673c2bedd208cc72e85dc51a5320a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/CBBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x70acdf2ad0bf2402c957154f944c19ef4e1cbae1',
        poolV3Fee: 0.0005,
        apr: 0.0825,
        tvlStaking: '182457842.67',
        tvlUsd: '182457842.67',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2293,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0xd39d1834e18cd1470d9f3a2d17db974c479152d6',
        calculationConnector: '',
        source: '',
        origin: '0x6399ed6725cc163d019aa64ff55b22149d7179a8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/CBBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4e962bb3889bf030368f56810a9c96b83cb3e778',
        poolV3Fee: 0.0005,
        apr: 0.0452,
        tvlStaking: '271481048.51',
        tvlUsd: '271481048.51',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2294,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0x4350eca91440af9e32233a29d2a5cb73330ab06c',
        calculationConnector: '',
        source: '',
        origin: '0xf33a96b5932d9e9b9a0eda447abd8c9d48d2e0c8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb2cc224c1c9fee385f8ad6a55b4d94e92359dc59',
        poolV3Fee: 0.0004,
        apr: 0.8778,
        tvlStaking: '61039518.58',
        tvlUsd: '61039518.58',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2295,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0x4b1a82f8b6d35dc9390975388be105014a04a317',
        calculationConnector: '',
        source: '',
        origin: '0xcc2714bf50f3c7174a868bec8f4d4d284a0b07cc',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4d69971ccd4a636c403a3c1b00c85e99bb9b5606',
        poolV3Fee: 0.0004,
        apr: 0.0778,
        tvlStaking: '1880129.61',
        tvlUsd: '1880129.61',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2296,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0xa09e049dbbbbde70ae0d18724e90d483da90ebfe',
        calculationConnector: '',
        source: '',
        origin: '0x2c0cbf25bb64687d11ea2e4a3dc893d56ca39c10',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9785ef59e2b499fb741674ecf6faf912df7b3c1b',
        poolV3Fee: 0.0004,
        apr: 1.122,
        tvlStaking: '167097.16',
        tvlUsd: '167097.16',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2297,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0x531f151e7fac34de77b5006c86f6d627cc06a132',
        calculationConnector: '',
        source: '',
        origin: '0xb0c500d53720ff63f000de6d26f7fe5c66571e3d',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/EURC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5d4e504eb4c526995e0cc7a6e327fda75d8b52b5',
        poolV3Fee: 0.0005,
        apr: 5.0943,
        tvlStaking: '649748.58',
        tvlUsd: '649748.58',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2298,
        createdAt: '2024-11-11T10:40:55.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:55.000Z',
        beacon: '0xac7b1f2b3efc5bac4d9237b7635c417dea43a3b3',
        calculationConnector: '',
        source: '',
        origin: '0x549690894f61bf0d3a5799d03fded6e775a424aa',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDZ/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcf88b8bf7ccce2d836878e538197eb20fc673bce',
        poolV3Fee: 0.0004,
        apr: 0.5727,
        tvlStaking: '18885.55',
        tvlUsd: '18885.55',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2299,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0xe8ab7b29e82bb291b11f2c8f17f9e9729745543c',
        calculationConnector: '',
        source: '',
        origin: '0x46e078fedcd91a813306d5637d7ec5c7dc201ec3',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/ZRO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa4463789e8f3c6a599b3dfb608dde55513bcf289',
        poolV3Fee: 0.0025,
        apr: 1.3883,
        tvlStaking: '224834.33',
        tvlUsd: '224834.33',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2300,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0x02a0710706247641c438b0154cba024a3106b37d',
        calculationConnector: '',
        source: '',
        origin: '0x1e6490c37841024b9ee55f505ccb24cefa7fce9c',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USD+/CBBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe05ce080119b33dd30482a6ec9b8911508ae226e',
        poolV3Fee: 0.0005,
        apr: 0.0859,
        tvlStaking: '17950.41',
        tvlUsd: '17950.41',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2301,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0xf3bedb936df8808bf93a491a4de341adfefea781',
        calculationConnector: '',
        source: '',
        origin: '0x017a82b26d612cad89d240206f652e76ae8c4b31',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'EURC/CBBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb07d7eece8866e549601af5c7622d8cdbedc914e',
        poolV3Fee: 0.0005,
        apr: 0.332,
        tvlStaking: '96336.83',
        tvlUsd: '96336.83',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2302,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0x189ddf91159d681bd7bde93f5943fc0a723578e6',
        calculationConnector: '',
        source: '',
        origin: '0x384ce87727323ededdc95d3206399806a3da7f02',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDZ/CBBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x7f770a81811b58094b75cea1de76304aa8eae72c',
        poolV3Fee: 0.0005,
        apr: 5.1454,
        tvlStaking: '24.01',
        tvlUsd: '24.01',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2303,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0xfd250562921cc325e209094fbf0a7d85903751e0',
        calculationConnector: '',
        source: '',
        origin: '0xfd73ab1100a60ba64686ef9dcde36d0209773f6a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/BRETT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4e829f8a5213c42535ab84aa40bd4adcce9cba02',
        poolV3Fee: 0.0025,
        apr: 0.0985,
        tvlStaking: '8993383.55',
        tvlUsd: '8993383.55',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2304,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0xd105ba67e63e082e289c6d2ad1c87b1c184bfa37',
        calculationConnector: '',
        source: '',
        origin: '0xde8ff0d3e8ab225110b088a250b546015c567e27',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/AERO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x82321f3beb69f503380d6b233857d5c43562e2d0',
        poolV3Fee: 0.006,
        apr: 1.6351,
        tvlStaking: '5213601.24',
        tvlUsd: '5213601.24',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2305,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0x5484c07fa18a17638c0d665b0921001df01f2e14',
        calculationConnector: '',
        source: '',
        origin: '0x44e6f4d58a81531338d11ae6374f199a35c787be',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'MOG/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc29dc26b28fff463e32834ce6325b5c74fac7098',
        poolV3Fee: 0.007,
        apr: 1.1397,
        tvlStaking: '117847.05',
        tvlUsd: '117847.05',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2306,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0xa09c7884bad3f0fabae6c813f13e3ad9eef47532',
        calculationConnector: '',
        source: '',
        origin: '0x1c664940858dcea1e5a3b87951f1f74911102cb5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WIF/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3cacb8007d50f3e4166d7c5fd303c1a6ed337531',
        poolV3Fee: 0.007,
        apr: 0.2332,
        tvlStaking: '8314.39',
        tvlUsd: '8314.39',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2307,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0xfe19a1894010f936674e1f0c2f3b721d1bb68354',
        calculationConnector: '',
        source: '',
        origin: '0x9d312ed8646ce9a4ec2a44279c07cfccfefab012',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/SPX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4ba1e3e9280facbacafa7baf4ae0b78bea60beca',
        poolV3Fee: 0.007,
        apr: 0.4709,
        tvlStaking: '1319014.78',
        tvlUsd: '1319014.78',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2308,
        createdAt: '2024-11-11T10:41:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:03.000Z',
        beacon: '0x28b138f4652bbb7a90b69a129b0965c5a544cb3f',
        calculationConnector: '',
        source: '',
        origin: '0xed5355807fb4e7a04a7ff8bbc20cf65d425cb868',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/USUI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5c45b0f48c326f79b56709d8f63ce2bee7697106',
        poolV3Fee: 0.003,
        apr: 0.016,
        tvlStaking: '8789851.81',
        tvlUsd: '8789851.81',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2728,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0xa0989223f8b63cc7108a69ec88aa4aeb130b064b',
        calculationConnector: '',
        source: '',
        origin: '0xf5550f8f0331b8caa165046667f4e6628e9e3aac',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'CBETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x47ca96ea59c13f72745928887f84c9f52c3d7348',
        poolV3Fee: 0.0005,
        apr: 0.0491,
        tvlStaking: '7903602.39',
        tvlUsd: '7903602.39',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2729,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0xffc25723afff5bddbd04fd3e8e406d7e045e120c',
        calculationConnector: '',
        source: '',
        origin: '0xea22a3aada580bd75fb6cac35034e09046cbff72',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0c1a09d5d0445047da3ab4994262b22404288a3b',
        poolV3Fee: 0.0001,
        apr: 0.0028,
        tvlStaking: '8577877.18',
        tvlUsd: '8577877.18',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2730,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0xbd4ffa6c85d681f1f54a10e26eca79cd761e1b2d',
        calculationConnector: '',
        source: '',
        origin: '0x4a3e1294d7869567b387fc3d5e5ccf14be2bbe0a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/USDBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x98c7a2338336d2d354663246f64676009c7bda97',
        poolV3Fee: 0.0001,
        apr: 0.0405,
        tvlStaking: '1272569.66',
        tvlUsd: '1272569.66',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2731,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0xfdf0b5c24b5cd47931cf1793bb2620e8551000bd',
        calculationConnector: '',
        source: '',
        origin: '0x4197186d3d65f694018ae4b80355225ce1dd64ad',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WSTETH/WRSETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x14dccdd311ab827c42cca448ba87b1ac1039e2a4',
        poolV3Fee: 0.0001,
        apr: 0.0019,
        tvlStaking: '3752331.94',
        tvlUsd: '3752331.94',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2732,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0x3e4396e20e1c57dcc3f15d4e9d9b2e5e14dccbd3',
        calculationConnector: '',
        source: '',
        origin: '0x0b537ac41400433f09d97cd370c1ea9ce78d8a74',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/BSDETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2ae9df02539887d4ebce0230168a302d34784c82',
        poolV3Fee: 0.0001,
        apr: 0.0215,
        tvlStaking: '14020290.13',
        tvlUsd: '14020290.13',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2733,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0x0baf7ff656bc400fe6ccb9506fd57e984c861b18',
        calculationConnector: '',
        source: '',
        origin: '0xbd85d45f1636fceb2359d9dcf839f12b3cf5af3f',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa41bc0affba7fd420d186b84899d7ab2ac57fcd1',
        poolV3Fee: 0.0001,
        apr: 0.0288,
        tvlStaking: '5537375.96',
        tvlUsd: '5537375.96',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2734,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0x036a56977c828293736d7bb3810e0e261ff59c44',
        calculationConnector: '',
        source: '',
        origin: '0xe62adb491707513ea98b957d9adb73d8d23e191c',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/EUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x988702fe529a3461ec7fd09eea3f962856709fd9',
        poolV3Fee: 0.0001,
        apr: 0.0345,
        tvlStaking: '8761208.37',
        tvlUsd: '8761208.37',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2735,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0xe6f18d7b31e633ccff4367568eee3d70294f5f2a',
        calculationConnector: '',
        source: '',
        origin: '0xd030df11fa453a222782f6458cc71954a48ea104',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/USDC+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8dd9751961621fcfc394d90969e5ae0c5babe147',
        poolV3Fee: 0.0001,
        apr: 2.0314,
        tvlStaking: '1129.07',
        tvlUsd: '1129.07',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2736,
        createdAt: '2024-11-11T10:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:40:39.000Z',
        beacon: '0x70fd49ce9d962614def7a42548e3589deea91a5e',
        calculationConnector: '',
        source: '',
        origin: '0xe2f3c8c699a1bf30a12118b287b5208e7c6ddfef',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDZ/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xde5ff829fef54d1bdec957d9538a306f0ead1368',
        poolV3Fee: 0.001,
        apr: 0.0906,
        tvlStaking: '42169.75',
        tvlUsd: '42169.75',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2767,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0x4e8b236bb540001551a02fde7d428ca09fe7ce37',
        calculationConnector: '',
        source: '',
        origin: '0x399ffb6b1263a12ed23c27ba07043f07d74c19da',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/PEPE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3333e1d9174720d6ec2cf815e65b82915a9eae1e',
        poolV3Fee: 0.007,
        apr: 0.1549,
        tvlStaking: '134202.64',
        tvlUsd: '134202.64',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2768,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0x42c0facff8d1cc81543c6b2ea871abd2d1a7b3fc',
        calculationConnector: '',
        source: '',
        origin: '0xa9edd05f8d82f4050d4649fef30bec9378f499e7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/KEYCAT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb211a9ddff3a10806c8fdb92dbc4c34596a23f84',
        poolV3Fee: 0.007,
        apr: 0.5876,
        tvlStaking: '269180.16',
        tvlUsd: '269180.16',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2769,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0xfc49d8d417561a950ef21e6b26afbb244df04563',
        calculationConnector: '',
        source: '',
        origin: '0xafabcbbab5e4261b1d655c906738176191819164',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/MIGGLES',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x326841efd63340767e02ec88e583f18a82af4a48',
        poolV3Fee: 0.0027,
        apr: 0.7979,
        tvlStaking: '83825.18',
        tvlUsd: '83825.18',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2770,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0xfa1df52f00541ccd1c3cd625a4ef10ddfac56003',
        calculationConnector: '',
        source: '',
        origin: '0x7a8464b293e1a035a2546dd38fb9cf8be4c5ab44',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/OVN',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1da71ce5ebf772f9fdd44e29bec53c7185e188ba',
        poolV3Fee: 0.01,
        apr: 0.4467,
        tvlStaking: '8891.54',
        tvlUsd: '8891.54',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2772,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0x6186ee35c8e9c44b394848610613090dffe947e7',
        calculationConnector: '',
        source: '',
        origin: '0x79efe300783f448283e54ce7cad08118a52849f6',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/SPEC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfd7abc461df4e496a25898cab0c6ea88cdd94cf9',
        poolV3Fee: 0.0025,
        apr: 0.7475,
        tvlStaking: '43721.88',
        tvlUsd: '43721.88',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2773,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0xb345080c7e145b80e5906d20d48f11f18f2864c1',
        calculationConnector: '',
        source: '',
        origin: '0x4d046a24da2b4c01b89df7eae9b4794586489769',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'BITCOIN/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfd22d75b2fb405ee185155d57b0277b9db2f8e29',
        poolV3Fee: 0.007,
        apr: 0.1361,
        tvlStaking: '106504.44',
        tvlUsd: '106504.44',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2774,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0x84720be65a831bbf75d2aa5b5b2051c5045c1e85',
        calculationConnector: '',
        source: '',
        origin: '0x996802075582af2ee133fb30cc5a9e8a671d3c3a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'TBTC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa33f162da19c7273ba1205bfd9d4340da2446e3a',
        poolV3Fee: 0.003,
        apr: 0.0992,
        tvlStaking: '1993872.67',
        tvlUsd: '1993872.67',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2775,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0xb869307c468be768f4ecf6778db9d5faaa2a7129',
        calculationConnector: '',
        source: '',
        origin: '0xf9f8138150f67a469fa5437e75ad16eaaab8c09e',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/PRIME',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x87cd18069b6547a0e88b6155dd657e71779500ea',
        poolV3Fee: 0.0025,
        apr: 0.2313,
        tvlStaking: '125465.85',
        tvlUsd: '125465.85',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2776,
        createdAt: '2024-11-11T10:41:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:21.000Z',
        beacon: '0x30efd0f0da164dea0559102ce1226b5dfc3a159f',
        calculationConnector: '',
        source: '',
        origin: '0x37e1a626b09fade99e94752942a88f17ea2170fd',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'TBTC/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf81e1a62cbfa487e807044618661bfd4802b4982',
        poolV3Fee: 0.003,
        apr: 0.1849,
        tvlStaking: '1032721.88',
        tvlUsd: '1032721.88',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2777,
        createdAt: '2024-11-11T10:41:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:35.000Z',
        beacon: '0x29219be24267b736702163b887b541b55c7fc016',
        calculationConnector: '',
        source: '',
        origin: '0xcb1137e326b8c48a5b8b29a5ccc19b6e8b9782d2',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/USOL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0225ba893d5f8ecd6d2022f9dec59b34f61098a1',
        poolV3Fee: 0.003,
        apr: 0.7584,
        tvlStaking: '1016332.51',
        tvlUsd: '1016332.51',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2778,
        createdAt: '2024-11-11T10:41:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:35.000Z',
        beacon: '0xae9330f03b912cf4508d01b719f47ea374362b17',
        calculationConnector: '',
        source: '',
        origin: '0x45f8b8ec9c92d09ba8495074436fd97073423041',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'AERO/WSTETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x565aecf84b5d30a6e79a5cef3f0da0fc4280debc',
        poolV3Fee: 0.01,
        apr: 0.5475,
        tvlStaking: '398053.28',
        tvlUsd: '398053.28',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2779,
        createdAt: '2024-11-11T10:41:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:35.000Z',
        beacon: '0xf69d2798a4bf3f1dfdfd3c05ee7c0bc6fadf4972',
        calculationConnector: '',
        source: '',
        origin: '0xfdb47b2dfcc65899e21ad86197fcee79c38dfab5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'DEGEN/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa19acc3b4f11c46c2b1fc36b5f592af422ee338c',
        poolV3Fee: 0.01,
        apr: 0.7925,
        tvlStaking: '6037.11',
        tvlUsd: '6037.11',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2780,
        createdAt: '2024-11-11T10:41:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:35.000Z',
        beacon: '0xbdbe23c23eabea459d40ee57ff63916c965c8c37',
        calculationConnector: '',
        source: '',
        origin: '0xf36283a09895edff51e9451cd70c64e53b5dc2bb',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WIF/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x090d9c28e1edca0e693a9e553b256e07ca2af021',
        poolV3Fee: 0.01,
        apr: 6.2269,
        tvlStaking: '87.40',
        tvlUsd: '87.40',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2781,
        createdAt: '2024-11-11T10:41:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:35.000Z',
        beacon: '0xe8503af165b471213f9594b9d8a56c8b2ce4879e',
        calculationConnector: '',
        source: '',
        origin: '0x8d88c541f22de965536bd1849013caee6ce90e11',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/RDNT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2092f4acbb18bb1649595df59b9cb601bba1ebb7',
        poolV3Fee: 0.003,
        apr: 3.0497,
        tvlStaking: '7355.25',
        tvlUsd: '7355.25',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2782,
        createdAt: '2024-11-11T10:41:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:35.000Z',
        beacon: '0x8a6460f2f8a59c2c910bc201b69db88bee8a78e7',
        calculationConnector: '',
        source: '',
        origin: '0x41513004596b32b5483620f55774e3a2a5cb9052',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/STTAO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x266f421f80016d670c9de757d561a5c4a6a9ffac',
        poolV3Fee: 0.003,
        apr: 0.05,
        tvlStaking: '322993.61',
        tvlUsd: '322993.61',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2783,
        createdAt: '2024-11-11T10:41:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:35.000Z',
        beacon: '0x3113aab0d814db479c08415726549e60bdeab5ce',
        calculationConnector: '',
        source: '',
        origin: '0xa53ba46f4f0280b42575a3baadac54a61db578d0',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USD+/WSTETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa01a2513e95263b9bace60b573ce874e1e7a5246',
        poolV3Fee: 0.0025,
        apr: 0.7811,
        tvlStaking: '3397.28',
        tvlUsd: '3397.28',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2784,
        createdAt: '2024-11-11T10:41:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-11T10:41:35.000Z',
        beacon: '0x9db8a48f7161a8bb84631d64ea8906bc2af383b8',
        calculationConnector: '',
        source: '',
        origin: '0x5e3f10acaa0ce7315fd9c29839569ad827a6500a',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'BRETT/USD+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfad14c545e464e04c737d00643296144eb20c7f8',
        poolV3Fee: 0.01,
        apr: 0.6442,
        tvlStaking: '9432.81',
        tvlUsd: '9432.81',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2915,
        createdAt: '2024-11-28T08:37:25.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-28T08:37:25.000Z',
        beacon: '0x20ea5c9aa99d4d113af2a60bce030e32b3add9c0',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/CAPO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc58fecb0c0f0d5b40b5bdac3cca989e8a49f732f',
        poolV3Fee: 0.01,
        apr: 0.0001,
        tvlStaking: '10956.56',
        tvlUsd: '10956.56',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2916,
        createdAt: '2024-11-30T15:54:29.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-30T15:54:29.000Z',
        beacon: '0xd914f140115a2f3c8a47286effe253bf2b24e361',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'SIMMI/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe9a65059e895dd5d49806f6a71b63fed0ffffd4b',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1704867.90',
        tvlUsd: '1704867.90',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2917,
        createdAt: '2024-11-30T15:54:29.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-30T15:54:29.000Z',
        beacon: '0xec1c943bcdf7191ff53e7d8c9b45fcea3f83d092',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'CLANKER/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc1a6fbedae68e1472dbb91fe29b51f7a0bd44f97',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1803271.61',
        tvlUsd: '1803271.61',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2918,
        createdAt: '2024-11-30T15:54:29.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-30T15:54:29.000Z',
        beacon: '0xf611300913f8cd570a6f5cd280014995aba6bcfa',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/GUAN',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x77c1b9db1197b5d9145036aef1221ac17b8e4a54',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '100.51',
        tvlUsd: '100.51',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2919,
        createdAt: '2024-11-30T15:54:29.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-30T15:54:29.000Z',
        beacon: '0x67db065f21d522adc84eb83f98a4add91add6788',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/AGENT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf239650fefb8feeb4d168a54fa071c7a8dfd3d65',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '735.67',
        tvlUsd: '735.67',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2920,
        createdAt: '2024-11-30T16:14:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-11-30T16:14:03.000Z',
        beacon: '0x726bef5871cb24416cd1296cbf0eb53a3775e021',
        calculationConnector: '',
        source: '',
        origin: '0xc23924a846eca931ec3014253e94f15b038bd0c8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/AIXBT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x22a52bb644f855ebd5ca2edb643ff70222d70c31',
        poolV3Fee: 0.0027,
        apr: 0.0248,
        tvlStaking: '8001266.66',
        tvlUsd: '8001266.66',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2922,
        createdAt: '2024-12-02T07:38:33.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-02T07:38:33.000Z',
        beacon: '0x7a3bf922743b7435c9765be4660c79b0644cbd4c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/GUAN',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb4bc690e35ff10327036ae8033b89863c0add929',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '15.09',
        tvlUsd: '15.09',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2923,
        createdAt: '2024-12-02T12:11:59.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-02T12:11:59.000Z',
        beacon: '0x70781cc6da54a9c4ce4438a7ba5ee2da10696c32',
        calculationConnector: '',
        source: '',
        origin: '0x283a6ffdd95f1145988e324f01663ff95247cce0',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'EXTRA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5a1401c002f67ca00557e7179d34c3fe6d753b28',
        poolV3Fee: 0.003,
        apr: 0.0073,
        tvlStaking: '56115.03',
        tvlUsd: '56115.03',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2925,
        createdAt: '2024-12-02T13:03:25.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-02T13:03:25.000Z',
        beacon: '0x384053ca21a720c90bf5200ade7540e21ce23699',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'VIRTUAL/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1d4dab3f27c7f656b6323c1d6ef713b48a8f72f1',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1034587.76',
        tvlUsd: '1034587.76',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2926,
        createdAt: '2024-12-02T13:03:25.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-02T13:03:25.000Z',
        beacon: '0x2db6c806ba16a96c5b519e5b3e20458d2ef00e5e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'VIRTUAL/LUNA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0f741e1f9ed5428b07ba4911497cce310647d0c2',
        poolV3Fee: 0.003,
        apr: 0.0018,
        tvlStaking: '388.97',
        tvlUsd: '388.97',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2927,
        createdAt: '2024-12-02T13:03:25.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-02T13:03:25.000Z',
        beacon: '0x4306e3727732b00660845c888d7681f32760413e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'AIXBT/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf1fdc83c3a336bdbdc9fb06e318b08eaddc82ff4',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1417652.56',
        tvlUsd: '1417652.56',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2928,
        createdAt: '2024-12-02T13:03:25.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-02T13:03:25.000Z',
        beacon: '0x068a7ee2d19f274413c792607cdb9145dbd123bd',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ANON/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc4ecaf115cbce3985748c58dccfc4722fef8247c',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '580588.49',
        tvlUsd: '580588.49',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2929,
        createdAt: '2024-12-02T13:03:25.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-02T13:03:25.000Z',
        beacon: '0x293c6b7abc5d3594c1e0e9bed7a430da01388ddc',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'LUM/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x717358a47ac99f3cd233e723be331756b3951164',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '205527.42',
        tvlUsd: '205527.42',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2930,
        createdAt: '2024-12-02T13:03:25.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-02T13:03:25.000Z',
        beacon: '0x62ad7b0b918764eb1819a641d8d738c0d0d5f631',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'FCAST/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4ec1828654b4a28936701d08164721876e88f456',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '42797.47',
        tvlUsd: '42797.47',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2931,
        createdAt: '2024-12-03T08:01:45.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-03T08:01:45.000Z',
        beacon: '0x6a1338ba20e929e87fe6c8f7bff84f662c882ee6',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'CHAOS/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x01a1f5758c3a53057b6c819ec7331e39c167794a',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '760970.93',
        tvlUsd: '760970.93',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3117,
        createdAt: '2024-12-11T21:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-11T21:18:47.000Z',
        beacon: '0xf9e93b859dbee8f7ee10442824ccddb9710cd4f3',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/REI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa213c82265cd3d94f972f735a4f5130e34df81bc',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '4929861.58',
        tvlUsd: '4929861.58',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3118,
        createdAt: '2024-12-11T21:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-11T21:18:47.000Z',
        beacon: '0xc22b297849b58f037caeaf6fc92b97cc1cc375bc',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'SIMMI/CHAOS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9b4705112943beb2215ee19fe31af657a55c9ab1',
        poolV3Fee: 0.01,
        apr: 0.0496,
        tvlStaking: '52.60',
        tvlUsd: '52.60',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 3119,
        createdAt: '2024-12-11T21:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-11T21:18:47.000Z',
        beacon: '0x9e20677cefbb37ba3126b6cf8014473e340bd812',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/SPEC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xee6f3c5f418d1097c50c4698d535edb33bd72931',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '12177.08',
        tvlUsd: '12177.08',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3120,
        createdAt: '2024-12-11T21:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-11T21:18:47.000Z',
        beacon: '0xd8079b6dc2ba1f4f3751ce00624cc1c877a64ca7',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/SPEC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8055e6de251e414e8393b20adab096afb3cf8399',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1134294.21',
        tvlUsd: '1134294.21',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3121,
        createdAt: '2024-12-11T21:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-11T21:18:47.000Z',
        beacon: '0x751417976a62b15326663e1aef38c2a7d7758f96',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ZERO/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x26cbe9f2ad77e811e40cd11c0d04ff182e3b0975',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '7137.56',
        tvlUsd: '7137.56',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3167,
        createdAt: '2024-12-17T15:13:35.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-17T15:13:35.000Z',
        beacon: '0xa7f30fc58d69f6da2807227d649de3b1f0c38a77',
        calculationConnector: '',
        source: '',
        origin: '0x4b9c4828a512ed379b8f2b656acc839a62265adb',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'UXRP/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x61c6e9e93592e535efc1bee07f491a517e98f6d0',
        poolV3Fee: 0.003,
        apr: 0.0486,
        tvlStaking: '3016812.72',
        tvlUsd: '3016812.72',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 3174,
        createdAt: '2024-12-20T11:20:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-20T11:20:03.000Z',
        beacon: '0xab276dc3e1335e35ca30e206d81e9d7b002eceb8',
        calculationConnector: '',
        source: '',
        origin: '0xbda319bc7cc8f0829df39ec0fff5d1e061ffadf7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'VIRTUAL/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc200f21efe67c7f41b81a854c26f9cda80593065',
        poolV3Fee: 0.0027,
        apr: 0.0741,
        tvlStaking: '41608961.18',
        tvlUsd: '41608961.18',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3176,
        createdAt: '2024-12-20T11:38:03.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-20T11:38:03.000Z',
        beacon: '0x10cc8ab585c52e3998d55653e718c81849bee40d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/VADER',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xebab2be57727f0165f4bb35d765377b951100b5f',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '57416.61',
        tvlUsd: '57416.61',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3177,
        createdAt: '2024-12-20T11:41:15.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-20T11:41:15.000Z',
        beacon: '0xad4da8dd168c8c85ab14890a4a7e443429a283d5',
        calculationConnector: '',
        source: '',
        origin: '0x937c527eb4f27030f6667078c64982b3202257d5',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x37785d5be19d0d9559d4634a5385c72c419b25da',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/RFL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3212,
        tvlStaking: '631528.28',
        tvlUsd: '631528.28',
        enabled: true,
        dexFactory: {
          id: 84735,
          chainId: 8453,
          address: '',
          name: 'Aerodrome',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3231,
        createdAt: '2024-12-30T13:43:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T13:43:21.000Z',
        beacon: '0x70f90300763da6b277d62d15e1c6a8afc5bbe3d8',
        calculationConnector: '',
        source: '',
        origin: '0x1c553b8cbcfa13c5f93394a3138e6c6ca16e3737',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'SIMMI/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xbae6f0e8d43e6158d3df940b332adc75beeba75f',
        poolV3Fee: 0.009,
        apr: 0.126,
        tvlStaking: '63869.26',
        tvlUsd: '63869.26',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3233,
        createdAt: '2024-12-30T13:43:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T13:43:21.000Z',
        beacon: '0x449e1649601f75b93ae92228bb741d513d8394ed',
        calculationConnector: '',
        source: '',
        origin: '0x6366138fd616df7e5906d7b00250634da342ee20',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'GAME/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2a36148a416cba81699b555120bd65f4682bdfd2',
        poolV3Fee: 0.007,
        apr: 3.315,
        tvlStaking: '54914.44',
        tvlUsd: '54914.44',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3235,
        createdAt: '2024-12-30T13:43:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T13:43:21.000Z',
        beacon: '0x557ab75877557f5a796620459b79a11e8f3e1571',
        calculationConnector: '',
        source: '',
        origin: '0x0592d3036ed8bfdf4545410edfc7f075227324a2',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'SEKOIA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x52f38a65dab3cf23478cc567110bec90162ab832',
        poolV3Fee: 0.009,
        apr: 0.3678,
        tvlStaking: '20513.26',
        tvlUsd: '20513.26',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3237,
        createdAt: '2024-12-30T13:43:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T13:43:21.000Z',
        beacon: '0xf50c44166898cd2fa0c9626d5f109de63f1207c1',
        calculationConnector: '',
        source: '',
        origin: '0x093b5fa753c6a4c94b0ae98326919a5e241901a0',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/FAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x28a9ec9928a689410e82e579fd9418fbbf6452f3',
        poolV3Fee: 0.005,
        apr: 3.837,
        tvlStaking: '157546.95',
        tvlUsd: '157546.95',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3239,
        createdAt: '2024-12-30T13:43:21.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T13:43:21.000Z',
        beacon: '0xa612fabadbd819962f7469e2bcbc66adfdd87358',
        calculationConnector: '',
        source: '',
        origin: '0xa4a7e0dae53e9de540ddef4bb7214499dfdea07d',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/REI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x54cdd0222df6b3bc17754c2c1b3d7d4203fe3d89',
        poolV3Fee: 0.008,
        apr: 1.8047,
        tvlStaking: '152408.46',
        tvlUsd: '152408.46',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3241,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0xa2c2a5fb5efdeb02cad3bcd23059958987fdcc3c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'GAME/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe5ff624bc6c0f85c5e1e27f94366b5829b1877a3',
        poolV3Fee: 0.01,
        apr: 0.0648,
        tvlStaking: '6143.14',
        tvlUsd: '6143.14',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3242,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0x2861dc2c35508f1ef3debdda712ef54caff5ffdb',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'VIRTUAL/GAME',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1b199d80188fc0488f938e14c5a361f858d882b6',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '58475.11',
        tvlUsd: '58475.11',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3243,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0xf49fad7502fe36459b99503dff5c95d2235982d2',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/CONVO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xce6709d66854e09de838cc56e7f4a0661fa3c432',
        poolV3Fee: 0.01,
        apr: 0.0685,
        tvlStaking: '7881.16',
        tvlUsd: '7881.16',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3244,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0x491bdf46bf1200bda0338b50b2ae8814e86ba7d4',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'SEKOIA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2c114787d52e9f080464dbed8e285e07ec4e120f',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '7502.31',
        tvlUsd: '7502.31',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3245,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0x3f9b37946713a9638f4d6bbe1854bdae2bd836d7',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/H4CK',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcfccd3eb9f54fc9b3e171e9d128160701f38033b',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '360.12',
        tvlUsd: '360.12',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3246,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0xe7ce3110e515db13b21b75997423f8da69180e18',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'FDREAM/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0ebcee3165654d9c52dd6d438423be76f2df1b0e',
        poolV3Fee: 0.01,
        apr: 0.0031,
        tvlStaking: '11330.20',
        tvlUsd: '11330.20',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3247,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0xbae4769700390a7ba478b4923d52c88eb36fcfa8',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'VIRTUAL/AIXCB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8de9eb567b5eaa3ed205161e1d80c567c4ab9907',
        poolV3Fee: 0.01,
        apr: 0.0005,
        tvlStaking: '11402.27',
        tvlUsd: '11402.27',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3248,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0x9872d9fc898241790c76992a5119858860894f5d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/SIM',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb7c971aab3c79f54bf94cf8f7c5fd3688936e57f',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '88080.89',
        tvlUsd: '88080.89',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3249,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0x4f6c6558f83af18c7a00de0f07f4b3af4e8ad3d1',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/FAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x68b27e9066d3aadc6078e17c8611b37868f96a1d',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1632044.32',
        tvlUsd: '1632044.32',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3250,
        createdAt: '2024-12-30T15:04:13.000Z',
        chainId: 8453,
        dateOfAdd: '2024-12-30T15:04:13.000Z',
        beacon: '0x99ef626b2f978608161234c135f07459a409407c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'DORA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2f25d28f03bbcda4675875171bc53bf40cff2c9d',
        poolV3Fee: 0.01,
        apr: 0.0172,
        tvlStaking: '5470.07',
        tvlUsd: '5470.07',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4231,
        createdAt: '2025-01-31T09:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2025-01-31T09:40:39.000Z',
        beacon: '0xd4222d0fffeda82c716eae85137035e7f1126159',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'GIA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0f4647926fba360fdff107917682fad847a54d6b',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '77021.44',
        tvlUsd: '77021.44',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4232,
        createdAt: '2025-01-31T09:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2025-01-31T09:40:39.000Z',
        beacon: '0x69a01ed62ab91c40e3f5423c7c9c7d8056a7f74d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'GIA/EMP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x45e20300f4a1d13c86440b098ecc5673ca927928',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '117423.57',
        tvlUsd: '117423.57',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4233,
        createdAt: '2025-01-31T09:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2025-01-31T09:40:39.000Z',
        beacon: '0x7cfb656485a07b482b7547bcea7c78b3e432b9ec',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/GDEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x65b6ee9cac744d4eed9886406ead6bc4e5681068',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1423779.79',
        tvlUsd: '1423779.79',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4234,
        createdAt: '2025-01-31T09:40:39.000Z',
        chainId: 8453,
        dateOfAdd: '2025-01-31T09:40:39.000Z',
        beacon: '0x6b6d1ed565771affdd6078aff466c14044e2a653',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'EMP/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x734fa91d5ccdf79a6bb2716eb5d3ff78cbace536',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '428725.76',
        tvlUsd: '428725.76',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4237,
        createdAt: '2025-02-06T09:16:19.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:16:19.000Z',
        beacon: '0x4176c8841fa8d74e29646e1d0375d9c11de44c48',
        calculationConnector: '',
        source: '',
        origin: '0xeca59a0fbd6498b4d3d6e4143a30c2e8d8f68686',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/ANON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1807af3897aa6419e770d4642df7b8b06e542c02',
        poolV3Fee: 0.008,
        apr: 0.832,
        tvlStaking: '80277.83',
        tvlUsd: '80277.83',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4238,
        createdAt: '2025-02-06T09:16:19.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:16:19.000Z',
        beacon: '0xdfeca91842f538b54614987a41001d151c92a8f9',
        calculationConnector: '',
        source: '',
        origin: '0x9c590e540b6d2b602565d00eb47023a2ea66f4e0',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/LUNA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb6b777577a05d85ffca7d9ebc7476fb344b92445',
        poolV3Fee: 0.007,
        apr: 0.1905,
        tvlStaking: '34308.09',
        tvlUsd: '34308.09',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4239,
        createdAt: '2025-02-06T09:16:19.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:16:19.000Z',
        beacon: '0xb4a8af2392674dc33dcfbfc274a5391b8d77a69b',
        calculationConnector: '',
        source: '',
        origin: '0x7cfffd69796e607a38a36be004074941cf58b7b9',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/SAINT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xeb4ab2038ef5662ff00acabbb76a09abd7440d10',
        poolV3Fee: 0.006,
        apr: 1.2506,
        tvlStaking: '2019.48',
        tvlUsd: '2019.48',
        enabled: false,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4240,
        createdAt: '2025-02-06T09:16:19.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:16:19.000Z',
        beacon: '0xc90e2eae253d7aadf12384915a2eb630692914b1',
        calculationConnector: '',
        source: '',
        origin: '0x6831125a82af7417e0cde3a214c03fe248ff6aa8',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/VVV',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x46d398a5b33709877f50c8918a7ee96f1be1d7dd',
        poolV3Fee: 0.008,
        apr: 0.0781,
        tvlStaking: '1121799.48',
        tvlUsd: '1121799.48',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4241,
        createdAt: '2025-02-06T09:16:19.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:16:19.000Z',
        beacon: '0x0c192e5c176b615c436a3936d7186835583c88c5',
        calculationConnector: '',
        source: '',
        origin: '0x5d05ef25a5f933271e1f0fdc02dc3eab6a4ea687',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/VVV',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x7ec6c9d993d9832aa654593f2dbc21303650bc6c',
        poolV3Fee: 0.0025,
        apr: 1.3972,
        tvlStaking: '236478.50',
        tvlUsd: '236478.50',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4242,
        createdAt: '2025-02-06T09:16:19.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:16:19.000Z',
        beacon: '0xd51ab57bffa8b9cd50745a7b9fdf9c2a889af7a6',
        calculationConnector: '',
        source: '',
        origin: '0x527b83782b2ef0c5506e79333ca709d81644952f',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/TOSHI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x74e4c08bb50619b70550733d32b7e60424e9628e',
        poolV3Fee: 0.0025,
        apr: 7.0837,
        tvlStaking: '234794.38',
        tvlUsd: '234794.38',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4249,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0x6914b90638e53fabf536d53213f08f74765ad953',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/ANON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc197d33b4eeb83ae01fef727f74f360efb6f4d7e',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '42527.02',
        tvlUsd: '42527.02',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4250,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0xa0b389e0733e6a1f7c353eb977dd49d6ae7eba40',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/COOKIE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x97f0470819080e85724d42ba4325c56698c3b387',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '138232.63',
        tvlUsd: '138232.63',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4251,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0x3be9640a6112d9fad46f82453d83710a2b318ac2',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'BNKR/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xaec085e5a5ce8d96a7bdd3eb3a62445d4f6ce703',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '3405411.36',
        tvlUsd: '3405411.36',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4252,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0x2bf9505917535d2d54a29e3ac0188968d31b21c1',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/GUD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x6d8503c85340176f61d5593182cccd37ba7e9b6a',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '327990.53',
        tvlUsd: '327990.53',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4253,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0x01fba79681f56509547f83ea6349e807c66c71b6',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'KUDAI/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x670e77c361375be9013869ccc516027ccc90383f',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '704814.36',
        tvlUsd: '704814.36',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4254,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0x0f7f3c9936bdb3fc5b85ddb65b6e08310b0d00b4',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/LUNA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3a3dc4a26d1aceae12fd1026a5856f12d20658ea',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '20831.02',
        tvlUsd: '20831.02',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4255,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0xb632224cb57028cb04702329ef8af80a643ac2ab',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/AIXBT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x47808ddbc91646b21b307fefbaf7ee200b004ccc',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '123348.35',
        tvlUsd: '123348.35',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4256,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0xa7992604144225131accef28c2338d4131ad2248',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'POLY/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3ba13e5074292aaba8f56faf65055952ccc20dc6',
        poolV3Fee: 0.01,
        apr: 0.0008,
        tvlStaking: '4712.81',
        tvlUsd: '4712.81',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4257,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0x6d3ffa7a6ed13c06cddae6bed6abd785d895b410',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/SAINT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x774a61f53f14d3bf92dfcdb79c5b6a8ad5f06965',
        poolV3Fee: 0.01,
        apr: 0.0025,
        tvlStaking: '15584.27',
        tvlUsd: '15584.27',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4258,
        createdAt: '2025-02-06T09:18:41.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:41.000Z',
        beacon: '0xd98c417fa3e66ec1b5d404453576969ff9743226',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/CALLS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc50578736dcbb177de5d42b597edb4b1ad26848d',
        poolV3Fee: 0.01,
        apr: 0.0047,
        tvlStaking: '5391.93',
        tvlUsd: '5391.93',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4259,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0x4a4067766ba038a119ce57cb7cf944538286b572',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/CERTAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x094080dfa2467263159f8054b3960f90996bfd77',
        poolV3Fee: 0.01,
        apr: 0.0594,
        tvlStaking: '15126.55',
        tvlUsd: '15126.55',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4260,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0x2fdb89d0a4b2ed6dc47cba4b1d71d70f591c6fa7',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/G3',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xd8582fc6daf45ed8076292e7a8586e87fd67bc0c',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '32841.67',
        tvlUsd: '32841.67',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4261,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0xf03d7b6f1cde491c1cefd23fef71a5a263c93cac',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'NFTXBT/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf8d0037be52d84a28a3b95b88590aadee605e41f',
        poolV3Fee: 0.01,
        apr: 0.0047,
        tvlStaking: '6373.09',
        tvlUsd: '6373.09',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4262,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0x15500d21108fa27610c40d0020a137dc32c4d5e5',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/VVV',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1d2bdb7117a5a7d7fe4c1d95681a92e4df13bb69',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1045144.39',
        tvlUsd: '1045144.39',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4263,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0x15bc60841bef5117fe2624aa8edcd83c67d8e95a',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/VVV',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf85fa96193f411ae7baa892dd4abb7dacedf9191',
        poolV3Fee: 0.01,
        apr: 0.0139,
        tvlStaking: '12419.95',
        tvlUsd: '12419.95',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4264,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0x3482337a7ae9add7e202007184e28bc43384abf3',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/VVV',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x67a11022b7b6ed66f81233f6c8ed6e48f7826530',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '36047.27',
        tvlUsd: '36047.27',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4265,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0x366739ac07dc9b3390b3647bb39898bbb1e345cf',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/TOSHI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4b0aaf3ebb163dd45f663b38b6d93f6093ebc2d3',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '5085219.88',
        tvlUsd: '5085219.88',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4266,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0x315e2bca9c089cedf897bca7c6c6739dee7ab101',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/TOSHI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5aa4ad647580bfe86258d300bc9852f4434e2c61',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '414566.44',
        tvlUsd: '414566.44',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4267,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0xf4bf463da795909b0c27eacc4ed7bfc42bc168a1',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/TOSHI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfc131b9981fb053c2cab7373daf70def1436c4bb',
        poolV3Fee: 0.01,
        apr: 0.0377,
        tvlStaking: '11679.12',
        tvlUsd: '11679.12',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4268,
        createdAt: '2025-02-06T09:18:47.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:47.000Z',
        beacon: '0x60364da2444bf50ea6789b80f2dedc0e024ba448',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/OBT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb49a3eb20ada6fa09104c06690b9ab45959c153d',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '43362.84',
        tvlUsd: '43362.84',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4269,
        createdAt: '2025-02-06T09:18:51.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:51.000Z',
        beacon: '0x98d9a82a86766acabfdf3922703ead0ccfdbb1dc',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/TRUMP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xaa4bdf13c4ca0594daebb38ae7d772b7e975b284',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '104814.79',
        tvlUsd: '104814.79',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4270,
        createdAt: '2025-02-06T09:18:51.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-06T09:18:51.000Z',
        beacon: '0x768b39d97ffab006dc7010f1a935d502c40f92d6',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/AIXCB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x062d9afe7d0c0cbc1806b8c035ee6a08268362f2',
        poolV3Fee: 0.01,
        apr: 0.0002,
        tvlStaking: '15894.01',
        tvlUsd: '15894.01',
        enabled: false,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4619,
        createdAt: '2025-02-14T18:55:59.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-14T18:55:59.000Z',
        beacon: '0xc325e5bbe7bb0761c96dba4232c25cab3c595e11',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/TRUMP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xaa4bdf13c4ca0594daebb38ae7d772b7e975b284',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '104814.79',
        tvlUsd: '104814.79',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 4652,
        createdAt: '2025-02-17T08:51:53.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-17T08:51:53.000Z',
        beacon: '0xc7c304319152d97e9b36ecbcea77e6e37c9d719e',
        calculationConnector: '',
        source: '',
        origin: '0x0c1d14b66e74fbb35d53a0c97dbe93fa8a97bbe7',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'USDC/TRUMP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0c40e7f5b43f6759060a3c4d2fb406dfecf03b57',
        poolV3Fee: 0.003,
        apr: 0.0389,
        tvlStaking: '40614.92',
        tvlUsd: '40614.92',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4687,
        createdAt: '2025-02-21T15:18:59.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-21T15:18:59.000Z',
        beacon: '0x9e8dc131b1e403f66b454f645dd6cd71b26258f3',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/KAITO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2ea054c177abd8b8c87704eaa08680db5c6d805c',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '330374.97',
        tvlUsd: '330374.97',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4688,
        createdAt: '2025-02-21T15:18:59.000Z',
        chainId: 8453,
        dateOfAdd: '2025-02-21T15:18:59.000Z',
        beacon: '0x6fc1d5ce4258015561669171211564879418df4c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'FROC/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x74f8a8c18010659a456c8584e625996ab62c1b62',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '457690.41',
        tvlUsd: '457690.41',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 7826,
        createdAt: '2025-03-11T16:42:03.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-11T16:42:03.000Z',
        beacon: '0xc8a87673b9ac8851d400eb25f0bec539f55aa6a4',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'GRK/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb5a0da376245e67b2e55e4f011b4daa464278cfa',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '166728.43',
        tvlUsd: '166728.43',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9382,
        createdAt: '2025-03-11T10:35:49.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-11T10:35:49.000Z',
        beacon: '0x59feeec81248d59a286b1d4c9030206d9e3bb051',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'DRB/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5116773e18a9c7bb03ebb961b38678e45e238923',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '1690413.73',
        tvlUsd: '1690413.73',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9384,
        createdAt: '2025-03-12T15:22:37.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-12T15:22:37.000Z',
        beacon: '0xc85fc7e057e92e186fc728db56010f2a4b44be1e',
        calculationConnector: '',
        source: '',
        origin: '0x3b86ca918e7c114cf8ddf69609e53bb4e7727237',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/B3',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb099c658e784b41ee435d48a8eb67e8f27285c93',
        poolV3Fee: 0.0025,
        apr: 1.4807,
        tvlStaking: '147865.56',
        tvlUsd: '147865.56',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9501,
        createdAt: '2025-03-24T14:00:25.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-24T14:00:25.000Z',
        beacon: '0xfc3eebe935b772137b7df4fdc6a46d6aafa15b4e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: '$COOL/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe8f548d25db0b4073c34ec2c5d3f30b1a5b72da8',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '461020.37',
        tvlUsd: '461020.37',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9502,
        createdAt: '2025-03-24T14:00:25.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-24T14:00:25.000Z',
        beacon: '0x216635ca15571efb35da3da446f58db5e61b1638',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'CLIZA/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x76c0106bba123e9b32770b2b34b6d13bf4cfa933',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '629674.33',
        tvlUsd: '629674.33',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9503,
        createdAt: '2025-03-24T14:00:25.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-24T14:00:25.000Z',
        beacon: '0x8c73f62279f942215842d9d56238e93fab7e67e2',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'HEIR/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf3610a81ea40175346e272387498433fc27a8fda',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '94085.91',
        tvlUsd: '94085.91',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9504,
        createdAt: '2025-03-25T08:00:05.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-25T08:00:05.000Z',
        beacon: '0x39bd22efb6a0d6c99d7d399ab000d9de6c3deb00',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'FARTCOIN/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfdbaf04326acc24e3d1788333826b71e3291863a',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '2686818.29',
        tvlUsd: '2686818.29',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9505,
        createdAt: '2025-03-25T08:00:05.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-25T08:00:05.000Z',
        beacon: '0x25fdf659d51a9b921307382c88dcb9e4dee8de3b',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 40,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x03a520b32c04bf3beef7beb72e919cf822ed34f1',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/OKAYEG',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x58342c302dd4df0531f60dd3c0eabb0c95ac08cb',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '470715.50',
        tvlUsd: '470715.50',
        enabled: true,
        dexFactory: {
          id: 95087,
          chainId: 8453,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9506,
        createdAt: '2025-03-25T08:07:55.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-25T08:07:55.000Z',
        beacon: '0xa058faf081637e906656a50506213c404406408c',
        calculationConnector: '',
        source: '',
        origin: '0x7a53fd90c6fb9ffd8eebc668300fe42e151cfa02',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'DRB/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x385b47e56b73eb6549378f78f7c7cbc42c56c9e0',
        poolV3Fee: 0.0025,
        apr: 0.1372,
        tvlStaking: '196521.43',
        tvlUsd: '196521.43',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9507,
        createdAt: '2025-03-25T08:07:55.000Z',
        chainId: 8453,
        dateOfAdd: '2025-03-25T08:07:55.000Z',
        beacon: '0x31257c6abbaad5338b27356197353a827f8fbada',
        calculationConnector: '',
        source: '',
        origin: '0x6205dfbe68444cff504a20a712cea794c6b6cf04',
        vaultFactoryId: 40,
        rewardTokens: ['0x940181a94a35a4569e4529a3cdfb74e38fd98631'],
        rewardTokenType: '',
        stakingToken: '0x827922686190790b37229fd06084350e74485b72',
        stakingTokenType: 'ERC721-AERODROME-CL-GAUGE',
        stakeTokenSymbol: 'WETH/KAITO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x56b92e5b391dbfb8b8028ac95a4b97f52ffeb416',
        poolV3Fee: 0.002511,
        apr: 0.0224,
        tvlStaking: '10732822.76',
        tvlUsd: '10732822.76',
        enabled: true,
        dexFactory: {
          id: 95112,
          chainId: 8453,
          address: '',
          name: 'Aerodrome-CL',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
    ],
    profitClaimer: '0x6e46730c49bdc498d0becef214f094d15bcc1901',
  },
  {
    id: 41,
    factory: '0x3ace08b10b5c08a17d1c46277d65c81249e65f44',
    chainId: 56,
    name: 'bsc',
    enabled: true,
    migrator: '0x76ae096ced2bda7fa56404cff9654cc4ead05c7f',
    zapper: '0x96179aecd27301bd63e3f1d627003eddf3d0cb44',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.055',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0xa7a05771422daa64b318c17da250c922090cfd82',
      '0xba65c5086caf782616395cb165877e8e963c59b1',
      '0x0a5bb74d578b228c73bc073d051dfcd56a6cbaf4',
    ],
    underlyingZapperTokensWl: [],
    farms: [
      {
        id: 559,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0x4fa7b90907892af8a7222011d0294b7b4611e957',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'CAKE/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x133b3d95bad5405d14d53473671200e9342896bf',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '5450219.92',
        tvlUsd: '5450219.92',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 560,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0x6bcd834071963d008937d2f7c926022a5f6ef3d4',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'CAKE/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x7f51c8aaa6b0599abd16674e2b17fec7a9f674a1',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '5291503.89',
        tvlUsd: '5291503.89',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 561,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0xe39ea0508d3122882a76f29386baac079df6a5c4',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ETH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0xbe141893e4c6ad9272e8c04bab7e6a10604501a5',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '2665688.19',
        tvlUsd: '2665688.19',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 562,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0x8beb1c906a94d4295c7cb6d2d707cb9a8120c27e',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ETH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x66e9acba7c3a82c8ee02faf3e325dd55d6581a8c',
        poolV3Fee: 0.0025,
        apr: 0.031,
        tvlStaking: '13415.35',
        tvlUsd: '13415.35',
        enabled: false,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 563,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0x930a0bc0f639db939128628f0431cbdbc3f999ec',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USDT/ALPACA',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        poolV3: '0xcfe783e16c9a8c74f2be9bceb2339769439061bf',
        poolV3Fee: 0.01,
        apr: 0.193,
        tvlStaking: '1308.75',
        tvlUsd: '1308.75',
        enabled: false,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 564,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0x08312d2f3c18bd17153753c874cc50f1a95b2db2',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WBNB/XVS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x77d5b2560e4b84b3fc58875cb0133f39560e8ae3',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '7555.08',
        tvlUsd: '7555.08',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 565,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0x18ccf94b3c6acdd5edd7d75a0b194f6ec45e67b2',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'DOGE/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        poolV3: '0xce6160bb594fc055c943f59de92cee30b8c6b32c',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '192005.55',
        tvlUsd: '192005.55',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 566,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0xe88e56d46be9bb7a249acd6206ed2f923afc2294',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WBNB/UNI',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x647d99772863e09f47435782cbb6c96ec4a75f12',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '80525.23',
        tvlUsd: '80525.23',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 567,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0xa67132ed7201add7ca67d57c3fc03915a0048104',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'BTCB/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x6bbc40579ad1bbd243895ca0acb086bb6300d636',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1869941.33',
        tvlUsd: '1869941.33',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 568,
        createdAt: '2024-01-12T14:18:15.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:15.000Z',
        beacon: '0x9510b7e39fe9e8ed05361e0cbcc8144a27eeab5f',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'BTCB/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0xfc75f4e78bf71ed5066db9ca771d4ccb7c1264e0',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '1809904.54',
        tvlUsd: '1809904.54',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 569,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0xacbbffb08948e3b115c1b22e5af338fb8e024983',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ETH/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0xd0e226f674bbf064f54ab47f42473ff80db98cba',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1290180.83',
        tvlUsd: '1290180.83',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 570,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x1d2720fd2c26f6ad4d988b9c8d49cd009938a282',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ETH/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x7d05c84581f0c41ad80ddf677a510360bae09a5a',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '1658936.96',
        tvlUsd: '1658936.96',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 571,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0xdc21b1cdbaf59b1f37aeb474629ab7a875bf2f2f',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'AXLUSDC/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x803036ac78752ef599ec75c500ac8b0ac0be67df',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '5367.63',
        tvlUsd: '5367.63',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 572,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x6cac1edef7fed002eb8342cb223e261b559a5533',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'PENDLE/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x85bea4fbc57fa22b41fb1632f0d9a6a99390fd0a',
        poolV3Fee: 0.01,
        apr: 9.6464,
        tvlStaking: '3445.67',
        tvlUsd: '3445.67',
        enabled: false,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 573,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0xbfdbc099758418bf772e7e6584c8f9f2a5b6775d',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USDT/BTCB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x46cf1cf8c69595804ba91dfdd8d6b960c9b0a7c4',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '903105.46',
        tvlUsd: '903105.46',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 574,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x1aef4e1d1a9fc8236b97c4effe2ae527bf3e28e4',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ETH/BTCB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x4bba1018b967e59220b22ca03f68821a3276c9a6',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '508227.64',
        tvlUsd: '508227.64',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: true,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 575,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x8b6a81edeb01fa85997c468374f99c612ca89db4',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ETH/BTCB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0xd4dca84e1808da3354924cd243c66828cf775470',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '3958525.40',
        tvlUsd: '3958525.40',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: true,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 576,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x43dcbb2b5165cac70d0dbbed7cfecd9647fd9d45',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x539e0ebfffd39e54a0f7e5f8fec40ade7933a664',
        poolV3Fee: 0.0005,
        apr: 0.2356,
        tvlStaking: '2365.06',
        tvlUsd: '2365.06',
        enabled: false,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 577,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x10ee3509e013c05f3e4fd7b048b6aa2725b8a3bf',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'USDT/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x92b7807bf19b7dddf89b706143896d05228f3121',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '11210489.77',
        tvlUsd: '11210489.77',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 578,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x1102ca926eacc46c8e9d22562698bf8468b6a4c9',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'ADA/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x673516e510d702ab5f2bbf0c6b545111a85f7ea7',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '786229.41',
        tvlUsd: '786229.41',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 579,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x058ac0d8ba849c7cce00894f5609cccbe236a321',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'DOT/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        poolV3: '0x62f0546cbcd684f7c394d8549119e072527c41bc',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '47900.01',
        tvlUsd: '47900.01',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 580,
        createdAt: '2024-01-12T14:18:18.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T14:18:18.000Z',
        beacon: '0x093fa209d8c527508b56f36b09e4b9ac3f2797f4',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'WBNB/SFP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x64ebb904e169cb94e9788fcb68283b4c894ed881',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '1038967.10',
        tvlUsd: '1038967.10',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 582,
        createdAt: '2024-01-12T15:23:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T15:23:54.000Z',
        beacon: '0x1e33b41e96610bdc9f8c5f331143d490123a3446',
        calculationConnector: '',
        source: '',
        origin: '0xdbc1a13490deef9c3c12b44fe77b503c1b061739',
        vaultFactoryId: 41,
        rewardTokens: ['0x965f527d9159dce6288a2219db51fc6eef120dd1'],
        rewardTokenType: '',
        stakingToken: '0xacaac9311b0096e04dfe96b6d87dec867d3883dc',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBNB/BUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '340230.78',
        tvlUsd: '340230.78',
        enabled: false,
        dexFactory: {
          id: 84757,
          chainId: 56,
          address: '',
          name: 'Biswap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 583,
        createdAt: '2024-01-12T15:23:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T15:23:54.000Z',
        beacon: '0x2349e6c1435b8809f49f8683888b1c86dd045b6b',
        calculationConnector: '',
        source: '',
        origin: '0xdbc1a13490deef9c3c12b44fe77b503c1b061739',
        vaultFactoryId: 41,
        rewardTokens: ['0x965f527d9159dce6288a2219db51fc6eef120dd1'],
        rewardTokenType: '',
        stakingToken: '0xacaac9311b0096e04dfe96b6d87dec867d3883dc',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBNB/BUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '340230.78',
        tvlUsd: '340230.78',
        enabled: false,
        dexFactory: {
          id: 84757,
          chainId: 56,
          address: '',
          name: 'Biswap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 591,
        createdAt: '2024-01-12T15:23:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T15:23:54.000Z',
        beacon: '0x84c206e71eef16d95e42728d4f3dccf1bc752544',
        calculationConnector: '',
        source: '',
        origin: '0xdbc1a13490deef9c3c12b44fe77b503c1b061739',
        vaultFactoryId: 41,
        rewardTokens: ['0x965f527d9159dce6288a2219db51fc6eef120dd1'],
        rewardTokenType: '',
        stakingToken: '0x1483767e665b3591677fd49f724bf7430c18bf83',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDT/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '144566.92',
        tvlUsd: '144566.92',
        enabled: false,
        dexFactory: {
          id: 84757,
          chainId: 56,
          address: '',
          name: 'Biswap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 628,
        createdAt: '2024-01-12T15:25:36.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T15:25:36.000Z',
        beacon: '0x3968dae3d1bc7d32386df66bc342366e6b73ac71',
        calculationConnector: '',
        source: '',
        origin: '0xdbc1a13490deef9c3c12b44fe77b503c1b061739',
        vaultFactoryId: 41,
        rewardTokens: ['0x965f527d9159dce6288a2219db51fc6eef120dd1'],
        rewardTokenType: '',
        stakingToken: '0x5dc30bb8d7f02efef28f7e637d17aea13fa96906',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'XRP/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '47802.28',
        tvlUsd: '47802.28',
        enabled: false,
        dexFactory: {
          id: 84757,
          chainId: 56,
          address: '',
          name: 'Biswap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 629,
        createdAt: '2024-01-12T15:25:36.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T15:25:36.000Z',
        beacon: '0x80022eca05caa8e79341ea46df0974fdff015897',
        calculationConnector: '',
        source: '',
        origin: '0xdbc1a13490deef9c3c12b44fe77b503c1b061739',
        vaultFactoryId: 41,
        rewardTokens: ['0x965f527d9159dce6288a2219db51fc6eef120dd1'],
        rewardTokenType: '',
        stakingToken: '0xe0caab61ee7a12d03b268e1f6a56537ac1b61d13',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DAI/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0,
        tvlStaking: '9862.44',
        tvlUsd: '9862.44',
        enabled: false,
        dexFactory: {
          id: 84757,
          chainId: 56,
          address: '',
          name: 'Biswap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 632,
        createdAt: '2024-01-12T15:25:36.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T15:25:36.000Z',
        beacon: '0xd4d8693f12edc5e2c96b35c2b10ae0edd3f24036',
        calculationConnector: '',
        source: '',
        origin: '0xdbc1a13490deef9c3c12b44fe77b503c1b061739',
        vaultFactoryId: 41,
        rewardTokens: ['0x965f527d9159dce6288a2219db51fc6eef120dd1'],
        rewardTokenType: '',
        stakingToken: '0x06cd679121ec37b0a2fd673d4976b09d81791856',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '49156.05',
        tvlUsd: '49156.05',
        enabled: false,
        dexFactory: {
          id: 84757,
          chainId: 56,
          address: '',
          name: 'Biswap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 638,
        createdAt: '2024-01-12T15:32:12.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-12T15:32:12.000Z',
        beacon: '0x28d9cc12d50807d956d64fe074a4ea61830fb686',
        calculationConnector: '',
        source: '',
        origin: '0xdbc1a13490deef9c3c12b44fe77b503c1b061739',
        vaultFactoryId: 41,
        rewardTokens: ['0x965f527d9159dce6288a2219db51fc6eef120dd1'],
        rewardTokenType: '',
        stakingToken: '0x2f3899ffb9fdcf635132f7bb94c1a3a0f906cc6f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AVAX/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0,
        tvlStaking: '47100.79',
        tvlUsd: '47100.79',
        enabled: false,
        dexFactory: {
          id: 84757,
          chainId: 56,
          address: '',
          name: 'Biswap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 675,
        createdAt: '2024-01-18T13:00:23.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:00:23.000Z',
        beacon: '0xfcf98a49a86379df1f3aab9c63e09aa427573d00',
        calculationConnector: '',
        source: '',
        origin: '0xc48fe252aa631017df253578b1405ea399728a50',
        vaultFactoryId: 41,
        rewardTokens: ['0x9c65ab58d8d978db963e63f2bfb7121627e3a739'],
        rewardTokenType: '',
        stakingToken: '0x9f4da89774570e27170873befd139a79cb1a3da2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDT/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 2e-5,
        tvlStaking: '76272.51',
        tvlUsd: '76272.51',
        enabled: true,
        dexFactory: {
          id: 84801,
          chainId: 56,
          address: '',
          name: 'Mdex',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 677,
        createdAt: '2024-01-18T13:00:23.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:00:23.000Z',
        beacon: '0xb62c7a61e2cc7674273fd270d1632d42a93fe1ca',
        calculationConnector: '',
        source: '',
        origin: '0xc48fe252aa631017df253578b1405ea399728a50',
        vaultFactoryId: 41,
        rewardTokens: ['0x9c65ab58d8d978db963e63f2bfb7121627e3a739'],
        rewardTokenType: '',
        stakingToken: '0x0fb881c078434b1c0e4d0b64d8c64d12078b7ce2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ETH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 3.3e-6,
        tvlStaking: '42460.77',
        tvlUsd: '42460.77',
        enabled: true,
        dexFactory: {
          id: 84801,
          chainId: 56,
          address: '',
          name: 'Mdex',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 678,
        createdAt: '2024-01-18T13:00:23.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:00:23.000Z',
        beacon: '0x8bc81959d245ce7ad49483d7efc95f869ce8e787',
        calculationConnector: '',
        source: '',
        origin: '0xc48fe252aa631017df253578b1405ea399728a50',
        vaultFactoryId: 41,
        rewardTokens: ['0x9c65ab58d8d978db963e63f2bfb7121627e3a739'],
        rewardTokenType: '',
        stakingToken: '0xda28eb7aba389c1ea226a420bce04cb565aafb85',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDT/BTCB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0004,
        tvlStaking: '17986.60',
        tvlUsd: '17986.60',
        enabled: false,
        dexFactory: {
          id: 84801,
          chainId: 56,
          address: '',
          name: 'Mdex',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 679,
        createdAt: '2024-01-18T13:00:23.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:00:23.000Z',
        beacon: '0xeb3eea16023c537e6d0c4f5960b34f95d54f20f6',
        calculationConnector: '',
        source: '',
        origin: '0xc48fe252aa631017df253578b1405ea399728a50',
        vaultFactoryId: 41,
        rewardTokens: ['0x9c65ab58d8d978db963e63f2bfb7121627e3a739'],
        rewardTokenType: '',
        stakingToken: '0x62c1dec1ff328dcdc157ae0068bb21af3967acd9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDT/BUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.9e-8,
        tvlStaking: '253279.55',
        tvlUsd: '253279.55',
        enabled: true,
        dexFactory: {
          id: 84801,
          chainId: 56,
          address: '',
          name: 'Mdex',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 680,
        createdAt: '2024-01-18T13:00:23.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:00:23.000Z',
        beacon: '0xbf9031326d62615f92c90f725b3a28a6eac7dc34',
        calculationConnector: '',
        source: '',
        origin: '0xc48fe252aa631017df253578b1405ea399728a50',
        vaultFactoryId: 41,
        rewardTokens: ['0x9c65ab58d8d978db963e63f2bfb7121627e3a739'],
        rewardTokenType: '',
        stakingToken: '0x223740a259e461abee12d84a9fff5da69ff071dd',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MDX/BUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1e-7,
        tvlStaking: '36360.72',
        tvlUsd: '36360.72',
        enabled: true,
        dexFactory: {
          id: 84801,
          chainId: 56,
          address: '',
          name: 'Mdex',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 681,
        createdAt: '2024-01-18T13:00:23.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:00:23.000Z',
        beacon: '0x8f68570883973a0fcffe9a2737e13078eb094ce6',
        calculationConnector: '',
        source: '',
        origin: '0xc48fe252aa631017df253578b1405ea399728a50',
        vaultFactoryId: 41,
        rewardTokens: ['0x9c65ab58d8d978db963e63f2bfb7121627e3a739'],
        rewardTokenType: '',
        stakingToken: '0x577d005912c49b1679b4c21e334fdb650e92c077',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'ETH/BTCB',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 1e-7,
        tvlStaking: '72607.12',
        tvlUsd: '72607.12',
        enabled: true,
        dexFactory: {
          id: 84801,
          chainId: 56,
          address: '',
          name: 'Mdex',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: true,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 682,
        createdAt: '2024-01-18T13:00:23.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:00:23.000Z',
        beacon: '0x846729a26bf0504b0eae607fb950c6c6680c6b2b',
        calculationConnector: '',
        source: '',
        origin: '0xc48fe252aa631017df253578b1405ea399728a50',
        vaultFactoryId: 41,
        rewardTokens: ['0x9c65ab58d8d978db963e63f2bfb7121627e3a739'],
        rewardTokenType: '',
        stakingToken: '0xaf9aa53146c5752bf6068a84b970e9fbb22a87bc',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'MDX/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1e-5,
        tvlStaking: '17404.80',
        tvlUsd: '17404.80',
        enabled: false,
        dexFactory: {
          id: 84801,
          chainId: 56,
          address: '',
          name: 'Mdex',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 684,
        createdAt: '2024-01-18T13:18:29.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:18:29.000Z',
        beacon: '0x0226cbd5be0ac118d5a67370578392528caa0f97',
        calculationConnector: '',
        source: '',
        origin: '0xe50cb76a71b0c52ab091860cd61b9ba2fa407414',
        vaultFactoryId: 41,
        rewardTokens: ['0xd23811058eb6e7967d9a00dc3886e75610c4abba'],
        rewardTokenType: '',
        stakingToken: '0x28f8ed3bb8795b11e9be8a6015add73ef7cd3a14',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBNB/BUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0427,
        tvlStaking: '61817.59',
        tvlUsd: '61817.59',
        enabled: true,
        dexFactory: {
          id: 84810,
          chainId: 56,
          address: '',
          name: 'Knightswap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 685,
        createdAt: '2024-01-18T13:18:29.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:18:29.000Z',
        beacon: '0x165a114b4e31de0bea7a778632554843e88dbf37',
        calculationConnector: '',
        source: '',
        origin: '0xe50cb76a71b0c52ab091860cd61b9ba2fa407414',
        vaultFactoryId: 41,
        rewardTokens: ['0xd23811058eb6e7967d9a00dc3886e75610c4abba'],
        rewardTokenType: '',
        stakingToken: '0xd71710c21fba293eb12e0ca079fe37f50ad17d42',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBNB/KNIGHT',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0667,
        tvlStaking: '142518.76',
        tvlUsd: '142518.76',
        enabled: true,
        dexFactory: {
          id: 84810,
          chainId: 56,
          address: '',
          name: 'Knightswap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 686,
        createdAt: '2024-01-18T13:18:29.000Z',
        chainId: 56,
        dateOfAdd: '2024-01-18T13:18:29.000Z',
        beacon: '0xdf5dedc3c9234f1c23816fdae0810d76f882a2a2',
        calculationConnector: '',
        source: '',
        origin: '0xe50cb76a71b0c52ab091860cd61b9ba2fa407414',
        vaultFactoryId: 41,
        rewardTokens: ['0xd23811058eb6e7967d9a00dc3886e75610c4abba'],
        rewardTokenType: '',
        stakingToken: '0xa12e1e2e2dea79694448ab9ef63bd4d82a26d90c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'KNIGHT/BUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.0001,
        tvlStaking: '34434.66',
        tvlUsd: '34434.66',
        enabled: true,
        dexFactory: {
          id: 84810,
          chainId: 56,
          address: '',
          name: 'Knightswap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1478,
        createdAt: '2024-05-24T19:41:46.000Z',
        chainId: 56,
        dateOfAdd: '2024-05-24T19:41:46.000Z',
        beacon: '0xb8511f37ecea4b7c6bc28d0cffdc07ca39777709',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'BTCB/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x28df0835942396b7a1b7ae1cd068728e6ddbbafd',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '3493285.69',
        tvlUsd: '3493285.69',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1479,
        createdAt: '2024-05-24T19:41:46.000Z',
        chainId: 56,
        dateOfAdd: '2024-05-24T19:41:46.000Z',
        beacon: '0x1e13bfc3cf89cdc5fa109e746f18da0347120d65',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ETH/BTCB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3fb2623567e21f8c50f0ae86f54ef4849b4eb47b',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '5021395.56',
        tvlUsd: '5021395.56',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: true,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1480,
        createdAt: '2024-05-24T19:41:46.000Z',
        chainId: 56,
        dateOfAdd: '2024-05-24T19:41:46.000Z',
        beacon: '0xe39814c71617cea1091a2328701482eb1c92748e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ETH/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0f338ec12d3f7c3d77a4b9fcc1f95f3fb6ad0ea6',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '3977789.76',
        tvlUsd: '3977789.76',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1481,
        createdAt: '2024-05-24T19:41:46.000Z',
        chainId: 56,
        dateOfAdd: '2024-05-24T19:41:46.000Z',
        beacon: '0x5cc48af3010b20b131e1be3300446f7d9d0c5c57',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ETH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb125aa15ad943d96e813e4a06d0c34716f897e26',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '57923.86',
        tvlUsd: '57923.86',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1482,
        createdAt: '2024-05-24T19:41:46.000Z',
        chainId: 56,
        dateOfAdd: '2024-05-24T19:41:46.000Z',
        beacon: '0xb9e756330dc4a1ca64e81662c8a579140899dda7',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WBNB/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x42d749f736051d8933b118324cded52d1f92bec1',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '77012.06',
        tvlUsd: '77012.06',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1483,
        createdAt: '2024-05-24T19:41:46.000Z',
        chainId: 56,
        dateOfAdd: '2024-05-24T19:41:46.000Z',
        beacon: '0x0628350b5b1289ffc78357f25d7af9e5dfe357db',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDT/BTCB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x813c0decbb1097fff46d0ed6a39fb5f6a83043f4',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '2744804.45',
        tvlUsd: '2744804.45',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1484,
        createdAt: '2024-05-24T19:41:46.000Z',
        chainId: 56,
        dateOfAdd: '2024-05-24T19:41:46.000Z',
        beacon: '0xe97bf9dbed291565bcbb56ac84f98b7102b1ded9',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDT/BTCB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x06396509195eb9e07c38a016694dc9ff535b128a',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '61289.21',
        tvlUsd: '61289.21',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2956,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x74b5d429d9401994b435514f880c4af123a777f4',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'XRP/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x0adaf134ae0c4583b3a38fc3168a83e33162651e',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '767840.87',
        tvlUsd: '767840.87',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2957,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x65acd6da6db6a2e27f8cae41fc495dc76c4e6f1f',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4141325bac36affe9db165e854982230a14e6d48',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '492289.94',
        tvlUsd: '492289.94',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2958,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x3233d8b845aff109d6e0d3c99081c0616c05a0a8',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ADA/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf7513c120b92fa4dd5cbfa78dffefcb4ced5743f',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '33878.55',
        tvlUsd: '33878.55',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2959,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0xb2cb1d311d69ba4e8ecbae9965918f2fe67cc43a',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDT/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x6fe9e9de56356f7edbfcbb29fab7cd69471a4869',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '286835.78',
        tvlUsd: '286835.78',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2960,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x538d615be3823bff9a3fe8ecb8de0b4f79a274d4',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDT/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x47a90a2d92a8367a91efa1906bfc8c1e05bf10c4',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '1512887.14',
        tvlUsd: '1512887.14',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2961,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x080a5df9e134e63d4ff967d506d40b7f0d7e5980',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'CAKE/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfe4fe5b4575c036ac6d5cccfe13660020270e27a',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '6969941.63',
        tvlUsd: '6969941.63',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2962,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x960e4c56ea7e789e58ea868f1d2d1e626b0cdc4c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDT/DOGE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x023b6298e2f9ae728b324757599f2a36e002a55a',
        poolV3Fee: 0.01,
        apr: 0.0772,
        tvlStaking: '15936.09',
        tvlUsd: '15936.09',
        enabled: false,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2963,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x1a624afab14e311116c0b04bfab5edad4963a383',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDT/SOL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x515e94dc736b9d8b7d28ecf1cece0aba3d75da97',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '123367.74',
        tvlUsd: '123367.74',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2964,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x378b0ba0c978404f67c66162fc3bebd0cd4e4258',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ETH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf9878a5dd55edc120fde01893ea713a4f032229c',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '166409.56',
        tvlUsd: '166409.56',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2965,
        createdAt: '2024-12-05T10:44:42.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:42.000Z',
        beacon: '0x323a51382c67af0ea55a59df6120bd271fe5dadd',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'FTM/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x96d5d78b179169ee0a0a0104dc514988f2a797fe',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '72102.10',
        tvlUsd: '72102.10',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2966,
        createdAt: '2024-12-05T10:44:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:54.000Z',
        beacon: '0x17859208c6a09aeb12dddadc089f10cc206e2f88',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'INJ/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x33e59edd3214e97cb68450c6d3d6c167de072aba',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '129045.44',
        tvlUsd: '129045.44',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2967,
        createdAt: '2024-12-05T10:44:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:54.000Z',
        beacon: '0x63088c9a017d1d42312672035e36082d462a5466',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WBNB/VELO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb1a1b707b143b911c36e1a0f4f901c5017791aca',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '185732.31',
        tvlUsd: '185732.31',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2968,
        createdAt: '2024-12-05T10:44:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:54.000Z',
        beacon: '0x19e805b6363c6a26e1ce3e56e02c0fb44b6d361f',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'ZRO/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9169bf3657353e4b2b81c75e235f22bc299a7780',
        poolV3Fee: 0.01,
        apr: 0.2981,
        tvlStaking: '10959.59',
        tvlUsd: '10959.59',
        enabled: false,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2969,
        createdAt: '2024-12-05T10:44:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:54.000Z',
        beacon: '0xb7b9860569eb9a59e4d74cf5a451995981daf664',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'NEAR/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4a978a2d4fb7393063babfb0cee741b8bcd4dd4b',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '102382.55',
        tvlUsd: '102382.55',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2970,
        createdAt: '2024-12-05T10:44:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:54.000Z',
        beacon: '0xb5f7850716c2a6dc62a85813ed63f392125f9bb3',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'PENDLE/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x916d7f23ccbb1d10118dcfc6ad5a10b6446ff73e',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '194754.06',
        tvlUsd: '194754.06',
        enabled: true,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2971,
        createdAt: '2024-12-05T10:44:54.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:44:54.000Z',
        beacon: '0x45139474601b816516b72fc3b29b6cb9ea9979fa',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x7b8a01b39d58278b5de7e48c8449c9f4f5170613',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'CAT/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x05c0a0b84b6b67499c33e6403686f45cab063810',
        poolV3Fee: 0.003,
        apr: 0.0265,
        tvlStaking: '7951.19',
        tvlUsd: '7951.19',
        enabled: false,
        dexFactory: {
          id: 95005,
          chainId: 56,
          address: '',
          name: 'Uniswap',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2972,
        createdAt: '2024-12-05T10:45:33.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:45:33.000Z',
        beacon: '0x8dd08d737cb175a9413b70e15304c288d3ecb8d1',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'AITECH/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x55458175c5f5d34b9bd01c81f172780ed4271b23',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2973,
        createdAt: '2024-12-05T10:45:33.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:45:33.000Z',
        beacon: '0xd04dad7657a9c78047f0ebf482bc61f02853e0fb',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'XRP/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xd15b00e81f98a7db25f1dc1ba6e983a4316c4cac',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '1012198.18',
        tvlUsd: '1012198.18',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2974,
        createdAt: '2024-12-05T10:45:33.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:45:33.000Z',
        beacon: '0xde8a75c98ef4a51f921ff83ab512a62aca6d697f',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'XRP/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x71f5a8f7d448e59b1ede00a19fe59e05d125e742',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '133643.41',
        tvlUsd: '133643.41',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2975,
        createdAt: '2024-12-05T10:45:33.000Z',
        chainId: 56,
        dateOfAdd: '2024-12-05T10:45:33.000Z',
        beacon: '0x575b5f7fd0214f6d726a9d93db4059e9fbc12ac0',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'XRP/ETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa322b156b138deaa6b5df1f76154ee019f33db25',
        poolV3Fee: 0.0025,
        apr: 0,
        tvlStaking: '579079.69',
        tvlUsd: '579079.69',
        enabled: true,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 4235,
        createdAt: '2025-01-31T16:01:25.000Z',
        chainId: 56,
        dateOfAdd: '2025-01-31T16:01:25.000Z',
        beacon: '0xc0b78cc91f26a85977f9949cbb515d5e26e7de23',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x4677f8c20c12f941fc480dffd1351061a6bb76a6',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'ETH/EMP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x31d48313bd3dc70458416be2fb12f96fdd77f497',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '97912.40',
        tvlUsd: '97912.40',
        enabled: true,
        dexFactory: {
          id: 95231,
          chainId: 56,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 4236,
        createdAt: '2025-02-06T09:11:12.000Z',
        chainId: 56,
        dateOfAdd: '2025-02-06T09:11:12.000Z',
        beacon: '0xdbd0a486c9b91588d31bce1de5bae677ec42b88f',
        calculationConnector: '',
        source: '',
        origin: '0x556b9306565093c855aea9ae92a594704c2cd59e',
        vaultFactoryId: 41,
        rewardTokens: ['0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'],
        rewardTokenType: '',
        stakingToken: '0x46a15b0b27311cedf172ab29e4f4766fbe7f4364',
        stakingTokenType: 'ERC721',
        stakeTokenSymbol: 'TRUMP/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x032ab93b734bef57d98552eb56839f0995d4fb28',
        poolV3Fee: 0.0025,
        apr: 0.4632,
        tvlStaking: '1308.09',
        tvlUsd: '1308.09',
        enabled: false,
        dexFactory: {
          id: 84747,
          chainId: 56,
          address: '',
          name: 'PCS v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4724,
        createdAt: '2025-02-25T22:55:39.000Z',
        chainId: 56,
        dateOfAdd: '2025-02-25T22:55:39.000Z',
        beacon: '0x87b11b98699110ee4ce72aeb4853a60588e661d9',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x4677f8c20c12f941fc480dffd1351061a6bb76a6',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'GG/ETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x045e0d7dd6f6b5ab37a4c557c3b5fa0db23be24a',
        poolV3Fee: 0.0005,
        apr: 0.0069,
        tvlStaking: '18818.53',
        tvlUsd: '18818.53',
        enabled: false,
        dexFactory: {
          id: 95231,
          chainId: 56,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 4725,
        createdAt: '2025-02-25T22:55:39.000Z',
        chainId: 56,
        dateOfAdd: '2025-02-25T22:55:39.000Z',
        beacon: '0x6f924e96115e365b0c501976b631448cebfac0e6',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 41,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x4677f8c20c12f941fc480dffd1351061a6bb76a6',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'ESHARE/WBNB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x99f220eff95dd089784a74d1ed8940cc485f3679',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '81115.04',
        tvlUsd: '81115.04',
        enabled: true,
        dexFactory: {
          id: 95231,
          chainId: 56,
          address: '',
          name: 'DexSwap',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
    ],
    profitClaimer: '0x9e485a803815e52279baf5c35bad58f5a5828f2c',
  },
  {
    id: 42,
    factory: '0xac297968c97ef5686c79640960d106f65c307a37',
    chainId: 369,
    name: 'pls',
    enabled: true,
    migrator: '0xe66f2ca259afe7f6f7b10472fc20fe2b2c6a1717',
    zapper: '0x951a491f6dac24232554a32640b6db9026571cd4',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.095',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0xb4370dde29e398bdc08d3569da9a36645f5dd1ff',
      '0xd9a987371e4b789e731c39f0f1b8e8cbdccbec85',
      '0x0a9851eff39d6f397db1c50cd0ac28508732149a',
      '0x2f18e32bc5cdf0d763d00acb93621903d885f0bf',
      '0xdd32d7e5d9a21feb7e5848c0767eaa9540f9507d',
      '0xaa916efea2235ffc37e705654e825d3a3d18db8c',
    ],
    underlyingZapperTokensWl: [
      '0x30fcb23a906493371b1721c8feb8815804808d74',
      '0xefd766ccb38eaf1dfd701853bfce31359239f305',
      '0xaa2c47a35c1298795b5271490971ec4874c8e53d',
      '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
      '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
    ],
    farms: [
      {
        id: 781,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0x2e9d11e369cbe6abcc9d35391479804134c880c6',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0x207288d32a108dfa89733b6e7354da0a8e768973',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SPARK/GOAT',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.105,
        tvlStaking: '172.04',
        tvlUsd: '172.04',
        enabled: false,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 782,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0x1a2f704ca2c6d3663cf6f8526c3ce53cf8a58cf8',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0xd3300f0bd587f0b9a77b62f74ea26fca1086618b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/EMP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '209.36',
        tvlUsd: '209.36',
        enabled: false,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 783,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0xe6e914307d061ab7757c7a2c668a24e7969c4eca',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0xf32b9398a7277609772f328fc2005d7da5420e77',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SDAI/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.1896,
        tvlStaking: '36970.78',
        tvlUsd: '36970.78',
        enabled: true,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 784,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0x324b791f1b7639192fa0313567997ef291c5b47b',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0x33208439e1b28b1d6fcfbb6334e9950027ee3b52',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SPARK/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.1643,
        tvlStaking: '51493.96',
        tvlUsd: '51493.96',
        enabled: true,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 785,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0x6b7fc734b381d14e2d427631e6138d806615b864',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0xf3a8a528c6300cf1e70762c3695b9c60b5a79e15',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SDAI/USDEX+',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.9277,
        tvlStaking: '19019.32',
        tvlUsd: '19019.32',
        enabled: true,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 786,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0xa503d353c5bb67608d653253fcfb6e62a4e98a1a',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0x9095d464a29abd1b840c1c5205fb602ae5b011ff',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'SDAI/SPARK',
        stakeTokenSwapFee: 0,
        riskLevel: 4,
        apr: 0.3216,
        tvlStaking: '10523.01',
        tvlUsd: '10523.01',
        enabled: true,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 787,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0x590b82d4d4dbf82549ab5c8cb3280270712ff3b0',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0x52729266e890de1f9f83c462f5c9fbdeae78dbf9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0676,
        tvlStaking: '5342.76',
        tvlUsd: '5342.76',
        enabled: false,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 788,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0x013c970ce45e5ea0f09c1494dca8db7c7be652a6',
        calculationConnector: '',
        source: '',
        origin: '0xb2ca4a66d3e57a5a9a12043b6bad28249fe302d4',
        vaultFactoryId: 42,
        rewardTokens: ['0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d'],
        rewardTokenType: '',
        stakingToken: '0x1b45b9148791d3a104184cd5dfe5ce57193a3ee9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'PLSX/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0042,
        tvlStaking: '8335484.71',
        tvlUsd: '8335484.71',
        enabled: true,
        dexFactory: {
          id: 84850,
          chainId: 369,
          address: '',
          name: 'Pulsex',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 789,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0x793af44d056f6a069589c12fa2c465e23a596e4b',
        calculationConnector: '',
        source: '',
        origin: '0xb2ca4a66d3e57a5a9a12043b6bad28249fe302d4',
        vaultFactoryId: 42,
        rewardTokens: ['0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d'],
        rewardTokenType: '',
        stakingToken: '0xe56043671df55de5cdf8459710433c10324de0ae',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WPLS/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.1121,
        tvlStaking: '5043373.40',
        tvlUsd: '5043373.40',
        enabled: true,
        dexFactory: {
          id: 84850,
          chainId: 369,
          address: '',
          name: 'Pulsex',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 790,
        createdAt: '2024-02-05T11:51:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:15.000Z',
        beacon: '0xdc1db2d253f712f93572cb64ef30c57718e8d661',
        calculationConnector: '',
        source: '',
        origin: '0xb2ca4a66d3e57a5a9a12043b6bad28249fe302d4',
        vaultFactoryId: 42,
        rewardTokens: ['0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d'],
        rewardTokenType: '',
        stakingToken: '0x6753560538eca67617a9ce605178f788be7e524e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0874,
        tvlStaking: '2425409.13',
        tvlUsd: '2425409.13',
        enabled: true,
        dexFactory: {
          id: 84850,
          chainId: 369,
          address: '',
          name: 'Pulsex',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 791,
        createdAt: '2024-02-05T11:51:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:45.000Z',
        beacon: '0x1ba09ae5509d3cd1b7a71be1822e02f00ed13a33',
        calculationConnector: '',
        source: '',
        origin: '0xb2ca4a66d3e57a5a9a12043b6bad28249fe302d4',
        vaultFactoryId: 42,
        rewardTokens: ['0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d'],
        rewardTokenType: '',
        stakingToken: '0x42abdfdb63f3282033c766e72cc4810738571609',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0411,
        tvlStaking: '5155321.45',
        tvlUsd: '5155321.45',
        enabled: true,
        dexFactory: {
          id: 84850,
          chainId: 369,
          address: '',
          name: 'Pulsex',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 792,
        createdAt: '2024-02-05T11:51:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:45.000Z',
        beacon: '0xc7ade2c2e8738738693a6b8d4760a5a4aa632d2b',
        calculationConnector: '',
        source: '',
        origin: '0xb2ca4a66d3e57a5a9a12043b6bad28249fe302d4',
        vaultFactoryId: 42,
        rewardTokens: ['0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d'],
        rewardTokenType: '',
        stakingToken: '0x322df7921f28f1146cdf62afdac0d6bc0ab80711',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDT/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.1108,
        tvlStaking: '1913332.25',
        tvlUsd: '1913332.25',
        enabled: true,
        dexFactory: {
          id: 84850,
          chainId: 369,
          address: '',
          name: 'Pulsex',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 793,
        createdAt: '2024-02-05T11:51:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:45.000Z',
        beacon: '0x7ecaeeff12861c4b82785e223bd237b4620fd049',
        calculationConnector: '',
        source: '',
        origin: '0xb2ca4a66d3e57a5a9a12043b6bad28249fe302d4',
        vaultFactoryId: 42,
        rewardTokens: ['0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d'],
        rewardTokenType: '',
        stakingToken: '0xf1f4ee610b2babb05c635f726ef8b0c568c8dc65',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HEX/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0121,
        tvlStaking: '2920344.39',
        tvlUsd: '2920344.39',
        enabled: true,
        dexFactory: {
          id: 84850,
          chainId: 369,
          address: '',
          name: 'Pulsex',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 794,
        createdAt: '2024-02-05T11:51:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:45.000Z',
        beacon: '0x5b06547392d9ceaac98b8746a469fcf5b9406b79',
        calculationConnector: '',
        source: '',
        origin: '0xb2ca4a66d3e57a5a9a12043b6bad28249fe302d4',
        vaultFactoryId: 42,
        rewardTokens: ['0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d'],
        rewardTokenType: '',
        stakingToken: '0xf808bb6265e9ca27002c0a04562bf50d4fe37eaa',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'INC/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0137,
        tvlStaking: '2584188.00',
        tvlUsd: '2584188.00',
        enabled: true,
        dexFactory: {
          id: 84850,
          chainId: 369,
          address: '',
          name: 'Pulsex',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 795,
        createdAt: '2024-02-05T11:51:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-05T11:51:45.000Z',
        beacon: '0x4a257742d743907f067228c87cdd6354088e3ac9',
        calculationConnector: '',
        source: '',
        origin: '0xb2ca4a66d3e57a5a9a12043b6bad28249fe302d4',
        vaultFactoryId: 42,
        rewardTokens: ['0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d'],
        rewardTokenType: '',
        stakingToken: '0x7dbeca4c74d01cd8782d4ef5c05c0769723fb0ea',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'INC/PLSX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0104,
        tvlStaking: '3406406.13',
        tvlUsd: '3406406.13',
        enabled: true,
        dexFactory: {
          id: 84850,
          chainId: 369,
          address: '',
          name: 'Pulsex',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 828,
        createdAt: '2024-02-07T17:07:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-07T17:07:45.000Z',
        beacon: '0x391ce6dfe88dc3c134d62b801a5078a94acecdb5',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0x1b45b9148791d3a104184cd5dfe5ce57193a3ee9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'PLSX/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0537,
        tvlStaking: '6728.55',
        tvlUsd: '6728.55',
        enabled: false,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 829,
        createdAt: '2024-02-07T17:07:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-07T17:07:45.000Z',
        beacon: '0x221f8a1656dbf6ff9c6b8034c0123eea154c1096',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0xe56043671df55de5cdf8459710433c10324de0ae',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WPLS/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0717,
        tvlStaking: '7555.64',
        tvlUsd: '7555.64',
        enabled: false,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 830,
        createdAt: '2024-02-07T17:07:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-07T17:07:45.000Z',
        beacon: '0x29147b81cb86aab019b4ea744ae1f3d1255e483c',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0xf1f4ee610b2babb05c635f726ef8b0c568c8dc65',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HEX/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 2,
        apr: 0.0393,
        tvlStaking: '4602.70',
        tvlUsd: '4602.70',
        enabled: false,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 831,
        createdAt: '2024-02-07T17:07:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-02-07T17:07:45.000Z',
        beacon: '0xce88e349108279d6b644841ef5f7558bdaeb1228',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0x6753560538eca67617a9ce605178f788be7e524e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 1,
        apr: 0.0428,
        tvlStaking: '4216.96',
        tvlUsd: '4216.96',
        enabled: false,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1475,
        createdAt: '2024-05-22T11:06:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-05-22T11:06:05.000Z',
        beacon: '0x669489b07ddbd597c0cefbf3e13a7f6fa9b6108c',
        calculationConnector: '',
        source: '',
        origin: '0x63c2a0083861f8c496a0a29bd8ba223e1180664e',
        vaultFactoryId: 42,
        rewardTokens: ['0x6386704cd6f7a584ea9d23ccca66af7eba5a727e'],
        rewardTokenType: '',
        stakingToken: '0x8b951eb284ec0d80e94bf19874740b59e7392275',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WPLS/BSPARK',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3615,
        tvlStaking: '16986.92',
        tvlUsd: '16986.92',
        enabled: false,
        dexFactory: {
          id: 84843,
          chainId: 369,
          address: '',
          name: 'SparkSwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2197,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0x4ed79cec763e322cb54b27bb7ec5cd9673f6ce2d',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x1164dab36cd7036668ddcbb430f7e0b15416ef0b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: '9INCH/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.09,
        tvlStaking: '132165.81',
        tvlUsd: '132165.81',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2198,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0x875887740091413d3915921eb24016fb18246251',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x31acf819060ae711f63bd6b682640598e250c689',
        stakingTokenType: 'LP',
        stakeTokenSymbol: '9INCH/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1392,
        tvlStaking: '42738.25',
        tvlUsd: '42738.25',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2199,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0x5c2d8df96a51ab937447877c2c88f026e131deb7',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x6c5a0f22b459973a0305e2a565fc208a35a13850',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC/9INCH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1796,
        tvlStaking: '28970.62',
        tvlUsd: '28970.62',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2200,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0xfb1acc82d90afc260e1d64f38a75e7484b6dd96b',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x5449a776797b55a4aac0b4a76b2ac878bff3d3e3',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDT/9INCH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1584,
        tvlStaking: '28154.56',
        tvlUsd: '28154.56',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2201,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0xd815a62a2844e688c6a4ee7898391780ebafb465',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xb543812ddebc017976f867da710ddb30cca22929',
        stakingTokenType: 'LP',
        stakeTokenSymbol: '9INCH/BBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1158,
        tvlStaking: '192515.72',
        tvlUsd: '192515.72',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2202,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0x3a2bf8f6214deaa5c3555a75fa81013496e547f0',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x097d19b2061c5f31b68852349187c664920b4ba4',
        stakingTokenType: 'LP',
        stakeTokenSymbol: '9INCH/9INCH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2203,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0x815205b8620408c32bbb4331530ebd28f9d56eff',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xb89ea01677529a8bbcece3a486404880f9463c45',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'PLSX/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '56572.86',
        tvlUsd: '56572.86',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2204,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0x5c015474fd89fe4c8c680d35fba771ce976f26d7',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x898bb93f4629c73f0c519415a85d6bd2977cb0b5',
        stakingTokenType: 'LP',
        stakeTokenSymbol: '9INCH/PLSX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1153,
        tvlStaking: '64474.31',
        tvlUsd: '64474.31',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2205,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0x98eb564a4a7ccab67079455b2d8b5a2a8dfc4c1f',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xf34157a1aecfeef326c1c33d90802354abc5a702',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HEX/HEX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '0',
        tvlUsd: '0',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 2206,
        createdAt: '2024-11-04T14:41:45.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:41:45.000Z',
        beacon: '0x73f6c689723ab64f4e471cee7ab30c107e2dd242',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x8948940e76efc27b5e3253ea30acc8e325a9cca2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'HEX/9INCH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3792,
        tvlStaking: '7898.24',
        tvlUsd: '7898.24',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2207,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0xd9c9821b1a889839883a4508a52b9547288c8ced',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xb823f30963511fb0a083073763f55d1285900c0c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'NOPE/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '16562.11',
        tvlUsd: '16562.11',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2208,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0x00ab234b6dd57d9f7e1c58d6d046d7501d40c986',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x633055aa25f33bbae94091bbb753dd3b1849de0e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: '9INCH/NOPE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '26839.75',
        tvlUsd: '26839.75',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2209,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0xc545e6261f9a0e4eae7dbfe63a3e38475e64e4f3',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x13f31a66a0f844d0bcfe1832a3c7096dd4bde79e',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'INC/BBC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2632,
        tvlStaking: '17062.82',
        tvlUsd: '17062.82',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2210,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0xaa60e26605d4a400bf3c1fb4b3e8c049affdc13c',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x8e680888c29ae549f1cc293930d4fead8abb5bad',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'BBC/SOLIDX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.122,
        tvlStaking: '12269.06',
        tvlUsd: '12269.06',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2211,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0xb64ac934725bf386f463b47b2de4f989559c32b6',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xd98c555186bb218b0fe0967c417cce4ef6ba6859',
        stakingTokenType: 'LP',
        stakeTokenSymbol: '9INCH/SOLIDX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0793,
        tvlStaking: '18883.68',
        tvlUsd: '18883.68',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2212,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0xbcd8f6b257cd67267a6e7b70ede57b89a451d702',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x994e575563f8204d2ccc022e91dd91138b0506c2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WPLS/TEDDY BEAR',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2304,
        tvlStaking: '6504.57',
        tvlUsd: '6504.57',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2213,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0xb7eeddb11e5bb61dcf10a56f1307491a42bcca36',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xd7e98780c10c9c716a87a7f76e76cb1d49556da1',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WPLS/ATROPA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1922,
        tvlStaking: '7802.42',
        tvlUsd: '7802.42',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2214,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0x3cb9fbe00cc4716014d8a1cb1a8e53408871be93',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xd7b70d726cb370ac96eb6912db1f57a8df73267f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBTC/DAI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '8856.64',
        tvlUsd: '8856.64',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2215,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0x1a666e8fca7bdd4e07d75822c8dbce9294241773',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0x8356edc1d60b0ede626bc52980e708a604b0e861',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'DAI/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0,
        tvlStaking: '15757.42',
        tvlUsd: '15757.42',
        enabled: true,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2216,
        createdAt: '2024-11-04T14:42:05.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:05.000Z',
        beacon: '0xe62c530def87f68491214d5cc8c3f87b33573eda',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xbd1d593a038da65f247c8b3d5c445de9a031db53',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WBTC/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1124,
        tvlStaking: '13338.90',
        tvlUsd: '13338.90',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 2217,
        createdAt: '2024-11-04T14:42:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:15.000Z',
        beacon: '0xbb831d1a44f6c2ac3cbcca5938849bf051bae1bb',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xdaa4b508e1a958038f0f0b1f2eac796a2fc17bb8',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'AXIS/WPLS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1978,
        tvlStaking: '7568.25',
        tvlUsd: '7568.25',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 2218,
        createdAt: '2024-11-04T14:42:15.000Z',
        chainId: 369,
        dateOfAdd: '2024-11-04T14:42:15.000Z',
        beacon: '0xc3278cae1668cefdae885a2e111137b9462ae88c',
        calculationConnector: '',
        source: '',
        origin: '0x444775ae2c82560337c86f6d62909a63381de4fd',
        vaultFactoryId: 42,
        rewardTokens: ['0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e'],
        rewardTokenType: '',
        stakingToken: '0xa11e5d05295767fa83e8e7db3b6adea6bb67573a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'BBC/AXIS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1819,
        tvlStaking: '8231.19',
        tvlUsd: '8231.19',
        enabled: false,
        dexFactory: {
          id: 95102,
          chainId: 369,
          address: '',
          name: '9inch',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
    ],
    profitClaimer: '0x2dc995c4cfbd9cc795bb5386eb5098c5f810d424',
  },
  {
    id: 43,
    factory: '0x714c94b9820d7d73e61510e4c18b91f995a895c1',
    chainId: 169,
    name: 'manta',
    enabled: true,
    migrator: '0x8d4609125b4782d564a3b8ae6c759e90aa04910f',
    zapper: '0x1bec5d62748f68f5a254906066aed2a46fdc465a',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.095',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0x039ce3ef6b1c17b893453337073b894144014b08',
      '0x6a111389ebe74ba66e96d318fd8a4f0241bf1bc5',
      '0x5def90e6d216776765bcf62a4eb60859a4acb457',
      '0xfc6b9a72312c5efb09d1b77a8e61b0dafaa881dc',
      '0x103f62be53bdfb3521e6a8661f19319ad2cebdc7',
    ],
    underlyingZapperTokensWl: [
      '0x6da9ebd271a0676f39c088a2b5fd849d5080c0af',
      '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
    ],
    farms: [
      {
        id: 1369,
        createdAt: '2024-04-17T17:47:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-04-17T17:47:09.000Z',
        beacon: '0x84b4280be0f39ebfd647adc0b07f806d4d0187d1',
        calculationConnector: '',
        source: '',
        origin: '0x78343abfc1381d4358161c2f73fc0990ccd5cbe0',
        vaultFactoryId: 43,
        rewardTokens: ['0x3af03e8c993900f0ea6b84217071e1d4cc783982'],
        rewardTokenType: '',
        stakingToken: '0x3838753b9b9b7cf26ddc71d0f1a0ee0b9144aba5',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDEX+/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1594,
        tvlStaking: '11105.39',
        tvlUsd: '11105.39',
        enabled: false,
        dexFactory: {
          id: 94961,
          chainId: 169,
          address: '',
          name: 'CetoSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1370,
        createdAt: '2024-04-17T17:47:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-04-17T17:47:09.000Z',
        beacon: '0x57322aa5ae2e8e0152de619a2ce6730e52a14b71',
        calculationConnector: '',
        source: '',
        origin: '0x78343abfc1381d4358161c2f73fc0990ccd5cbe0',
        vaultFactoryId: 43,
        rewardTokens: ['0x3af03e8c993900f0ea6b84217071e1d4cc783982'],
        rewardTokenType: '',
        stakingToken: '0xef799451a28a1432712d19df82e512d985d685d4',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'CETO/USDEX+',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.3181,
        tvlStaking: '1341.96',
        tvlUsd: '1341.96',
        enabled: false,
        dexFactory: {
          id: 94961,
          chainId: 169,
          address: '',
          name: 'CetoSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1371,
        createdAt: '2024-04-17T17:47:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-04-17T17:47:09.000Z',
        beacon: '0x5c5f821e1cb3f688bd9813142900f5fcd3876bb8',
        calculationConnector: '',
        source: '',
        origin: '0x78343abfc1381d4358161c2f73fc0990ccd5cbe0',
        vaultFactoryId: 43,
        rewardTokens: ['0x3af03e8c993900f0ea6b84217071e1d4cc783982'],
        rewardTokenType: '',
        stakingToken: '0xb9454b5fc78c826cf028f4e513b0e0a4d2bf51a9',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/MANTA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1983,
        tvlStaking: '407.46',
        tvlUsd: '407.46',
        enabled: false,
        dexFactory: {
          id: 94961,
          chainId: 169,
          address: '',
          name: 'CetoSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 1372,
        createdAt: '2024-04-17T17:47:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-04-17T17:47:09.000Z',
        beacon: '0x2385b629219cb86088e2a54139f0424549006497',
        calculationConnector: '',
        source: '',
        origin: '0x78343abfc1381d4358161c2f73fc0990ccd5cbe0',
        vaultFactoryId: 43,
        rewardTokens: ['0x3af03e8c993900f0ea6b84217071e1d4cc783982'],
        rewardTokenType: '',
        stakingToken: '0x75791775dc127d4441ecc532be128214ca4c6f72',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'STGAI/MANTA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0134,
        tvlStaking: '753.29',
        tvlUsd: '753.29',
        enabled: false,
        dexFactory: {
          id: 94961,
          chainId: 169,
          address: '',
          name: 'CetoSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1373,
        createdAt: '2024-04-17T17:47:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-04-17T17:47:09.000Z',
        beacon: '0xf39ecfc0c7330479a4bc2a1846a7f09675002ef6',
        calculationConnector: '',
        source: '',
        origin: '0x78343abfc1381d4358161c2f73fc0990ccd5cbe0',
        vaultFactoryId: 43,
        rewardTokens: ['0x3af03e8c993900f0ea6b84217071e1d4cc783982'],
        rewardTokenType: '',
        stakingToken: '0x6c72baee6d7074e54add3f617ec5d6b22afe779b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/CETO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2951,
        tvlStaking: '2055.27',
        tvlUsd: '2055.27',
        enabled: false,
        dexFactory: {
          id: 94961,
          chainId: 169,
          address: '',
          name: 'CetoSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1374,
        createdAt: '2024-04-17T17:47:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-04-17T17:47:09.000Z',
        beacon: '0x2d90202279b15a7e8b9d1624efd0dbda195aae50',
        calculationConnector: '',
        source: '',
        origin: '0x78343abfc1381d4358161c2f73fc0990ccd5cbe0',
        vaultFactoryId: 43,
        rewardTokens: ['0x3af03e8c993900f0ea6b84217071e1d4cc783982'],
        rewardTokenType: '',
        stakingToken: '0xd6359083da64e79ad7c54106ee71a889268f0462',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0487,
        tvlStaking: '4149.72',
        tvlUsd: '4149.72',
        enabled: false,
        dexFactory: {
          id: 94961,
          chainId: 169,
          address: '',
          name: 'CetoSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1375,
        createdAt: '2024-04-17T17:47:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-04-17T17:47:09.000Z',
        beacon: '0x11d3c371ce50a93fcff4c0b7fe7e3dc8703c907e',
        calculationConnector: '',
        source: '',
        origin: '0x78343abfc1381d4358161c2f73fc0990ccd5cbe0',
        vaultFactoryId: 43,
        rewardTokens: ['0x3af03e8c993900f0ea6b84217071e1d4cc783982'],
        rewardTokenType: '',
        stakingToken: '0x3afed5925034bb3b730ffdae6d98b6df45c0ff74',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/BCETO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.3648,
        tvlStaking: '1939.19',
        tvlUsd: '1939.19',
        enabled: false,
        dexFactory: {
          id: 94961,
          chainId: 169,
          address: '',
          name: 'CetoSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 1376,
        createdAt: '2024-04-17T17:47:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-04-17T17:47:09.000Z',
        beacon: '0x6304ff0ce5e63d1530f66059f05326e949e354d1',
        calculationConnector: '',
        source: '',
        origin: '0x78343abfc1381d4358161c2f73fc0990ccd5cbe0',
        vaultFactoryId: 43,
        rewardTokens: ['0x3af03e8c993900f0ea6b84217071e1d4cc783982'],
        rewardTokenType: '',
        stakingToken: '0x05db409bc3c2629e2987dc7aa87c39376bc49477',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WETH/STONE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1572,
        tvlStaking: '1125.28',
        tvlUsd: '1125.28',
        enabled: false,
        dexFactory: {
          id: 94961,
          chainId: 169,
          address: '',
          name: 'CetoSwap',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1412,
        createdAt: '2024-05-06T13:13:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:13:09.000Z',
        beacon: '0xdd11b32e1829b7515cd4a21398f7ed2524ee369d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xe77e3f98a386a4c8f8c706a2acffdf57e70d06c6',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/STONE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x02b25ffb7269fc167f8959de9a1bcd4213c06aaf',
        poolV3Fee: 0.0005,
        apr: 0.009,
        tvlStaking: '9772.68',
        tvlUsd: '9772.68',
        enabled: false,
        dexFactory: {
          id: 94969,
          chainId: 169,
          address: '',
          name: 'Aperture',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1413,
        createdAt: '2024-05-06T13:13:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:13:09.000Z',
        beacon: '0x9da1449cbdb4f7f5bac778c7e739c3c65a68ec2d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xe77e3f98a386a4c8f8c706a2acffdf57e70d06c6',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xd7f09148eb22686cb5dcbdd0cf27d04123d14c74',
        poolV3Fee: 0.0005,
        apr: 0.008,
        tvlStaking: '11385.07',
        tvlUsd: '11385.07',
        enabled: false,
        dexFactory: {
          id: 94969,
          chainId: 169,
          address: '',
          name: 'Aperture',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1414,
        createdAt: '2024-05-06T13:13:09.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:13:09.000Z',
        beacon: '0xc61fb0539f119e078eef6de1139665f65c2a18cd',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xe77e3f98a386a4c8f8c706a2acffdf57e70d06c6',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/MANTA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x66e354c61f877574a97c501335e1fe93da114f24',
        poolV3Fee: 0.003,
        apr: 0.025,
        tvlStaking: '3511.87',
        tvlUsd: '3511.87',
        enabled: false,
        dexFactory: {
          id: 94969,
          chainId: 169,
          address: '',
          name: 'Aperture',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1426,
        createdAt: '2024-05-06T13:18:19.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:18:19.000Z',
        beacon: '0x2e3ba161c90c9109d01665fd5aa87ccf23b97496',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/STONE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8294b6e9a5ce9d322b710c45d83e3a3cb1592199',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '101403.21',
        tvlUsd: '101403.21',
        enabled: true,
        dexFactory: {
          id: 94972,
          chainId: 169,
          address: '',
          name: 'QuickSwap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1427,
        createdAt: '2024-05-06T13:18:19.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:18:19.000Z',
        beacon: '0x13167a92235f0f7d9a65b4993eeeedec73ba8f5b',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'USDC/USDT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x462609c41ca27bd4240778c53c0908542b59b972',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '1551654.25',
        tvlUsd: '1551654.25',
        enabled: true,
        dexFactory: {
          id: 94972,
          chainId: 169,
          address: '',
          name: 'QuickSwap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1428,
        createdAt: '2024-05-06T13:18:19.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:18:19.000Z',
        beacon: '0xa047216adc0e43f015dd7de3dddce916027fd642',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/MANTA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8f0111df7d48c9117d44b9cedfc23f160e3311f3',
        poolV3Fee: 0.0005,
        apr: 0.0994,
        tvlStaking: '15275.92',
        tvlUsd: '15275.92',
        enabled: false,
        dexFactory: {
          id: 94972,
          chainId: 169,
          address: '',
          name: 'QuickSwap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1429,
        createdAt: '2024-05-06T13:18:19.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:18:19.000Z',
        beacon: '0x43c20d72a44f36d6304a0e83f1a1faa1e2476d2d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/WBTC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfc9ffc1c6e0ebf7be3ce93245b309f4d3b593101',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '87972.17',
        tvlUsd: '87972.17',
        enabled: true,
        dexFactory: {
          id: 94972,
          chainId: 169,
          address: '',
          name: 'QuickSwap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: true,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1430,
        createdAt: '2024-05-06T13:18:19.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:18:19.000Z',
        beacon: '0xf9d863f578b1369e2ce509140c201a79e07b9f59',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/USDC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x12cdded759b14bf6a34fbf6638aec9b735824a9e',
        poolV3Fee: 0.0001,
        apr: 0,
        tvlStaking: '1638733.58',
        tvlUsd: '1638733.58',
        enabled: true,
        dexFactory: {
          id: 94972,
          chainId: 169,
          address: '',
          name: 'QuickSwap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 1431,
        createdAt: '2024-05-06T13:18:19.000Z',
        chainId: 169,
        dateOfAdd: '2024-05-06T13:18:19.000Z',
        beacon: '0x6444b7b1a55589f88dfe604593069ffe46613044',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 43,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WETH/MANTA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x97433019b560c1c20055ba5edc8eef226f2d1be7',
        poolV3Fee: 0.003,
        apr: 0.0528,
        tvlStaking: '14591.19',
        tvlUsd: '14591.19',
        enabled: false,
        dexFactory: {
          id: 94972,
          chainId: 169,
          address: '',
          name: 'QuickSwap',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
    ],
    profitClaimer: '0x4ad57565458b4b426bec054d05045651172c4813',
  },
  {
    id: 76,
    factory: '0xa601e9e8cc78e1b13c7331a05bc16bba648feea5',
    chainId: 146,
    name: 'sonic',
    enabled: true,
    migrator: '0xb8f0114570ac609cb7c3ad2b1da9062e0b26abd2',
    zapper: '0x2dc995c4cfbd9cc795bb5386eb5098c5f810d424',
    minProfitPercent: '0',
    maxProfitPercent: '1',
    maxDepositorsCount: '1000',
    depositFee: '0',
    harvestFee: '0.055',
    withdrawFee: '0',
    migrateFee: '0',
    profitTokensWl: [
      '0x8d733825eea479e535e157a4afeb9bb725dfe5ef',
      '0xa86a21c4ea8bc83f7df6f9ddbee6443db9b051e1',
      '0x1d8b61137e9ff0fb85a2e7b6f874a0581921381c',
      '0xe0749379ba2e02fc8f6c118b426c44e2a9c82390',
      '0xc3687f3d8fb3abd9aa33b34218412dded510db46',
      '0x4f169bcb85e62930af0f3e98e8ff417da420b772',
    ],
    underlyingZapperTokensWl: ['0x29219dd400f2bf60e5a23d13be72b486d4038894'],
    farms: [
      {
        id: 3169,
        createdAt: '2024-12-19T15:49:44.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-19T15:49:44.000Z',
        beacon: '0x7e4f453ca2996b4fa82d1346f5752062490ff20f',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xbab4a13713c4dfba3073d0b35e2829f8be800310',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/SPUB',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3d31f9d80211a8cae138aeedceb36d571b16803f',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '567.52',
        tvlUsd: '567.52',
        enabled: true,
        dexFactory: {
          id: 95132,
          chainId: 146,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3170,
        createdAt: '2024-12-19T15:49:44.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-19T15:49:44.000Z',
        beacon: '0x55d7d73215943b17b77d3119e721f675305e6666',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xbab4a13713c4dfba3073d0b35e2829f8be800310',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/SSGRIM',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xeb5998f9dd9b966ca512adf8ebaa09cb5af96cb7',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '16953.41',
        tvlUsd: '16953.41',
        enabled: false,
        dexFactory: {
          id: 95132,
          chainId: 146,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3171,
        createdAt: '2024-12-19T15:49:44.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-19T15:49:44.000Z',
        beacon: '0xbeea8502f7e56dc4ca4465592c0072e6e62dab29',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xbab4a13713c4dfba3073d0b35e2829f8be800310',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: '$STONER/JOINT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcb63f3d4deb888aa3f5bf6f3eea095ce59e10a70',
        poolV3Fee: 0.01,
        apr: 0.0058,
        tvlStaking: '140.83',
        tvlUsd: '140.83',
        enabled: false,
        dexFactory: {
          id: 95132,
          chainId: 146,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3172,
        createdAt: '2024-12-19T15:50:14.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-19T15:50:14.000Z',
        beacon: '0x69fe2c8c15ff865cb836a90b7d56241c6fc557b8',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xbab4a13713c4dfba3073d0b35e2829f8be800310',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/SBEER',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc363bb3fc74917a31c5244d28edd332b7b2f9bdc',
        poolV3Fee: 0.01,
        apr: 0.0001,
        tvlStaking: '13494.90',
        tvlUsd: '13494.90',
        enabled: false,
        dexFactory: {
          id: 95132,
          chainId: 146,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3173,
        createdAt: '2024-12-19T15:50:14.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-19T15:50:14.000Z',
        beacon: '0x07e62f7d04fdfe0f9d45e1d427e1105a8c08541c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xbab4a13713c4dfba3073d0b35e2829f8be800310',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/JOINT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x00b62a8edd7b440b5ce29613e872fc8dfe15f2db',
        poolV3Fee: 0.01,
        apr: 0.0165,
        tvlStaking: '64.18',
        tvlUsd: '64.18',
        enabled: false,
        dexFactory: {
          id: 95132,
          chainId: 146,
          address: '',
          name: 'SpookySwap',
          swapFee: '',
          code: '1',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 3210,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0x73af9d15cba27797cfc37aece53160a9ffc08a63',
        calculationConnector: '',
        source: '',
        origin: '0xe73267246aa678a28d8e7b957135faec1db48aef',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x139f8ecc5fc8ef11226a83911febecc08476cfb1',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/EQUAL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2647,
        tvlStaking: '140799.79',
        tvlUsd: '140799.79',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3211,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0x172f897b0cf7fca7d5e7699f85f3046de6229caa',
        calculationConnector: '',
        source: '',
        origin: '0xad2131601f22d15cbbc6267acc16e4035ffc8bf6',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x822b6e8d0a3eaf306a6a604f6af370f6d893292d',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/FSONIC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0011,
        tvlStaking: '80584.54',
        tvlUsd: '80584.54',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3212,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0x3e16e37bf12226141b2f4ec6e29517e764d19149',
        calculationConnector: '',
        source: '',
        origin: '0x7326c976285f536e08a13525eae29fb0e1fe47eb',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x9e1a6c05a9d7325f4dd46963f5a5179aa3d59e9b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/FROQ',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0015,
        tvlStaking: '17912.63',
        tvlUsd: '17912.63',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3213,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0xdd092f3d03ff0b3f36a31fc644975a76765da8b7',
        calculationConnector: '',
        source: '',
        origin: '0x6962e20bea34beedeca8946afe1dae306ad20e96',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x6201175832e1313892f86c43806813515ad5abd2',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/HAWG',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0228,
        tvlStaking: '3538.83',
        tvlUsd: '3538.83',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3214,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0x874ff3dceb7c06d2b96123b22a1608e902f596bb',
        calculationConnector: '',
        source: '',
        origin: '0x9e06a65e545b4bd762158f6bc34656dee9693a4d',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x832e2bb9579f6ff038d3e704fa1bb5b6b18a6521',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/GOGLZ',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0988,
        tvlStaking: '10382.87',
        tvlUsd: '10382.87',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3215,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0xdbca5bdf283d9f31d8460e9177b13cd4df95199f',
        calculationConnector: '',
        source: '',
        origin: '0x15c2b42f6001758eddd9cd13f327cdc812e5795d',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x913b1c9924f563692b3a306c90c9fde9f825ca27',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/INDI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0421,
        tvlStaking: '5095.87',
        tvlUsd: '5095.87',
        enabled: false,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3216,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0x0ec42b0fc1880a92e7348e13e2887b3e75a6bef5',
        calculationConnector: '',
        source: '',
        origin: '0x0feea9a0e85aeb0801e85293bd8de7604d784680',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x6d9b4d31c66291c13f33ae1b2d8c1a5be8a77c4f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/MOON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0674,
        tvlStaking: '49420.87',
        tvlUsd: '49420.87',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3217,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0xa8b41a6e4503f5acdfe26cafdbff133cf7dfe7e1',
        calculationConnector: '',
        source: '',
        origin: '0x470a91462935a02eeb8b013d7185be880974bffc',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x8d2b12d0dc9bb13c62d213efbea10fd0bfce3c88',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/WHALE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0328,
        tvlStaking: '20244.41',
        tvlUsd: '20244.41',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3218,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0xa286afd7f9b87f799e11e7cd46eee56ab0119453',
        calculationConnector: '',
        source: '',
        origin: '0x452ff5d3f4c1a92d074510696ce09b04aa2b9c4a',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0xc2c3beb4bceb9b37d2b4b5eea3b7810858b3b68c',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/FBUX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1163,
        tvlStaking: '1782.84',
        tvlUsd: '1782.84',
        enabled: false,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3219,
        createdAt: '2024-12-26T10:19:13.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:13.000Z',
        beacon: '0x252620c17db8f470d11bbaa25195e76d4da0e080',
        calculationConnector: '',
        source: '',
        origin: '0x6ece627a8143f8c32d100f0d8aa54385272d2103',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x04f1b3ce71cde381097a0601213def55cf336589',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/HEDGY',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.218,
        tvlStaking: '6140.86',
        tvlUsd: '6140.86',
        enabled: false,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3220,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0xc174b47008e6d7924f4d1ca78289a12156fef154',
        calculationConnector: '',
        source: '',
        origin: '0x368ab33554defc758533c2a3817187339a9999d9',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x7693de58839ff25e265d9b494394cb9c1d1efaf1',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/ELITEUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.048,
        tvlStaking: '2099.82',
        tvlUsd: '2099.82',
        enabled: false,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3221,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0x46d5959a8139eb2f7fd0b2b1fcdced537537575d',
        calculationConnector: '',
        source: '',
        origin: '0x0da2e6e170990dcdd046880fadc17adf759b869e',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0xb75c9073ea00abda9ff420b5ae46fee248993380',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/STS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0007,
        tvlStaking: '21643.84',
        tvlUsd: '21643.84',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3222,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0x1af241d693f541fd00e457dc9aab6c988a98d957',
        calculationConnector: '',
        source: '',
        origin: '0x4c09ecec77bd56ea28ce85da6a2a4e39de997e35',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x3e6daa42268a5097de68ab39e48b860b9b55f589',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/THC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0235,
        tvlStaking: '57972.08',
        tvlUsd: '57972.08',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3223,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0x086830b5da21203141e25f29a8c76668518108d2',
        calculationConnector: '',
        source: '',
        origin: '0x3b321fbe1353fa74d954074e4f695bd9ad7682bf',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0xf1c16a99a0f30d505d8f5fe226a6f09b19bd7991',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/MEEP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1e-5,
        tvlStaking: '4.64',
        tvlUsd: '4.64',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3224,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0x14b7723079eecf2fa16c9dcaad636411ba1ca801',
        calculationConnector: '',
        source: '',
        origin: '0xa5de3c814418187c80884955632150b080435b48',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x23abb32a9a242a552b9b3e70c0648b7b6499c164',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/JOINT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0692,
        tvlStaking: '3852.94',
        tvlUsd: '3852.94',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3225,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0x04e16ec3f8063e277009114224b03da150bbc8b1',
        calculationConnector: '',
        source: '',
        origin: '0xeed7a0514459a623798ceba61660b7d100b349bf',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0xa6c957e9cee712b098160dcbadcfb32a2cb75437',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/⚡',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1e-7,
        tvlStaking: '7343.22',
        tvlUsd: '7343.22',
        enabled: false,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3226,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0x4ef6bb7ccd866aa45035bc8320febadd2f6e5a92',
        calculationConnector: '',
        source: '',
        origin: '0x54a40b0e14f865106d23f53483e672d144993bea',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x992e53cb4ba7c39deed1cfa3b6fa77863d6e82b0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/WOOF',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.2234,
        tvlStaking: '7932.73',
        tvlUsd: '7932.73',
        enabled: false,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3227,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0x12d7af4f60ea277f3bc62a8bdb4e962a51a5261f',
        calculationConnector: '',
        source: '',
        origin: '0x4a2d04248e30845e7bde1b41c33cfcf4b1619218',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0xc95b82d389c6a0ea9e12c7e05e5a6be939bb2afb',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/RUGGIE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.4049,
        tvlStaking: '601.30',
        tvlUsd: '601.30',
        enabled: false,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3228,
        createdAt: '2024-12-26T10:19:18.000Z',
        chainId: 146,
        dateOfAdd: '2024-12-26T10:19:18.000Z',
        beacon: '0xbcdf5bf2437db61ede48d07e8497c55277ae7991',
        calculationConnector: '',
        source: '',
        origin: '0xa4df0a210a5e242be68e8a2b780ecc854add3583',
        vaultFactoryId: 76,
        rewardTokens: ['0xddf26b42c1d903de8962d3f79a74a501420d5f19'],
        rewardTokenType: '',
        stakingToken: '0x38cfa6cb37d074b6e954c52d10a4cf0e4268607b',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/BRUSH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0244,
        tvlStaking: '79877.64',
        tvlUsd: '79877.64',
        enabled: true,
        dexFactory: {
          id: 95165,
          chainId: 146,
          address: '',
          name: 'Equalizer',
          swapFee: '',
          code: '0',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3277,
        createdAt: '2025-01-02T11:36:13.000Z',
        chainId: 146,
        dateOfAdd: '2025-01-02T11:36:13.000Z',
        beacon: '0xc68c178b17ddf18c75263454896395a78de9869c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/ANON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x267fb0fc7694af30ffbcd3c27ce7497a7db73616',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '362802.97',
        tvlUsd: '362802.97',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3278,
        createdAt: '2025-01-02T11:36:13.000Z',
        chainId: 146,
        dateOfAdd: '2025-01-02T11:36:13.000Z',
        beacon: '0x1add863a017c30a3ae2cac9a4f3d107a31a4d651',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/WAGMI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb4a22d3554024437d4d4ae196598f9e093b03396',
        poolV3Fee: 0.01,
        apr: 0,
        tvlStaking: '142315.46',
        tvlUsd: '142315.46',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3279,
        createdAt: '2025-01-02T11:36:13.000Z',
        chainId: 146,
        dateOfAdd: '2025-01-02T11:36:13.000Z',
        beacon: '0x3df16be82f80222b65e6e4faaa4832052bf538ff',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/WAGMI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcb1698a454b957f20b61ba7e8edd9e169baa28ae',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '229143.37',
        tvlUsd: '229143.37',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3280,
        createdAt: '2025-01-02T11:36:13.000Z',
        chainId: 146,
        dateOfAdd: '2025-01-02T11:36:13.000Z',
        beacon: '0xb6d1d6f9195646e67d93e3d6f58af72e96ee32eb',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/ANON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x297000941c155962b04760ecaeaa422757f20bc1',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '321602.31',
        tvlUsd: '321602.31',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3281,
        createdAt: '2025-01-02T11:36:13.000Z',
        chainId: 146,
        dateOfAdd: '2025-01-02T11:36:13.000Z',
        beacon: '0xa167c82c4d6914e4f1017e96c0aba20d51d48854',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/USDC.E',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe72b6dd415cdaceac76616df2c9278b33079e0d3',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '945445.52',
        tvlUsd: '945445.52',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3282,
        createdAt: '2025-01-02T11:36:13.000Z',
        chainId: 146,
        dateOfAdd: '2025-01-02T11:36:13.000Z',
        beacon: '0x502e1aa8288e1b4744dea7f9adc91438a19275f9',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/USDC.E',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x25f746bb206041ed8da6f08ed1d32454a5856d37',
        poolV3Fee: 0.0015,
        apr: 0,
        tvlStaking: '905252.97',
        tvlUsd: '905252.97',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 3283,
        createdAt: '2025-01-02T11:36:13.000Z',
        chainId: 146,
        dateOfAdd: '2025-01-02T11:36:13.000Z',
        beacon: '0x446542753ef2d73ec1d9a69a03367defeb48972b',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WAGMI/ANON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8f76e0deb376d81fd75028d47de0da7af0a5547e',
        poolV3Fee: 0.003,
        apr: 0,
        tvlStaking: '1311809.15',
        tvlUsd: '1311809.15',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4654,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0x13b7417ba06767b9c882e1dbfa2b5e6a2ee06a8d',
        calculationConnector: '',
        source: '',
        origin: '0x2036d05eca7fe86cd224927883490a255ef552ba',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0xbb8ae5b889243561ac9261f22f592b72250afd1f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC.E/SCUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.003,
        tvlStaking: '18180.15',
        tvlUsd: '18180.15',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 4655,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0xa2a50ce05dae0536297b94d4b3003db9ccd7ca73',
        calculationConnector: '',
        source: '',
        origin: '0x091bd925fc66a83a2a4ecd12782a9179f199a3f1',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0xad88149c1030d7544f244958f4889b5eda49a381',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/FIERY',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0246,
        tvlStaking: '2497.90',
        tvlUsd: '2497.90',
        enabled: false,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4656,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0x465f9b4812d883a3c423fd9be6b9351ff6de661b',
        calculationConnector: '',
        source: '',
        origin: '0x2762d589c6b03c22b372d7201634a05c4052ddb4',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0x7432d8e46d1e72f7af15247b36909e3eb6319931',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/BOL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0258,
        tvlStaking: '9659.61',
        tvlUsd: '9659.61',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4657,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0xccb36462a8d3e7ef85b7be483b342fa0a493814d',
        calculationConnector: '',
        source: '',
        origin: '0x232676951d505f369b49a1e4e09954e348e7a5c2',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0x1d64b681315839c83bf545b7a041f4e5111bee39',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/FMULTI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0054,
        tvlStaking: '12509.28',
        tvlUsd: '12509.28',
        enabled: false,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4658,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0xb8d3601be9438e38331e47732e1e0c6dd412e820',
        calculationConnector: '',
        source: '',
        origin: '0xb7b6fc72cbc8e8fa67737f83e945db2795a66ef7',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0x24f5cd888057a721f1acd7cba1afa7a8384c3e12',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/TYSG',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0011,
        tvlStaking: '7440.00',
        tvlUsd: '7440.00',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4659,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0xcaf989a6d9d3dad2ef4c0a1f7aa122dab534e401',
        calculationConnector: '',
        source: '',
        origin: '0x5d671de88045626e50be05c1d438b2b9908cfa97',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0xe6aa7ca47ddb6203e71d4d1497959da51f87aa98',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/GOGLZ',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1231,
        tvlStaking: '13108.19',
        tvlUsd: '13108.19',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4660,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0x5ecb2b2ed6f491daf53af6637a783c988052f4d3',
        calculationConnector: '',
        source: '',
        origin: '0xc1e516d12be0ed0f7ccccb106e49bbe4db65341f',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0x36e0c9ee4da91101b6509586b820190015e9114f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/HEDGY',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 1.5731,
        tvlStaking: '28260.94',
        tvlUsd: '28260.94',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4661,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0xdc59406593ed13271508c208a260da53d3c56dc2',
        calculationConnector: '',
        source: '',
        origin: '0x48c3ff29daeac7afa7785a3977aab247e6761576',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0xbf23e7fc58b7094d17fe52ef8bde979aa06b8916',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/SDOG',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.0299,
        tvlStaking: '11569.76',
        tvlUsd: '11569.76',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4662,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0xb15e307fe15d164499e97e5117967d1f01e0bf18',
        calculationConnector: '',
        source: '',
        origin: '0x9ad399ecc102212b4677b0dbbc82c07ae1c74cc5',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0x8218825e5964e17d872adcefa4c72d73c0d44021',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/MOON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1281,
        tvlStaking: '9151.01',
        tvlUsd: '9151.01',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4663,
        createdAt: '2025-02-18T11:29:07.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:07.000Z',
        beacon: '0x0cffee6541eb20b693ff9cac55103b527aff4552',
        calculationConnector: '',
        source: '',
        origin: '0xc1742f8898d343b4909d29e7f1061eb2ac92e999',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0x61974f520630b11e2af36e2c92cf0c0920dd487a',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/WOOF',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.1579,
        tvlStaking: '20172.19',
        tvlUsd: '20172.19',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4664,
        createdAt: '2025-02-18T11:29:12.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:12.000Z',
        beacon: '0x8948a8699bf7a5ee9561dd7eb5aa1d8f7611095b',
        calculationConnector: '',
        source: '',
        origin: '0xa49c12d9542eb16494cf1980556f1be437acb212',
        vaultFactoryId: 76,
        rewardTokens: ['0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70'],
        rewardTokenType: '',
        stakingToken: '0x03281b6f11d943157a973cdb6b39b747501bdbba',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/ECO',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.8179,
        tvlStaking: '23142.66',
        tvlUsd: '23142.66',
        enabled: true,
        dexFactory: {
          id: 95264,
          chainId: 146,
          address: '',
          name: 'SwapX v2',
          swapFee: '',
          code: '5',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4665,
        createdAt: '2025-02-18T11:29:35.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:35.000Z',
        beacon: '0x9e9d0434f32167c8194c67bb270da65d742dc5c5',
        calculationConnector: '',
        source: '',
        origin: '0xd562c4e3f2bff3168c1128551ed7c63ae0774561',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x3333111a391cc08fa51353e9195526a70b333333',
          '0x5555b2733602ded58d47b8d3d989e631cbee5555',
        ],
        rewardTokenType: '',
        stakingToken: '0xf19748a0e269c6965a84f8c98ca8c47a064d4dd0',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/SHADOW',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.5645,
        tvlStaking: '999892.29',
        tvlUsd: '999892.29',
        enabled: true,
        dexFactory: {
          id: 95274,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v2',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4666,
        createdAt: '2025-02-18T11:29:35.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-18T11:29:35.000Z',
        beacon: '0x0d5cda136067a76240cb96b770d70e05e9ed9417',
        calculationConnector: '',
        source: '',
        origin: '0xf1c6f77c46eb9b0b3ee3fae0f70f88a07e2f2067',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x17af1df44444ab9091622e4aa66db5bb34e51ad5',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0xae8e9b2222031c464342dbfab7433b64eb5c15cf',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'WS/THC',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.5775,
        tvlStaking: '66982.77',
        tvlUsd: '66982.77',
        enabled: true,
        dexFactory: {
          id: 95274,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v2',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4673,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0x4943c0efc5b057a49dd64ef576af0bcd004c38ae',
        calculationConnector: '',
        source: '',
        origin: '0x06308c747cf7b5b5bb3b9494b2314c166f0b7fa5',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x5555b2733602ded58d47b8d3d989e631cbee5555',
          '0x29219dd400f2bf60e5a23d13be72b486d4038894',
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/STS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xde861c8fc9ab78fe00490c5a38813d26e2d09c95',
        poolV3Fee: 0.0005,
        apr: 0.07,
        tvlStaking: '1364405.63',
        tvlUsd: '1364405.63',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4674,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0xffd49f09bcd994060aaee8e589faba67df92710e',
        calculationConnector: '',
        source: '',
        origin: '0x1a95aae3e67e453f607c38c4a02c4974d0caf5ec',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x5555b2733602ded58d47b8d3d989e631cbee5555',
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'SCETH/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xc291ca0a0a0e793dc6a0442a34e1607ce1905389',
        poolV3Fee: 0.0005,
        apr: 3e-5,
        tvlStaking: '14639694.02',
        tvlUsd: '14639694.02',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: true,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 4675,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0x847cad04d4db8839997c2fca12071f9d12376a74',
        calculationConnector: '',
        source: '',
        origin: '0xf5c7598c953e49755576cda6b2b2a9daaf89a837',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb6d9b069f6b96a507243d501d1a23b3fccfc85d3',
        poolV3Fee: 0.0005,
        apr: 0.1135,
        tvlStaking: '6011589.24',
        tvlUsd: '6011589.24',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4676,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0xe0539d7e9ca3c7537b6847f59b811ab3653a190e',
        calculationConnector: '',
        source: '',
        origin: '0xe879d0e44e6873cf4ab71686055a4f6817685f02',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333111a391cc08fa51353e9195526a70b333333',
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/USDC.E',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x324963c267c354c7660ce8ca3f5f167e05649970',
        poolV3Fee: 0.0005,
        apr: 0.842,
        tvlStaking: '4150660.29',
        tvlUsd: '4150660.29',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 4677,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0x712bd9e36ade8d847d00e51b783b37389f314b5e',
        calculationConnector: '',
        source: '',
        origin: '0x8cdec539ba3d3857ec29b491c78cfb48f5d34f56',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'USDC.E/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x6fb30f3fcb864d49cdff15061ed5c6adfee40b40',
        poolV3Fee: 0.0005,
        apr: 1.1935,
        tvlStaking: '1738983.14',
        tvlUsd: '1738983.14',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 4678,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0xb6b03cc48811154e2a6e71acbd7ba2d9b4f910b1',
        calculationConnector: '',
        source: '',
        origin: '0xd4e3f873945e86e65559af9112fca3439d0a101e',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/ANON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x43b3ba354aee512ca45f0c5512440fbadf114e98',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '11507.02',
        tvlUsd: '11507.02',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 4679,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0xf182a49885958f39b79d53cd770bf5cd594defcf',
        calculationConnector: '',
        source: '',
        origin: '0xf8440c989c72751c3a36419e61b6f62dfeb7630e',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x5555b2733602ded58d47b8d3d989e631cbee5555',
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'USDC.E/SCUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x2c13383855377faf5a562f1aef47e4be7a0f12ac',
        poolV3Fee: 0.0005,
        apr: 0.0019,
        tvlStaking: '3311066.18',
        tvlUsd: '3311066.18',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 4680,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0x5da9a2b70eb653d49213537bf706d595c9cb9389',
        calculationConnector: '',
        source: '',
        origin: '0xd9f075dcc8507612cdde043e379edfa1ae69e57b',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/GOGLZ',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1f4efc47e5a5ab6539d95a76e2dde6d74462acea',
        poolV3Fee: 0.0005,
        apr: 0.1648,
        tvlStaking: '184994.30',
        tvlUsd: '184994.30',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4681,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0x904b647e809ccef35955deef92273c3b7438f799',
        calculationConnector: '',
        source: '',
        origin: '0xeaee3f2f5b9f373f12b217d9740d98ba5a95e91b',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'SHADOW/STS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x66af3655e14a045f1742b3c9544553ef7915ed35',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '131643.29',
        tvlUsd: '131643.29',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4682,
        createdAt: '2025-02-20T15:03:34.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:34.000Z',
        beacon: '0x4ea8872db33127004a5867572f55c53f2fbcc0a6',
        calculationConnector: '',
        source: '',
        origin: '0x6c36bb2b7141d70f0dd57d13ed0bb8f733aee3d0',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/BRUSH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb8bda81eccb1a21198899ac8f1f2f73c82bd7695',
        poolV3Fee: 0.0005,
        apr: 0.1569,
        tvlStaking: '192605.51',
        tvlUsd: '192605.51',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4683,
        createdAt: '2025-02-20T15:03:40.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:40.000Z',
        beacon: '0xcaf23c993591b42dea71912d0b289b353f3d0e68',
        calculationConnector: '',
        source: '',
        origin: '0x428589650e95d7125784cfae63387bb6d8962aea',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/DERP',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9abf712d326da30f77ee14840f0180b571630a32',
        poolV3Fee: 0.0005,
        apr: 0.2598,
        tvlStaking: '173200.33',
        tvlUsd: '173200.33',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4684,
        createdAt: '2025-02-20T15:03:40.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:40.000Z',
        beacon: '0x258b237e9a7306be269e1a0cd45ef79aedf03b7f',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'X33/SHADOW',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x4b478f2d431e955f11c61b319351cbfd5053f1b6',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '15051.81',
        tvlUsd: '15051.81',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4685,
        createdAt: '2025-02-20T15:03:40.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:40.000Z',
        beacon: '0x3f4384a3471b5a10e7ac034da85ba0c0ec415af5',
        calculationConnector: '',
        source: '',
        origin: '0x1cb4e4667149c86f82153769ee2f01406705f8b7',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/SGOAT',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x8d0c7fe4814afa5428c79ae6915e44738cc3a39a',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '3649.20',
        tvlUsd: '3649.20',
        enabled: false,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4686,
        createdAt: '2025-02-20T15:03:40.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-20T15:03:40.000Z',
        beacon: '0xca9b9979a56822bf5dd14082a9157a2b0c865e1e',
        calculationConnector: '',
        source: '',
        origin: '0xbf2ede70eb05e3a15d43a8d33bdf3a4156e98932',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'SACRA/SCUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x350598c4c17ddc02049e34bfdf4555422d2d670e',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '23103.53',
        tvlUsd: '23103.53',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4689,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0x4bc81984891b7b883105e6ebcb09181ae22b8356',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WS/SWPX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xbeca246a76942502f61bfe88f60bbc87dafefe80',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '461270.58',
        tvlUsd: '461270.58',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4690,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0xa027fd2002762ed12e22a0cfc68734821541822e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'USDC.E/SWPX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x467865e7ce29e7ed8f362d51fd7141117b234b44',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '455257.20',
        tvlUsd: '455257.20',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4691,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0x27438d6c137c9c802ae753d63f90a108edc8b1ed',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WETH/SWPX',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9c2a7bb01951be15fe835886188fa13255ef9486',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '153259.64',
        tvlUsd: '153259.64',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4692,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0x2c476934c11a4ce6bd403e53d084adf37578ffc8',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'SWPX/OS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x9cb484fad38d953bc79e2a39bbc93655256f0b16',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '55833.01',
        tvlUsd: '55833.01',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4693,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0x96074eff1653c63641ce0b97118ae3c5e8f3fbae',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WS/SCETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xfc64bd7c84f7dc1387d6e752679a533f22f6f1db',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '404331.16',
        tvlUsd: '404331.16',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4694,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0x2a2737d14f9766159eb37111d32f58cc3605d2a9',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WS/ANON',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xb73a4d63fa27eb0ded5305c5d4d1ce488edfe2a1',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '52776.81',
        tvlUsd: '52776.81',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4695,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0xfa6f6c0cf1e42e21fe409d02ec44a9299af46b45',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WS/USDC.E',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5c4b7d607aaf7b5cde9f09b5f03cf3b5c923aeea',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1858925.54',
        tvlUsd: '1858925.54',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 4696,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0x04323e8cddf8608189149b4592980befe2d0699e',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WS/STS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xd760791b29e7894fb827a94ca433254bb5afb653',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '10351412.59',
        tvlUsd: '10351412.59',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4697,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0xd4ee1a641bde441bf901e4ab70c792465fd7e30f',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WS/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xf58fc088c33ad46113940173cb0da3dd08c4aa88',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1012584.38',
        tvlUsd: '1012584.38',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 4698,
        createdAt: '2025-02-24T09:10:32.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:32.000Z',
        beacon: '0x55e0c91ba111469002dbf4dbf38c08a9bcf5c82c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'USDC.E/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xec4ee7d6988ab06f7a8daaf8c5fdffde6321be68',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '2279817.08',
        tvlUsd: '2279817.08',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: true,
      },
      {
        id: 4699,
        createdAt: '2025-02-24T09:10:36.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:36.000Z',
        beacon: '0xae3cb57613964b3397187adf50fa6bc720047a9c',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'USDC.E/SCUSD',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xdd35c88b1754879ef86bbf3a24f81fcca5eb6b5d',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '26661.07',
        tvlUsd: '26661.07',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: true,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 4700,
        createdAt: '2025-02-24T09:10:36.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:36.000Z',
        beacon: '0x82c9d58d83f4ce19df8ffc3a981764dfbd1c2874',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'USDC.E/STS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5ddbef774488cc68266d5f15bfb08eaa7cd513f9',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '1121460.65',
        tvlUsd: '1121460.65',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4701,
        createdAt: '2025-02-24T09:10:36.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:36.000Z',
        beacon: '0xa878fbc48fd4a22c95b4f5962fb17c6a0279705d',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WS/OS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xa76beaf111bad5dd866fa4835d66b9aa2eb1fdec',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '5777171.38',
        tvlUsd: '5777171.38',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4702,
        createdAt: '2025-02-24T09:10:36.000Z',
        chainId: 146,
        dateOfAdd: '2025-02-24T09:10:36.000Z',
        beacon: '0x1d598d8e6b14366e308151267fabec28b547539a',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0xd82fe82244ad01aad671576202f9b46b76fadfe2',
        stakingTokenType: 'ERC721-ALGEBRA',
        stakeTokenSymbol: 'WS/SACRA',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x875819746112630cee95aa78e4327cd4837da70d',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '7859.10',
        tvlUsd: '7859.10',
        enabled: true,
        dexFactory: {
          id: 95286,
          chainId: 146,
          address: '',
          name: 'SwapX v3',
          swapFee: '',
          code: '6',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4770,
        createdAt: '2025-03-11T10:43:27.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-11T10:43:27.000Z',
        beacon: '0xa609680e0c81cebad268d585d95e4a9653bce6ed',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/WETH',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xe45a270b10cfed62ba586d3f1b72b36989a623ba',
        poolV3Fee: 0.0015,
        apr: 0,
        tvlStaking: '959218.98',
        tvlUsd: '959218.98',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 4771,
        createdAt: '2025-03-11T10:43:27.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-11T10:43:27.000Z',
        beacon: '0x1d9790a2972c9f51126d47dcc93bdf9f55fcadef',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x77dcc9b09c6ae94cdc726540735682a38e18d690',
        stakingTokenType: 'ERC721-NATIVE',
        stakeTokenSymbol: 'WS/USDC.E',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x25f746bb206041ed8da6f08ed1d32454a5856d37',
        poolV3Fee: 0.0015,
        apr: 0,
        tvlStaking: '910053.41',
        tvlUsd: '910053.41',
        enabled: true,
        dexFactory: {
          id: 95198,
          chainId: 146,
          address: '',
          name: 'WAGMI',
          swapFee: '',
          code: '2',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: true,
        isVolatilePair: false,
      },
      {
        id: 4772,
        createdAt: '2025-03-11T11:22:02.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-11T11:22:02.000Z',
        beacon: '0x1d24476dcdca5ae028766c95ffb05365ab8ebd96',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'USDC.E/X33',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x3fccdda302b23f3741df05e698d1300a346d92b1',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '408997.44',
        tvlUsd: '408997.44',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 4773,
        createdAt: '2025-03-11T11:22:02.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-11T11:22:02.000Z',
        beacon: '0x268630b261303d6ad622334ca75d47b806480cf6',
        calculationConnector: '',
        source: '',
        origin: '0x8e94bea3ccd02bc173e368636f650c6340a5290b',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'SHADOW/EGGS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x1f50e4f90c02411a07474b3209182b1e0162ad1a',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '5196.08',
        tvlUsd: '5196.08',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 7827,
        createdAt: '2025-03-12T07:13:17.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-12T07:13:17.000Z',
        beacon: '0x21c24355cfde183f9c67de8294a44429143bfbea',
        calculationConnector: '',
        source: '',
        origin: '0xecda0ae9d4fbed7349bc09e7c72b3c58e527466c',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'USDC.E/SHADOW',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x779ca4e7f14d10489cd32655fc513641ba3a8d8f',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '16436.83',
        tvlUsd: '16436.83',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9403,
        createdAt: '2025-03-19T14:30:47.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-19T14:30:47.000Z',
        beacon: '0x296cf9bb360e171d0bfb15f31a23a5d966fa8ed9',
        calculationConnector: '',
        source: '',
        origin: '0x094606ca700e68e18f6a8eee2ea4419c662fd0c7',
        vaultFactoryId: 76,
        rewardTokens: [
          '0xd441a37aa73fc1ddd2db99fc4c92f233b7d41cbd',
          '0x14d1db2367312ee3bba54905b64f3bf0f0d677a8',
        ],
        rewardTokenType: '',
        stakingToken: '0x9ff1b68f8bedf4665fe358f92c3e9af386cb295f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC.E/HUBBLE',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 11961.396,
        tvlStaking: '21.35',
        tvlUsd: '21.35',
        enabled: true,
        dexFactory: {
          id: 95319,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v2(Hubble)',
          swapFee: '',
          code: '7',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 9464,
        createdAt: '2025-03-21T15:11:06.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-21T15:11:06.000Z',
        beacon: '0x22ab9f758a3eaba0f559f4e9417c2d5d91bb9b63',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/X33',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xcf0a945ed064ac32ec8d178f865f650a9f9a2fdb',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '360560.35',
        tvlUsd: '360560.35',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 9465,
        createdAt: '2025-03-21T15:11:06.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-21T15:11:06.000Z',
        beacon: '0x655eb20eac06fe29663863e4fae239742c974db9',
        calculationConnector: '',
        source: '',
        origin: '0xc0f09aa22758d83debdd4d1232ba8292a15f41c7',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/SHADOW',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x36688823ef912ca5f3c152163c3082a01f22cc67',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '587447.34',
        tvlUsd: '587447.34',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 9466,
        createdAt: '2025-03-21T15:11:06.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-21T15:11:06.000Z',
        beacon: '0x64524b0fa9ddead73d7b4d422f7c24740160b8fb',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'X33/SHADOW',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0xbb528a050a3b3b998a9651f893fa46162967a04c',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '983584.66',
        tvlUsd: '983584.66',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: false,
      },
      {
        id: 9497,
        createdAt: '2025-03-24T14:34:58.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-24T14:34:58.000Z',
        beacon: '0x90a40ae943df3c2db1c64e602fe1dd9fb9acf916',
        calculationConnector: '',
        source: '',
        origin: '0x6f2d5ebfc4ac5774e08b0250155fd519728587b7',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x31e2eed04a62b232da964a097d8c171584e3c3bd',
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/OIL',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x5c8e4d65c68e4244511f33ecef5ee34f6de5d5ba',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '38808.40',
        tvlUsd: '38808.40',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9498,
        createdAt: '2025-03-24T14:34:58.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-24T14:34:58.000Z',
        beacon: '0xec21ba5df78fa2fd9220b95fddf3c76ce9245170',
        calculationConnector: '',
        source: '',
        origin: '0x0000000000000000000000000000000000000000',
        vaultFactoryId: 76,
        rewardTokens: [],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/GEMS',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x95f808cc1e83dba7818dd728fe720b2a8088ff61',
        poolV3Fee: 0.0005,
        apr: 0,
        tvlStaking: '5466.58',
        tvlUsd: '5466.58',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9499,
        createdAt: '2025-03-24T14:34:58.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-24T14:34:58.000Z',
        beacon: '0x54c67a9359de04224455ee674f44e1e5cb16f219',
        calculationConnector: '',
        source: '',
        origin: '0xb1fbe63d275788d46e8889af7df07cd988265338',
        vaultFactoryId: 76,
        rewardTokens: [
          '0x3333b97138d4b086720b5ae8a7844b1345a33333',
          '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        ],
        rewardTokenType: '',
        stakingToken: '0x12e66c8f215ddd5d48d150c8f46ad0c6fb0f4406',
        stakingTokenType: 'ERC721-RAMSES',
        stakeTokenSymbol: 'WS/NAVI',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        poolV3: '0x28f1bb2952ae8742b9e16fd515e3d01f4be6bc30',
        poolV3Fee: 0.0005,
        apr: 0.2148,
        tvlStaking: '299074.87',
        tvlUsd: '299074.87',
        enabled: true,
        dexFactory: {
          id: 95276,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v3',
          swapFee: '',
          code: '3',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
      {
        id: 9500,
        createdAt: '2025-03-24T14:54:04.000Z',
        chainId: 146,
        dateOfAdd: '2025-03-24T14:54:04.000Z',
        beacon: '0x385e72e3d12386b9687c4a9d39c19c4b037ea0af',
        calculationConnector: '',
        source: '',
        origin: '0xcd15aec547d01e24da7368d683872692354bf704',
        vaultFactoryId: 76,
        rewardTokens: ['0x5050bc082ff4a74fb6b0b04385defddb114b2424'],
        rewardTokenType: '',
        stakingToken: '0xe8b696fb500c2a3b1faa5e0fce4d53d6ad26765f',
        stakingTokenType: 'LP',
        stakeTokenSymbol: 'USDC.E/X33',
        stakeTokenSwapFee: 0,
        riskLevel: 3,
        apr: 0.7462,
        tvlStaking: '34469.99',
        tvlUsd: '34469.99',
        enabled: true,
        dexFactory: {
          id: 95274,
          chainId: 146,
          address: '',
          name: 'ShadowSwap v2',
          swapFee: '',
          code: '4',
        },
        tags: [],
        isPoolV3PositionInRange: false,
        isStablePair: false,
        isCorrelatedPair: false,
        isEthBtcPair: false,
        isBlueChipPair: false,
        isVolatilePair: true,
      },
    ],
    profitClaimer: '0x8926ca240230763835631099f35cea526e98a3ba',
  },
] as unknown as VaultFactoryDto[];

export default vaultFactories;
